{
  "common": {
    "loading": "Φόρτωση...",
    "error": "Παρουσιάστηκε σφάλμα",
    "save": "Αποθήκευση",
    "cancel": "Ακύρωση",
    "confirm": "Επιβεβαίωση",
    "back": "Πίσω",
    "next": "Επόμενο",
    "submit": "Υποβολή",
    "search": "Αναζήτηση",
    "filter": "Φίλτρο",
    "export": "Εξαγωγή",
    "delete": "Διαγραφή",
    "edit": "Επεξεργασία",
    "view": "Προβολή",
    "close": "Κλείσιμο",
    "yes": "Ναι",
    "no": "Όχι",
    "skip": "Παράλειψη",
    "continue": "Συνέχεια",
    "print": "Εκτύπωση",
    "download": "Λήψη",
    "language": "Γλώσσα",
    "saving": "Αποθήκευση...",
    "previous": "Προηγούμενο",
    "retry": "Επανάληψη",
    "clear": "Εκκαθάριση",
    "actions": "Ενέργειες",
    "showing": "Εμφάνιση",
    "of": "από",
    "noData": "Δεν υπάρχουν δεδομένα",
    "required": "Υποχρεωτικό",
    "optional": "Προαιρετικό",
    "active": "Ενεργό",
    "inactive": "Ανενεργό",
    "viewAll": "Προβολή όλων",
    "apply": "Εφαρμογή",
    "deleting": "Διαγραφή...",
    "saved": "Αποθηκεύτηκε",
    "add": "Προσθήκη",
    "remove": "Αφαίρεση",
    "dismiss": "Κλείσιμο"
  },
  "nav": {
    "dashboard": "Πίνακας ελέγχου",
    "patients": "Ασθενείς",
    "assessments": "Αξιολογήσεις",
    "reports": "Αναφορές",
    "settings": "Ρυθμίσεις",
    "help": "Βοήθεια",
    "analytics": "Αναλυτικά",
    "clinicSettings": "Ρυθμίσεις Κλινικής",
    "auditLog": "Αρχείο Ελέγχου",
    "gdpr": "GDPR / Δεδομένα",
    "editProfile": "Επεξεργασία Προφίλ",
    "myProfile": "Το Προφίλ Μου",
    "noTitle": "(κανένας)",
    "title": "Τίτλος",
    "frontdesk": "Υποδοχή",
    "exercises": "Ασκήσεις",
    "conditions": "Παθήσεις",
    "superadmin": "SuperAdmin",
    "kpi": "Πύλη KPI",
    "referralGaps": "Κενά πηγής παραπομπής",
    "staffBoard": "Πίνακας ομάδας"
  },
  "auth": {
    "signIn": "Σύνδεση",
    "signOut": "Αποσύνδεση",
    "email": "Email",
    "password": "Κωδικός",
    "forgotPassword": "Ξεχάσατε τον κωδικό;",
    "emailPasswordRequired": "Απαιτούνται email και κωδικός",
    "appTitle": "MSK Insight",
    "appSubtitle": "Πλατφόρμα Κλινικής Υποστήριξης Αποφάσεων",
    "signInSubtitle": "Συνδεθείτε στον λογαριασμό σας",
    "emailLabel": "Διεύθυνση email",
    "emailPlaceholder": "you@clinic.com",
    "passwordPlaceholder": "Εισάγετε τον κωδικό σας",
    "signingIn": "Σύνδεση…",
    "loginFailed": "Η σύνδεση απέτυχε",
    "footer": "Τεκμηριωμένη μυοσκελετική φροντίδα · Συμμόρφωση GDPR"
  },
  "dashboard": {
    "greeting": {
      "morning": "Καλημέρα",
      "afternoon": "Καλό απόγευμα",
      "evening": "Καλό βράδυ"
    },
    "newPatient": "Νέος Ασθενής",
    "newAssessment": "Νέα Αξιολόγηση",
    "viewAllPatients": "Προβολή Όλων των Ασθενών",
    "totalPatients": "Ασθενείς",
    "thisMonth": "Αυτό τον Μήνα",
    "assessments": "αξιολογήσεις",
    "pendingReviews": "Εκκρεμή",
    "activeCare": "Ενεργή Θεραπεία",
    "allTime": "Συνολικά",
    "avgWellness": "Μέσο Ευεξίας",
    "completion": "Ολοκλήρωση",
    "assessmentsPerMonth": "Αξιολογήσεις ανά Μήνα",
    "noDataYet": "Δεν υπάρχουν δεδομένα ακόμα",
    "topConditions": "Κορυφαίες Διαγνώσεις",
    "noDiagnoses": "Δεν υπάρχουν διαγνώσεις ακόμα",
    "bodyRegionDistribution": "Κατανομή Περιοχών Σώματος",
    "noRegionData": "Δεν υπάρχουν δεδομένα περιοχών ακόμα",
    "fullAnalytics": "Πλήρη Αναλυτικά",
    "needsCompletion": "Χρειάζεται Ολοκλήρωση",
    "allCaughtUp": "Όλα ενημερωμένα! Δεν υπάρχουν αξιολογήσεις που αναμένουν ολοκλήρωση.",
    "saved": "Αποθηκεύτηκε ",
    "awaitingFrontDesk": "Αναμένει Υποδοχή",
    "frontDeskWorking": "Η Υποδοχή Εργάζεται",
    "inProgress": "Σε Εξέλιξη",
    "complete": "Ολοκληρώθηκε",
    "recentPatients": "Πρόσφατοι Ασθενείς",
    "recentAssessments": "Πρόσφατες Αξιολογήσεις",
    "noPatients": "Δεν υπάρχουν ασθενείς ακόμα",
    "addFirstPatientMsg": "Προσθέστε τον πρώτο σας ασθενή για να ξεκινήσετε.",
    "addFirstPatient": "Προσθήκη Πρώτου Ασθενούς",
    "noVisits": "Χωρίς επισκέψεις",
    "table": {
      "patient": "Ασθενής",
      "age": "Ηλικία",
      "carePhase": "Φάση Θεραπείας",
      "lastVisit": "Τελευταία Επίσκεψη",
      "clinician": "Κλινικός",
      "status": "Κατάσταση",
      "date": "Ημερομηνία"
    },
    "stable": "σταθερό",
    "onTrack": "σε πορεία",
    "last6Months": "Τελευταίοι 6 μήνες"
  },
  "patient": {
    "new": "Νέος Ασθενής",
    "search": "Αναζήτηση ασθενών",
    "firstName": "Όνομα",
    "lastName": "Επώνυμο",
    "dateOfBirth": "Ημερομηνία γέννησης",
    "phone": "Τηλέφωνο",
    "email": "Email",
    "carePhase": "Φάση θεραπείας"
  },
  "patients": {
    "title": "Ασθενείς",
    "newPatient": "+ Νέος Ασθενής",
    "searchPlaceholder": "Αναζήτηση με όνομα, MRN, τηλέφωνο...",
    "allPhases": "Όλες οι Φάσεις",
    "initial": "Αρχική",
    "activeCare": "Ενεργή Θεραπεία",
    "maintenance": "Συντήρηση",
    "wellness": "Ευεξία",
    "noFound": "Δεν βρέθηκαν ασθενείς",
    "table": {
      "name": "Όνομα",
      "mrn": "MRN",
      "dob": "Ημ. Γέννησης",
      "phone": "Τηλέφωνο",
      "carePhase": "Φάση Θεραπείας",
      "lastUpdated": "Τελευταία Ενημέρωση"
    },
    "guardian": "Κηδεμόνας",
    "total": "ασθενείς",
    "firstName": "Όνομα",
    "lastName": "Επώνυμο",
    "status": {
      "active": "Ενεργός",
      "doNotContact": "Να μην γίνει επικοινωνία"
    },
    "typeahead": {
      "loading": "Αναζήτηση…",
      "empty": "Δεν βρέθηκαν ασθενείς",
      "error": "Η αναζήτηση δεν είναι διαθέσιμη αυτή τη στιγμή",
      "lastSeen": "Τελευταία",
      "nextSeen": "Επόμενη",
      "lastAppt": "Τελ. ραντεβού:",
      "nextAppt": "Επόμ. ραντεβού:"
    },
    "loadError": {
      "title": "Δεν ήταν δυνατή η φόρτωση των ασθενών.",
      "body": "Κάτι πήγε στραβά από τη δική μας πλευρά. Δοκιμάστε ξανά σε λίγο.",
      "unavailable": "Τα δεδομένα ασθενών δεν είναι προσωρινά διαθέσιμα. Δοκιμάστε ξανά σύντομα.",
      "retry": "Επανάληψη"
    }
  },
  "patientDetail": {
    "backToPatients": "Πίσω στους ασθενείς",
    "startAssessment": "Έναρξη Αξιολόγησης",
    "patientInfo": "Πληροφορίες Ασθενούς",
    "dateOfBirth": "Ημερομηνία Γέννησης",
    "gender": "Φύλο",
    "phone": "Τηλέφωνο",
    "email": "Email",
    "language": "Γλώσσα",
    "carePhase": "Φάση Θεραπείας",
    "registered": "Εγγραφή",
    "assessments": "Αξιολογήσεις",
    "noAssessments": "Δεν υπάρχουν αξιολογήσεις ακόμα. Πατήστε \"Έναρξη Αξιολόγησης\" για να ξεκινήσετε.",
    "continueAssessment": "Συνέχεια Αξιολόγησης",
    "notFound": "Ο ασθενής δεν βρέθηκε",
    "step": "Βήμα",
    "reexam": {
      "title": "Βρέθηκε Προηγούμενη Αξιολόγηση",
      "message": "Αυτός ο ασθενής έχει προηγούμενη αξιολόγηση από {{date}}. Θα θέλατε να:",
      "startReexam": "Έναρξη Επανεξέτασης",
      "reexamDesc": "Σύγκριση με προηγούμενη αξιολόγηση. Τα υπάρχοντα ενοχλήματα προ-φορτώνονται. Μπορείτε να προσθέσετε νέα.",
      "startNew": "Νέα Αξιολόγηση",
      "newDesc": "Νέα πλήρης αξιολόγηση — διαφορετικός λόγος επίσκεψης ή νέα κλινική εικόνα."
    },
    "deleteModal": {
      "title": "Διαγραφή Ασθενούς",
      "message": "Είστε σίγουροι ότι θέλετε να διαγράψετε οριστικά τον/την {{name}} και όλες τις αξιολογήσεις; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
      "typeToConfirm": "Πληκτρολογήστε το επώνυμο του ασθενούς ({{lastName}}) για επιβεβαίωση:",
      "deleting": "Διαγραφή..."
    },
    "needsRepair": {
      "title": "Αυτή η καρτέλα ασθενούς χρειάζεται επιδιόρθωση",
      "body": "Μέρος αυτής της καρτέλας δεν μπορεί να διαβαστεί αυτή τη στιγμή. Έχει αναφερθεί και δεν έχει αλλάξει τίποτα. Μην δημιουργήσετε ξανά τον ασθενή — επικοινωνήστε με την υποστήριξη αν χρειάζεστε αυτή την καρτέλα σήμερα."
    },
    "loadFailed": "Δεν ήταν δυνατή η φόρτωση αυτού του ασθενούς."
  },
  "patientForm": {
    "editTitle": "Επεξεργασία Ασθενούς",
    "newTitle": "Νέος Ασθενής",
    "firstNameLabel": "Όνομα *",
    "lastNameLabel": "Επώνυμο *",
    "dateOfBirthLabel": "Ημερομηνία Γέννησης *",
    "genderLabel": "Φύλο",
    "selectGender": "Επιλέξτε...",
    "male": "Άνδρας",
    "female": "Γυναίκα",
    "other": "Άλλο",
    "phoneLabel": "Τηλέφωνο",
    "emailLabel": "Email",
    "languageLabel": "Γλώσσα",
    "english": "Αγγλικά",
    "greek": "Ελληνικά",
    "russian": "Ρωσικά",
    "hebrew": "Εβραϊκά",
    "carePhaseLabel": "Φάση Θεραπείας",
    "initial": "Αρχική",
    "activeCare": "Ενεργή Θεραπεία",
    "maintenance": "Συντήρηση",
    "wellness": "Ευεξία",
    "saving": "Αποθήκευση...",
    "updatePatient": "Ενημέρωση Ασθενούς",
    "createPatient": "Δημιουργία Ασθενούς",
    "guardianLabel": "Κηδεμόνας / Γονέας",
    "relationshipLabel": "Σχέση με τον Ασθενή",
    "selectRelationship": "Επιλέξτε σχέση",
    "mother": "Μητέρα",
    "father": "Πατέρας",
    "legalGuardian": "Νόμιμος Κηδεμόνας",
    "carer": "Φροντιστής",
    "minorWarning": "Ο ασθενής είναι κάτω των 18 ({{age}} {{unit}}) — Απαιτούνται στοιχεία κηδεμόνα",
    "guardianNamePlaceholder": "π.χ. Μαρία Γεωργίου",
    "dayPlaceholder": "ΗΗ",
    "monthPlaceholder": "ΜΜ",
    "yearPlaceholder": "ΕΕΕΕ",
    "errors": {
      "required": "Το όνομα, το επώνυμο και η ημερομηνία γέννησης είναι υποχρεωτικά",
      "saveFailed": "Αποτυχία αποθήκευσης ασθενούς",
      "guardianRequired": "Απαιτείται όνομα κηδεμόνα / γονέα για ασθενείς κάτω των 18",
      "genderRequired": "Το φύλο είναι υποχρεωτικό"
    },
    "contactInfo": "Στοιχεία επικοινωνίας",
    "editDescription": "Ενημερώστε τα στοιχεία του ασθενή",
    "newDescription": "Συμπληρώστε τα στοιχεία για εγγραφή νέου ασθενή",
    "personalInfo": "Προσωπικά στοιχεία",
    "preferences": "Προτιμήσεις"
  },
  "aiPaste": {
    "analyze": "Ανάλυση με AI",
    "analyzing": "Γίνεται ανάλυση...",
    "aiTruncated": "Η ανάλυση AI δεν ολοκληρώθηκε — η απάντηση της AI ξεπέρασε το διαθέσιμο όριο. Έγινε ήδη αυτόματη επανάληψη. Δοκιμάστε ξανά· για πολύ μεγάλα ιστορικά, βοηθά η επικόλληση μικρότερου τμήματος. Εναλλακτικά, χρησιμοποιήστε το καθοδηγούμενο ερωτηματολόγιο.",
    "examSkippedTitle": "{{count}} αποτελέσματα εξέτασης δεν ήταν δυνατό να αποθηκευτούν και ΔΕΝ καταχωρήθηκαν:",
    "examSkippedUnknownKey": "η δοκιμασία αυτή δεν υπάρχει στον κατάλογο δοκιμασιών",
    "examSkippedInvalidResult": "η τιμή του αποτελέσματος δεν αναγνωρίστηκε",
    "examSkippedHelp": "Όλα τα υπόλοιπα αποθηκεύτηκαν. Καταχωρήστε τα στο βήμα της εξέτασης εάν πρόκειται για πραγματικά ευρήματα.",
    "removedTitle": "{{count}} προτεινόμενα ενοχλήματα αφαιρέθηκαν από τον έλεγχο ακεραιότητας:",
    "removedExamDerived": "Αφαιρέθηκε: προέκυψε από ευρήματα εξέτασης",
    "removedNoEvidence": "Αφαιρέθηκε: χωρίς αυτολεξεί τεκμηρίωση στις σημειώσεις",
    "strippedNegatives": "Ορισμένες δηλώσεις «όχι ...» δεν είχαν τεκμηρίωση στις σημειώσεις σας και αφαιρέθηκαν. Οι αλλεργίες χωρίς δηλωμένη κατάσταση εμφανίζονται ως μη καταγεγραμμένες.",
    "deadline": "Η ανάλυση AI άργησε πολύ και διακόπηκε μετά από 150 δευτερόλεπτα. Τίποτα από αυτή την προσπάθεια δεν αποθηκεύτηκε. Δοκιμάστε ξανά ή μεταβείτε στο καθοδηγούμενο ερωτηματολόγιο.",
    "retry": "Επανάληψη",
    "clientTimeout": "Η ανάλυση AI δεν απάντησε εγκαίρως και διακόπηκε. Τίποτα από αυτή την προσπάθεια δεν εφαρμόστηκε. Δοκιμάστε ξανά ή μεταβείτε στο καθοδηγούμενο ερωτηματολόγιο."
  },
  "holistic": {
    "invalid": "Η κλινική ανάλυση AI δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "longWait": "Ακόμη σε εξέλιξη — η AI ίσως κάνει δεύτερη προσπάθεια. Μπορεί να χρειαστούν έως δύο λεπτά.",
    "takes": "Συνήθως διαρκεί λιγότερο από ένα λεπτό",
    "retry": "Δοκιμάστε ξανά",
    "notGenerated": "Η κλινική ανάλυση AI δεν έχει δημιουργηθεί για αυτή την αξιολόγηση.",
    "notGeneratedInvalid": "Η αποθηκευμένη ανάλυση AI ήταν ελλιπής και παραμερίστηκε. Δημιουργήστε την ξανά όταν είστε έτοιμοι.",
    "regenerate": "Δημιουργία ανάλυσης",
    "saveFailed": "Δεν ήταν δυνατή η αποθήκευση της ολιστικής ανάλυσης. Οι αλλαγές σας δεν αποθηκεύτηκαν — δοκιμάστε ξανά."
  },
  "aiCaller": {
    "soapInvalid": "Η σημείωση SOAP από AI δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "summaryInvalid": "Η περίληψη AI δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "secondOpinionInvalid": "Η δεύτερη γνώμη AI δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "letterInvalid": "Η επιστολή AI δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "retry": "Δοκιμάστε ξανά",
    "translationInvalid": "Η μετάφραση της αναφοράς δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής, εσφαλμένη ή όχι στη γλώσσα-στόχο. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "uploadTextInvalid": "Η περίληψη του αρχείου δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά.",
    "postureExtractInvalid": "Η εξαγωγή PostureScreen δεν ολοκληρώθηκε — η απάντηση της AI ήταν ελλιπής ή εσφαλμένη. Έγινε ήδη αυτόματη επανάληψη. Παρακαλούμε δοκιμάστε ξανά."
  },
  "assessment": {
    "new": "Νέα Αξιολόγηση",
    "resume": "Συνέχεια",
    "complete": "Ολοκληρώθηκε",
    "draft": "Πρόχειρο",
    "fullAssessment": "Πλήρης Αξιολόγηση",
    "quickScore": "Γρήγορη Βαθμολόγηση",
    "reExam": "Επανεξέταση",
    "steps": {
      "medicalHistory": "Ιατρικό Ιστορικό",
      "chiefComplaints": "Κύρια Ενοχλήματα",
      "physicalExamination": "Κλινική Εξέταση",
      "postureAnalysis": "Ανάλυση Στάσης Σώματος",
      "investigations": "Απεικονιστικές Εξετάσεις",
      "outcomeMeasures": "Δείκτες Αποτελέσματος",
      "ddxReview": "Διαφοροδιάγνωση",
      "managementPlan": "Θεραπευτικό Πλάνο",
      "reportGeneration": "Δημιουργία Αναφοράς"
    },
    "readOnly": "Αυτή η αξιολόγηση έχει οριστικοποιηθεί και είναι μόνο για ανάγνωση.",
    "completedBy": "Αυτά τα βήματα ολοκληρώθηκαν από τον/την {{name}}. Επικοινωνήστε μαζί τους για αλλαγές.",
    "completedByClinician": "Αυτά τα βήματα ολοκληρώθηκαν από τον κλινικό. Επικοινωνήστε μαζί τους για αλλαγές.",
    "bodyMap": {
      "instruction": "Πατήστε στις περιοχές του σώματος όπου ο ασθενής έχει πόνο ή συμπτώματα. Επιλέξτε μέχρι 5 περιοχές.",
      "noRegions": "Δεν έχουν επιλεγεί περιοχές",
      "regionsSelected": "{{count}} περιοχή(-ές) επιλεγμένη(-ες)",
      "startDetail": "Έναρξη Λεπτομερειών Ενοχλήματος",
      "editRegions": "Επεξεργασία περιοχών",
      "regions": "Περιοχές: "
    },
    "redFlags": {
      "title": "Ανιχνεύθηκαν Κόκκινες Σημαίες",
      "requireAction": "Οι ακόλουθες κόκκινες σημαίες απαιτούν ενέργεια κλινικού πριν τη συνέχεια.",
      "clear": "Ο έλεγχος κόκκινων σημαιών ολοκληρώθηκε. Δεν υπάρχουν ανησυχίες που απαιτούν άμεση δράση.",
      "instruction": "Απαντήστε ΝΑΙ ή ΟΧΙ σε κάθε ερώτηση ελέγχου. Ερωτούνται μία φορά για ολόκληρη την αξιολόγηση.",
      "backToComplaints": "Πίσω στα ενοχλήματα",
      "submitting": "Υποβολή...",
      "submitAndContinue": "Υποβολή Ελέγχου & Συνέχεια"
    },
    "saveAsDraft": "Αποθήκευση ως Πρόχειρο — Η Υποδοχή θα Ολοκληρώσει",
    "continueToReport": "Συνέχεια στη Δημιουργία Αναφοράς",
    "finalize": {
      "instruction": "Όταν όλες οι ενότητες είναι έτοιμες, οριστικοποιήστε την αναφορά για να την σημειώσετε ως ολοκληρωμένη.",
      "button": "Οριστικοποίηση Αναφοράς",
      "success": "Η αναφορά οριστικοποιήθηκε και είναι έτοιμη για τον ασθενή. Ανακατεύθυνση στον πίνακα ελέγχου…"
    },
    "stepComingSoon": "Βήμα {{step}} — σύντομα διαθέσιμο.",
    "loadingAssessment": "Φόρτωση αξιολόγησης…",
    "goBack": "Επιστροφή",
    "noPatient": "Δεν επιλέχθηκε ασθενής. Ξεκινήστε αξιολόγηση από το προφίλ του ασθενούς.",
    "viewPatients": "Προβολή Ασθενών",
    "finalized": "Οριστικοποιημένο",
    "navigation": {
      "previousSection": "Προηγούμενη Ενότητα",
      "continueTo": "Συνέχεια σε {{step}}",
      "nextSection": "Επόμενη Ενότητα",
      "completeAssessment": "Ολοκλήρωση Αξιολόγησης",
      "saveAndContinueTo": "Αποθήκευση & Συνέχεια σε {{step}}"
    }
  },
  "clinical": {
    "findings": "Κλινικά ευρήματα",
    "observations": "Παρατηρήσεις",
    "workingHypothesis": "Κλινική υπόθεση",
    "assessment": "Αξιολόγηση",
    "aiSuggested": "Πρόταση AI — αναμένει επιβεβαίωση κλινικού",
    "confirmedBy": "Επιβεβαιώθηκε από κλινικό",
    "redFlag": "Κόκκινη σημαία — απαιτείται άμεση προσοχή"
  },
  "medicalHistory": {
    "treatmentGoals": "Θεραπευτικοί Στόχοι",
    "pastMsk": "Προηγούμενες Μυοσκελετικές Παθήσεις",
    "medications": "Φαρμακευτική Αγωγή",
    "systemsReview": "Ανασκόπηση Συστημάτων",
    "loading": "Φόρτωση ιατρικού ιστορικού...",
    "noSurgical": "Δεν έχει καταγραφεί χειρουργικό ιστορικό.",
    "noFamily": "Δεν έχει καταγραφεί οικογενειακό ιστορικό.",
    "searchMedications": "Αναζήτηση φαρμάκων",
    "year": "Έτος",
    "selectBodyRegion": "Επιλέξτε περιοχή σώματος",
    "procedureName": "Όνομα επέμβασης",
    "allergenName": "Όνομα αλλεργιογόνου",
    "pregnancyStatus": "Κατάσταση Εγκυμοσύνης",
    "title": "Ιατρικό Ιστορικό",
    "pastMedical": "Προηγούμενο Ιατρικό Ιστορικό",
    "currentMedications": "Τρέχουσα Φαρμακευτική Αγωγή",
    "allergies": "Αλλεργίες",
    "lifestyle": "Αξιολόγηση Τρόπου Ζωής",
    "familyHistory": "Οικογενειακό Ιστορικό",
    "socialHistory": "Κοινωνικό Ιστορικό",
    "surgicalHistory": "Χειρουργικό Ιστορικό",
    "reviewOfSystems": "Ανασκόπηση Συστημάτων",
    "noConditions": "Δεν αναφέρονται παθήσεις",
    "noMedications": "Χωρίς τρέχουσα φαρμακευτική αγωγή",
    "noAllergies": "Χωρίς γνωστές αλλεργίες",
    "addCondition": "Προσθήκη Πάθησης",
    "addMedication": "Προσθήκη Φαρμάκου",
    "addAllergy": "Προσθήκη Αλλεργίας",
    "condition": "Πάθηση",
    "medication": "Φάρμακο",
    "dosage": "Δοσολογία",
    "frequency": "Συχνότητα",
    "allergen": "Αλλεργιογόνο",
    "reaction": "Αντίδραση",
    "severity": "Βαρύτητα",
    "mild": "Ήπια",
    "moderate": "Μέτρια",
    "severe": "Σοβαρή",
    "occupation": "Επάγγελμα",
    "smokingStatus": "Κατάσταση Καπνίσματος",
    "alcoholUse": "Χρήση Αλκοόλ",
    "exerciseLevel": "Επίπεδο Άσκησης",
    "never": "Ποτέ",
    "former": "Πρώην",
    "current": "Τρέχον",
    "none": "Κανένα",
    "light": "Ελαφρύ",
    "heavy": "Βαρύ",
    "sedentary": "Καθιστική ζωή",
    "active": "Ενεργό",
    "veryActive": "Πολύ Ενεργό",
    "saveAndContinue": "Αποθήκευση & Συνέχεια στα Ενοχλήματα",
    "additionalNotes": "Πρόσθετες παθήσεις ή σημειώσεις",
    "shortPastMsk": "Ιστορ. ΜΣ",
    "shortMedications": "Φάρμακα",
    "shortSurgical": "Χειρουργ.",
    "shortFamily": "Οικογ.",
    "shortSystems": "Συστήμ.",
    "shortAllergies": "Αλλεργίες",
    "shortLifestyle": "Τρόπος Ζωής",
    "birthSummary": "Σύνοψη Γέννησης",
    "mothersHealth": "Υγεία Μητέρας",
    "immunisations": "Εμβολιασμοί",
    "shortBirth": "Γέννηση",
    "shortMother": "Μητέρα",
    "shortVaccines": "Εμβόλια",
    "noCurrentMeds": "Χωρίς τρέχουσα φαρμακευτική αγωγή",
    "addFamilyCondition": "Προσθήκη οικογενειακής πάθησης",
    "noFamilyHistory": "Δεν έχει καταγραφεί οικογενειακό ιστορικό.",
    "systemsToggleDesc": "Ενεργοποιήστε κάθε σύστημα για να υποδείξετε θετικά ευρήματα, στη συνέχεια προσθέστε σημειώσεις.",
    "notesPlaceholder": "Σημειώσεις για ευρήματα {{system}}...",
    "pregnancyTitle": "Κατάσταση Εγκυμοσύνης",
    "notPregnant": "Δεν είναι έγκυος",
    "currentlyPregnant": "Σε εγκυμοσύνη",
    "possiblyPregnant": "Πιθανή εγκυμοσύνη",
    "unknown": "Άγνωστο"
  },
  "complaints": {
    "complaintReview": "Ανασκόπηση Ενοχλημάτων",
    "aiParsedBadge": "Ανάλυση AI · πατήστε για επιβεβαίωση",
    "confirmError": "Αποτυχία επιβεβαίωσης — δοκιμάστε ξανά",
    "reviewInstructions": "Ελέγξτε τα αποθηκευμένα ενοχλήματα παρακάτω. Μπορείτε να προσθέσετε άλλη περιοχή ενοχλήματος ή να συνεχίσετε στον έλεγχο κόκκινων σημαιών.",
    "loadingComplaints": "Φόρτωση ενοχλημάτων...",
    "noComplaintsSaved": "Δεν έχουν αποθηκευτεί ενοχλήματα ακόμα. Παρακαλώ προσθέστε τουλάχιστον ένα ενόχλημα.",
    "painLabel": "Πόνος: {{score}}/10",
    "addAnother": "+ Προσθήκη Νέου Ενοχλήματος",
    "maxReached": "Μέγιστος αριθμός 5 ενοχλημάτων επιτεύχθηκε",
    "editRedFlags": "Επεξεργασία Απαντήσεων Κόκκινων Σημαιών",
    "continueToRedFlags": "Συνέχεια στον Έλεγχο Κόκκινων Σημαιών →",
    "complaintsCount": "{{count}} ενόχλημα(-τα) αποθηκευμένο(-α)",
    "bodyMapInstructions": "Πατήστε στις περιοχές του σώματος όπου ο ασθενής έχει πόνο ή συμπτώματα. Επιλέξτε μέχρι 5 περιοχές.",
    "regionsSelected": "{{count}} περιοχή(-ές) επιλεγμένη(-ες)",
    "startComplaintDetail": "Έναρξη Λεπτομερειών Ενοχλήματος →",
    "editRegions": "← Επεξεργασία περιοχών",
    "title": "Κύρια Ενοχλήματα",
    "side": "Πλευρά",
    "painLevel": "Επίπεδο Πόνου (NRS)",
    "onset": "Έναρξη",
    "nature": "Φύση Πόνου",
    "aggravating": "Επιβαρυντικοί Παράγοντες",
    "relieving": "Ανακουφιστικοί Παράγοντες",
    "radiation": "Πρότυπο Ακτινοβολίας",
    "dermatome": "Δερματοτομική Κατανομή",
    "neuroSymptoms": "Νευρολογικά Συμπτώματα",
    "functionalImpact": "Λειτουργική Επίπτωση",
    "whichSide": "Σε ποια πλευρά είναι ο πόνος;",
    "left": "Αριστερά",
    "right": "Δεξιά",
    "bilateral": "Αμφοτερόπλευρα",
    "central": "Κεντρικός/Μέση γραμμή",
    "noPain": "Χωρίς πόνο",
    "worstPain": "Χειρότερος πόνος",
    "sudden": "Αιφνίδια",
    "gradual": "Σταδιακή",
    "sharp": "Οξύς",
    "dull": "Αμβλύς",
    "aching": "Πονώδης",
    "burning": "Καυστικός",
    "shooting": "Αστραπιαίος",
    "throbbing": "Σφυγμώδης",
    "stabbing": "Μαχαιρωτός",
    "doesRadiate": "Ακτινοβολεί ο πόνος;",
    "whereRadiate": "Πού ακριβώς ακτινοβολεί;",
    "region": "Περιοχή",
    "question": "Ερώτηση",
    "newComplaint": "ΝΕΟ",
    "newComplaintNote": "Αυτό είναι νέο ενόχλημα (δεν υπήρχε σε προηγούμενη αξιολόγηση)",
    "noRegionsSelected": "Δεν έχουν επιλεγεί περιοχές σώματος",
    "loadingComplaint": "Φόρτωση δεδομένων ενοχλήματος...",
    "saveAndContinue": "Αποθήκευση & Συνέχεια στις Κόκκινες Σημαίες",
    "chronicity": "Πόσο καιρό έχετε αυτό το ενόχλημα;",
    "haLocation": "Πού εντοπίζεται ο πονοκέφαλός σας;",
    "haCharacter": "Πώς θα περιγράφατε τον πονοκέφαλο;",
    "haDuration": "Πόσο διαρκεί κάθε επεισόδιο;",
    "haFrequency": "Πόσο συχνά έχετε πονοκεφάλους;",
    "haAssociated": "Αντιμετωπίζετε κάτι από αυτά με τον πονοκέφαλό σας;",
    "haTriggers": "Τι προκαλεί ή επιδεινώνει τον πονοκέφαλό σας;",
    "haRelief": "Τι ανακουφίζει τον πονοκέφαλό σας;",
    "redFlagScreening": "Έλεγχος Κόκκινων Σημαιών",
    "dzType": "Πώς θα περιγράφατε τη ζάλη σας;",
    "dzTiming": "Πόσο διαρκεί κάθε επεισόδιο;",
    "dzPosition": "Επηρεάζεται η ζάλη σας από τη θέση του σώματος;",
    "dzAssociated": "Αντιμετωπίζετε κάτι από αυτά με τη ζάλη σας;",
    "dzTriggers": "Τι προκαλεί τη ζάλη σας;",
    "paedReporter": "Ποιος αναφέρει τα συμπτώματα;",
    "paedDailyImpact": "Επίπτωση στις καθημερινές δραστηριότητες",
    "paedRecentHistory": "Πρόσφατο ιστορικό",
    "paedDevelopmental": "Αναπτυξιακές σκέψεις",
    "paedFamilyHistory": "Οικογενειακό ιστορικό (παιδιατρικό)",
    "selectDuration": "Επιλέξτε τη διάρκεια των συμπτωμάτων",
    "noDestinations": "Δεν υπάρχουν συγκεκριμένοι προορισμοί για αυτήν την περιοχή.",
    "selectDermatome": "Επιλέξτε τη δερματοτομική κατανομή (εάν είναι αναγνωρίσιμη):",
    "selectAllApply": "Επιλέξτε όλα όσα ισχύουν",
    "selectAllApplyMultiType": "Επιλέξτε όλα όσα ισχύουν — οι ασθενείς μπορεί να βιώνουν περισσότερους από έναν τύπο",
    "selectAllApplyDuration": "Επιλέξτε όλα όσα ισχύουν — τα επεισόδια μπορεί να διαφέρουν σε διάρκεια",
    "selectTypicalDuration": "Επιλέξτε τη συνηθισμένη διάρκεια κάθε επεισοδίου",
    "selectTypicalFrequency": "Επιλέξτε τη συνηθισμένη συχνότητα",
    "redFlagInstructions": "Απαντήστε ΝΑΙ ή ΟΧΙ σε κάθε ερώτηση. Οποιαδήποτε απάντηση «ναι» μπορεί να υποδεικνύει ανάγκη επείγουσας παραπομπής.",
    "clinicalNote": "Κλινική Σημείωση",
    "paedReporterHint": "Ποιος αναφέρει τα συμπτώματα;",
    "paedDailyImpactHint": "Πώς επηρεάζει ο πόνος τις καθημερινές δραστηριότητες του παιδιού σας; Επιλέξτε όλα όσα ισχύουν.",
    "paedRecentHistoryHint": "Πρόσφατες αλλαγές; Επιλέξτε όλα όσα ισχύουν.",
    "paedDevelopmentalHint": "Αναπτυξιακές σκέψεις; Επιλέξτε όλα όσα ισχύουν.",
    "paedFamilyHistoryHint": "Σχετικό οικογενειακό ιστορικό; Επιλέξτε όλα όσα ισχύουν.",
    "centralMidline": "Κεντρικά/Μέση γραμμή",
    "centralFrontal": "Κεντρικά/Μετωπιαία",
    "occipital": "Ινιακά",
    "onsetTraumatic": "Τραυματική",
    "onsetInsidious": "Ύπουλη",
    "onsetPostSurgical": "Μετεγχειρητική",
    "onsetRepetitiveStrain": "Επαναλαμβανόμενη καταπόνηση",
    "onsetUnknown": "Άγνωστη",
    "chronicityAcute": "Λιγότερο από 2 εβδομάδες (οξεία)",
    "chronicitySubacute": "2–6 εβδομάδες (υποξεία)",
    "chronicityChronic": "6–12 εβδομάδες (χρόνια)",
    "chronicityChronicLong": "Περισσότερο από 12 εβδομάδες (χρόνια)",
    "cramping": "Κράμπα",
    "tingling": "Μυρμήγκιασμα",
    "numbness": "Μούδιασμα",
    "radiationNone": "Καμία",
    "radiationArm": "Προς το χέρι",
    "radiationLeg": "Προς το πόδι",
    "radiationBack": "Κατά μήκος της πλάτης",
    "radiationShoulder": "Προς τον ώμο",
    "radiationHand": "Προς το χέρι/δάχτυλα",
    "radiationFoot": "Προς το πόδι/δάχτυλα",
    "radiationChest": "Γύρω από το στήθος",
    "radiationGroin": "Προς τη βουβωνική χώρα",
    "radiationButtock": "Προς τον γλουτό",
    "neuroWeakness": "Αδυναμία",
    "neuroBalance": "Απώλεια ισορροπίας",
    "neuroCoordination": "Απώλεια συντονισμού",
    "neuroAlteredSensation": "Αλλοιωμένη αίσθηση",
    "impactUnableWork": "Αδυναμία εργασίας",
    "impactReducedWork": "Μειωμένη ικανότητα εργασίας",
    "impactSleeping": "Δυσκολία στον ύπνο",
    "impactDaily": "Δυσκολία στις καθημερινές δραστηριότητες",
    "impactSelfCare": "Δυσκολία στην αυτοφροντίδα",
    "impactExercise": "Αδυναμία άσκησης",
    "impactMobility": "Μειωμένη κινητικότητα",
    "impactSocial": "Κοινωνική απόσυρση",
    "impactMood": "Επηρεασμός διάθεσης",
    "impactNone": "Καμία σημαντική",
    "haLocOneSame": "Μία πλευρά μόνο (πάντα ίδια πλευρά)",
    "haLocOneAlt": "Μία πλευρά (εναλλασσόμενες πλευρές)",
    "haLocBoth": "Και οι δύο πλευρές / παντού",
    "haLocBack": "Πίσω μέρος κεφαλής / βάση κρανίου",
    "haLocForehead": "Μέτωπο / πίσω από τα μάτια",
    "haLocTemple": "Κροταφική περιοχή",
    "haLocTop": "Κορυφή κεφαλής",
    "haCharThrobbing": "Σφυγμώδης / παλμικός",
    "haCharPressing": "Πιεστικός / σφιγκτικός (σαν ζώνη)",
    "haCharSharp": "Οξύς / μαχαιρωτός",
    "haCharDull": "Αμβλύς / πονώδης",
    "haDurSeconds": "Δευτερόλεπτα έως λεπτά",
    "haDur30min": "30 λεπτά έως 4 ώρες",
    "haDur4h": "4 έως 72 ώρες",
    "haDurConstant": "Συνεχής / πάντα παρών",
    "haDurVariable": "Μεταβλητός",
    "haFreqDaily": "Καθημερινά ή σχεδόν καθημερινά",
    "haFreqSeveral": "Αρκετές φορές την εβδομάδα",
    "haFreqWeekly": "Εβδομαδιαία",
    "haFreqMonthly": "Μηνιαία ή λιγότερο",
    "haFreqEpisodic": "Επεισοδιακά / πηγαινοέρχεται",
    "startFromTemplate": "Έναρξη από Πρότυπο",
    "hideMap": "Απόκρυψη χάρτη πόνου",
    "markLocation": "Σημειώστε ακριβή τοποθεσία πόνου (προαιρετικό)"
  },
  "physicalExam": {
    "primaryTests": "Πρωτεύουσες Δοκιμασίες",
    "secondaryTests": "Δευτερεύουσες Δοκιμασίες",
    "romSpecialized": "ROM / Εξειδικευμένες",
    "notTested": "Δεν Εξετάστηκε",
    "left": "Αριστερά",
    "right": "Δεξιά",
    "bilateral": "Αμφοτερόπλευρα",
    "normal": "Φυσιολογικό",
    "restricted": "Περιορισμένο",
    "painful": "Επώδυνο",
    "hypermobile": "Υπερκινητικό",
    "noAbnormalities": "Δεν Βρέθηκαν Ανωμαλίες",
    "noSpinalDysfunction": "Δεν Βρέθηκε Σπονδυλική Δυσλειτουργία",
    "collapse": "Σύμπτυξη",
    "expand": "Ανάπτυξη",
    "hideNotes": "Απόκρυψη σημειώσεων",
    "clinicalNotes": "Κλινικές σημειώσεις...",
    "searchTests": "Αναζήτηση δοκιμασιών κατά όνομα...",
    "all": "Όλες",
    "title": "Φυσική Εξέταση",
    "selectTests": "Επιλογή Δοκιμασιών προς Εκτέλεση",
    "recommended": "Συνιστάται",
    "performed": "Εκτελέστηκε",
    "notPerformed": "Δεν Εκτελέστηκε",
    "positive": "Θετικό",
    "negative": "Αρνητικό",
    "inconclusive": "Ακαθόριστο",
    "notes": "Σημειώσεις",
    "addNotes": "Προσθήκη σημειώσεων...",
    "testResult": "Αποτέλεσμα Δοκιμασίας",
    "saveResults": "Αποθήκευση Αποτελεσμάτων",
    "noTestsSelected": "Δεν επιλέχθηκαν δοκιμασίες",
    "selectRegion": "Επιλέξτε περιοχή σώματος για να δείτε τις διαθέσιμες δοκιμασίες",
    "allTests": "Όλες οι Δοκιμασίες",
    "essentialTests": "Βασικές Δοκιμασίες",
    "recommendedTests": "Συνιστώμενες Δοκιμασίες",
    "differentialTests": "Δοκιμασίες Διαφορικής Διάγνωσης",
    "additionalTests": "Πρόσθετες Δοκιμασίες",
    "clinicalGuide": "Οδηγός Κλινικής Αξιολόγησης",
    "patternMatch": "Ταίριασμα Προτύπου",
    "match": "ταίριασμα",
    "basedOnPresentation": "Βάσει ανάλυσης κλινικής εικόνας",
    "showProcedureDetails": "Εμφάνιση λεπτομερειών διαδικασίας",
    "essentialDesc": "Πρέπει να εκτελεστεί — κρίσιμη για αποκλεισμό/επιβεβαίωση πρωτευουσών διαγνώσεων",
    "recommendedDesc": "Συνιστάται — ενισχύει την κλινική σκέψη",
    "additionalDesc": "Αν ενδείκνυται — βάσει πολυπλοκότητας παρουσίασης"
  },
  "posture": {
    "manualAssessment": "Χειροκίνητη Αξιολόγηση",
    "cameraAssessment": "Αξιολόγηση Κάμερας",
    "shoulderROM": "Εύρος Κίνησης Ώμου",
    "advancedMeasurements": "Προχωρημένες Μετρήσεις (14 μετρικές)",
    "removeImage": "Αφαίρεση εικόνας",
    "cameraDataPopulated": "Δεδομένα κάμερας συμπληρώθηκαν"
  },
  "investigations": {
    "title": "Εξετάσεις",
    "description": "Ανεβάστε απεικονιστικές εξετάσεις (Ακτινογραφία, MRI, CT) ή/και εισάγετε εργαστηριακά αποτελέσματα. Και τα δύο τμήματα είναι προαιρετικά.",
    "skipAll": "Παράλειψη Όλων",
    "imaging": "Απεικόνιση (Ακτινογραφία, MRI, CT, Υπέρηχος)",
    "labTests": "Εργαστηριακές Εξετάσεις (Αιματολογικές, Δείκτες)"
  },
  "improvement": {
    "previous": "Προηγούμενο",
    "current": "Τρέχον",
    "noData": "Χωρίς Δεδομένα",
    "significantImprovement": "Σημαντική Βελτίωση",
    "moderateImprovement": "Μέτρια Βελτίωση",
    "declining": "Επιδείνωση",
    "stable": "Σταθερό",
    "mcidMet": "MCID ✓",
    "loading": "Φόρτωση αναφοράς βελτίωσης...",
    "noComparisonData": "Δεν υπάρχουν διαθέσιμα δεδομένα σύγκρισης.",
    "reportTitle": "Αναφορά Βελτίωσης Επανεξέτασης",
    "comparisonSubtitle": "Σύγκριση με προηγούμενη αξιολόγηση",
    "printReport": "Εκτύπωση Αναφοράς",
    "painSeverityChanges": "Αλλαγές Σοβαρότητας Πόνου",
    "outcomeMeasureChanges": "Αλλαγές Μετρήσεων Αποτελεσμάτων",
    "clinicallySignificantChanges": "Κλινικά Σημαντικές Αλλαγές",
    "wellnessScore": "Βαθμολογία Σωματικής Απόδοσης",
    "mcidExplanation": "MCID = Ελάχιστη Κλινικά Σημαντική Διαφορά. Αλλαγές που πληρούν ή υπερβαίνουν το MCID θεωρούνται κλινικά σημαντικές.",
    "loadError": "Αποτυχία φόρτωσης δεδομένων σύγκρισης",
    "descNoMeasures": "Δεν υπάρχουν διαθέσιμες μετρήσεις για σύγκριση.",
    "descImproved": "{{improved}} από {{total}} μετρήσεις βελτιώθηκαν.",
    "descModerate": "{{improved}} από {{total}} μετρήσεις βελτιώθηκαν, {{worsened}} επιδεινώθηκαν.",
    "descDeclining": "{{worsened}} από {{total}} μετρήσεις επιδεινώθηκαν. Εξετάστε τροποποίηση του σχεδίου.",
    "descMixed": "Μικτά αποτελέσματα: {{improved}} βελτιωμένα, {{worsened}} επιδεινωμένα, {{unchanged}} αμετάβλητα."
  },
  "reexam": {
    "improved": "Βελτιωμένο",
    "worsened": "Επιδεινωμένο",
    "noChange": "Χωρίς Αλλαγή",
    "noMeasures": "Δεν υπάρχουν μετρήσεις αποτελεσμάτων."
  },
  "paediatricReEvalReport": {
    "title": "Αναφορά Προόδου του Παιδιού σας",
    "yearsOld": "{{age}} ετών",
    "reEvalFollowup": "Επανεκτίμηση — Επόμενο Ραντεβού",
    "dearParents": "Αγαπητοί Γονείς,",
    "introText": "Σας ευχαριστούμε που φέρατε ξανά τον/την {{name}} για την επόμενη επίσκεψη. Με χαρά μοιραζόμαστε την πρόοδό του/της και τα επόμενα βήματα της φροντίδας.",
    "howChildIsDoing": "Πώς Τα Πάει ο/η {{name}}",
    "lastVisit": "Τελευταία Επίσκεψη",
    "today": "Σήμερα",
    "improvement": "Βελτίωση",
    "painImprovementMessage": "Αυτό είναι βελτίωση {{pct}}%! Εξαιρετική πρόοδος.",
    "greatNews": "Καλά νέα!",
    "improvingMessage": "Χαιρόμαστε που ο/η {{name}} αισθάνεται καλύτερα.",
    "muchBetterNote": "Η σημαντική βελτίωση δείχνει ότι το σώμα του/της ανταποκρίνεται πολύ καλά στη φροντίδα.",
    "worseMessage": "Κατανοούμε ότι αυτό μπορεί να είναι ανησυχητικό. Η πρόοδος δεν είναι πάντα γραμμική, ειδικά στα παιδιά. Θα σας εξηγήσουμε τα σημερινά ευρήματα και πώς προσαρμόζουμε το πλάνο για να βοηθήσουμε τον/την {{name}}.",
    "noChangeMessage": "Αν και τα συμπτώματα δεν έχουν αλλάξει ακόμη σημαντικά, αυτό είναι συχνό στα πρώιμα στάδια της φροντίδας. Παρακολουθούμε προσεκτικά την πρόοδο του/της {{name}} και προσαρμόζουμε το πλάνο ανάλογα.",
    "developmentalProgress": "Αναπτυξιακή Πρόοδος",
    "whatWeFoundToday": "Τι Βρήκαμε Σήμερα",
    "whatWeFoundIntro": "Ακολουθεί μια περίληψη των τρεχουσών παθήσεων του/της {{name}} και της πορείας τους:",
    "statusImproving": "Βελτιώνεται",
    "statusStable": "Σταθερό",
    "statusNeedsAttention": "Χρειάζεται Προσοχή",
    "statusUnderReview": "Υπό Αξιολόγηση",
    "monitoring": "Παρακολουθούμε αυτή την κατάσταση ως μέρος του πλάνου φροντίδας του/της {{name}}.",
    "noConditionsConfirmed": "Δεν έχουν επιβεβαιωθεί συγκεκριμένες παθήσεις αυτή τη στιγμή.",
    "updatedTreatmentPlan": "Ενημερωμένο Θεραπευτικό Πλάνο του/της {{name}}",
    "updatedPlanIntro": "Βάσει των σημερινών ευρημάτων, παρακάτω είναι το ενημερωμένο πλάνο φροντίδας του/της {{name}}:",
    "whatYouCanDoAtHome": "Τι Μπορείτε Να Κάνετε Στο Σπίτι",
    "infantTitle": "Συμβουλές για Βρέφη (0-1 έτους)",
    "infantTummyTime": "Χρόνος μπρούμυτα:",
    "infantTummyTimeText": "3-5 λεπτά, αρκετές φορές την ημέρα, αυξάνοντας σταδιακά",
    "infantFeeding": "Σίτιση:",
    "infantFeedingText": "Εναλλάσσετε πλευρές κατά τη σίτιση για συμμετρική κίνηση",
    "infantCarrying": "Κράτημα:",
    "infantCarryingText": "Εναλλάσσετε θέσεις κρατήματος — στο ισχίο, μπροστά, υποστηριζόμενο κάθισμα",
    "infantSleep": "Ύπνος:",
    "infantSleepText": "Στον ύπνο ανάσκελα, εναλλάξτε τη θέση του κεφαλιού σε κάθε ύπνο",
    "infantPlay": "Παιχνίδι:",
    "infantPlayText": "Χρησιμοποιήστε παιχνίδια για να ενθαρρύνετε κίνηση προς και τις δύο πλευρές",
    "toddlerTitle": "Συμβουλές για Νήπια (1-3 ετών)",
    "toddlerMovement": "Κίνηση:",
    "toddlerMovementText": "Ενθαρρύνετε σκαρφάλωμα, μπουσούλημα σε τούνελ και ασκήσεις ισορροπίας",
    "toddlerShoes": "Παπούτσια:",
    "toddlerShoesText": "Επιλέξτε ευέλικτα, υποστηρικτικά παπούτσια — ξυπόλητοι στο σπίτι όταν είναι ασφαλές",
    "toddlerWalking": "Πρότυπα βάδισης:",
    "toddlerWalkingText": "Μικρό βάδισμα στις μύτες ή προς τα μέσα είναι συχνά φυσιολογικό σε αυτή την ηλικία",
    "toddlerActivities": "Δραστηριότητες:",
    "toddlerActivitiesText": "Χορός, παιχνίδι με μαλακή μπάλα και ήπιο πήδημα βοηθούν τον συντονισμό",
    "childTitle": "Συμβουλές για Παιδιά (3-12 ετών)",
    "childSport": "Αθλητισμός & δραστηριότητα:",
    "childSportText": "Ενθαρρύνετε 60 λεπτά σωματικής δραστηριότητας καθημερινά — η ποικιλία είναι η καλύτερη",
    "childBackpack": "Σακίδιο:",
    "childBackpackText": "Δεν πρέπει να ζυγίζει πάνω από 10-15% του βάρους του παιδιού, να χρησιμοποιούνται και οι δύο τιράντες",
    "childScreen": "Στάση σώματος στην οθόνη:",
    "childScreenText": "Μάτια στο ύψος της οθόνης, πέλματα επίπεδα, διαλείμματα κάθε 20-30 λεπτά",
    "childFun": "Διασκεδαστικές ασκήσεις:",
    "childFunText": "«Βάδιση ζώων» (αρκούδα, καβούρι), «στάσεις υπερήρωα» και άγγελοι στον τοίχο",
    "childRest": "Ξεκούραση vs δραστηριότητα:",
    "childRestText": "Αν ο πόνος είναι ήπιος, η ήπια δραστηριότητα συνήθως βοηθά περισσότερο από την πλήρη ανάπαυση",
    "adolescentTitle": "Συμβουλές για Εφήβους (12-18 ετών)",
    "adolescentSport": "Ειδικά για το άθλημα:",
    "adolescentSportText": "Σωστή προθέρμανση, μην παίζετε παρά τον σημαντικό πόνο",
    "adolescentGrowth": "Αναπτυξιακές εξάρσεις:",
    "adolescentGrowthText": "Επιπλέον διατάσεις κατά τις περιόδους ανάπτυξης βοηθούν να αποφευχθεί η σφιξία",
    "adolescentStudy": "Στάση στο διάβασμα/παιχνίδι:",
    "adolescentStudyText": "Ρυθμίστε τον χώρο εργασίας στο σωστό ύψος, κάνετε τακτικά διαλείμματα",
    "adolescentStrength": "Ενδυνάμωση:",
    "adolescentStrengthText": "Ασκήσεις με το βάρος του σώματος (σανίδες, καθίσματα, βήματα) χτίζουν γερές βάσεις",
    "adolescentReturn": "Πότε να επιστρέψετε:",
    "adolescentReturnText": "Επικοινωνήστε μαζί μας αν ο πόνος επιδεινωθεί, μετακινηθεί σε νέα περιοχή ή επηρεάσει τις καθημερινές δραστηριότητες",
    "specificHomeAdvice": "Συγκεκριμένες Οδηγίες Φροντίδας στο Σπίτι:",
    "do": "Κάνετε:",
    "avoid": "Αποφεύγετε:",
    "recommendedExercises": "Συνιστώμενες Ασκήσεις:",
    "whenToContactUs": "Πότε να Επικοινωνήσετε Μαζί Μας",
    "contactImmediatelyIf": "Επικοινωνήστε άμεσα εάν:",
    "contactImmediate1": "ο/η {{name}} εμφανίσει πυρετό με πόνο στις αρθρώσεις",
    "contactImmediate2": "ο/η {{name}} αρνείται να χρησιμοποιήσει ένα άκρο ή να φορτώσει βάρος",
    "contactImmediate3": "Έντονος πόνος που χειροτερεύει παρά την ανάπαυση",
    "contactImmediate4": "Παρατηρείτε νέο οίδημα, ερυθρότητα ή θερμότητα γύρω από άρθρωση",
    "contactImmediate5": "Ξαφνική αλλαγή στον τρόπο που ο/η {{name}} περπατά ή κινείται",
    "bookSoonerIf": "Κλείστε νωρίτερο ραντεβού εάν:",
    "bookSooner1": "Ο πόνος δεν βελτιώνεται μετά από 2 εβδομάδες",
    "bookSooner2": "Εμφανιστούν νέα συμπτώματα",
    "bookSooner3": "Έχετε οποιαδήποτε ανησυχία για την πρόοδο του/της {{name}}",
    "otherwiseSeeAgain": "Διαφορετικά, θα δούμε ξανά τον/την {{name}} σύμφωνα με το πλάνο θεραπείας παραπάνω.",
    "noteForParents": "Σημείωμα για τους Γονείς",
    "parentsNote1": "Κατανοούμε ότι το να βλέπετε το παιδί σας με πόνο μπορεί να είναι ανησυχητικό. Σας διαβεβαιώνουμε ότι η κατάσταση του/της {{name}} είναι συχνή, αντιμετωπίσιμη και ανταποκρίνεται στη φροντίδα. Τα παιδιά είναι ιδιαίτερα ανθεκτικά και με τη σωστή υποστήριξη οι περισσότερες μυοσκελετικές παθήσεις στην παιδική ηλικία εξελίσσονται θετικά. Είμαστε εδώ για να καθοδηγήσουμε εσάς και τον/την {{name}} σε αυτή τη διαδρομή.",
    "growingPainsTitle": "Σχετικά με τους πόνους ανάπτυξης:",
    "growingPainsNote": "Οι πόνοι ανάπτυξης είναι φυσιολογικό μέρος της παιδικής ηλικίας και ΔΕΝ υποδεικνύουν κάτι παθολογικό στα οστά ή τις αρθρώσεις. Είναι προσωρινοί και θα υποχωρήσουν καθώς το παιδί μεγαλώνει. Ένα ζεστό μπάνιο πριν τον ύπνο και απαλό μασάζ της περιοχής βοηθούν.",
    "parentsNote2": "Αν έχετε ερωτήσεις μεταξύ των ραντεβού, μη διστάσετε να επικοινωνήσετε μαζί μας. Καμία ερώτηση δεν είναι πολύ μικρή όταν πρόκειται για την υγεία του παιδιού σας.",
    "nextSteps": "Επόμενα Βήματα",
    "readyToBook": "Έτοιμοι να κλείσετε το επόμενο ραντεβού του/της {{name}};",
    "scanToBook": "Σαρώστε για κράτηση",
    "referralTitle": "Γνωρίζετε άλλη οικογένεια που θα μπορούσαμε να βοηθήσουμε;",
    "referralText": "Θα χαρούμε να βοηθήσουμε την οικογένεια και τους φίλους σας. Αν γνωρίζετε κάποιο παιδί που θα ωφελείτο από τη φροντίδα μας, θα ήταν τιμή μας να τους υποδεχτούμε.",
    "disclaimer": "Η αναφορά αυτή προορίζεται για τους γονείς/κηδεμόνες του ασθενούς και έχει ενημερωτικό χαρακτήρα. Δεν υποκαθιστά την ιατρική συμβουλή. Αν έχετε ανησυχίες για την υγεία του παιδιού σας, επικοινωνήστε με τον γιατρό σας.",
    "reliefCare": "Φροντίδα Ανακούφισης",
    "rehabilitation": "Αποκατάσταση",
    "wellnessCare": "Φροντίδα Ευεξίας"
  },
  "paediatricProgress": {
    "loading": "Φόρτωση δεδομένων προόδου...",
    "title": "Πρόοδος από την Τελευταία Επίσκεψη",
    "painLevels": "Επίπεδα Πόνου",
    "improving": "Βελτιώνεται",
    "worsening": "Επιδεινώνεται",
    "stable": "Σταθερό",
    "resolved": "Επιλύθηκε",
    "new": "Νέο",
    "errorLoad": "Δεν ήταν δυνατή η φόρτωση δεδομένων προόδου",
    "retry": "Επανάληψη",
    "empty": "Δεν υπάρχουν δεδομένα προηγούμενης επίσκεψης για σύγκριση",
    "parentConcernChanges": "Αλλαγές στις Ανησυχίες των Γονέων",
    "ongoing": "Σε εξέλιξη",
    "treatmentResponseTitle": "Ανταπόκριση στη Θεραπεία (Αναφορά Γονέα)",
    "developmentalMilestonesTitle": "Επιτεύγματα Αναπτυξιακά Ορόσημα",
    "exerciseCompliance": "Συμμόρφωση Ασκήσεων",
    "outcomeMeasures": "Μετρήσεις Αποτελεσμάτων",
    "wellnessScore": "Βαθμολογία Σωματικής Απόδοσης"
  },
  "paediatricReEval": {
    "title": "Ερωτηματολόγιο Γονέα / Κηδεμόνα",
    "subtitle": "Παρακαλούμε απαντήστε στις παρακάτω ερωτήσεις σχετικά με την πρόοδο του παιδιού σας από την τελευταία επίσκεψη.",
    "loading": "Φόρτωση ερωτηματολογίου…",
    "errorLoad": "Δεν ήταν δυνατή η φόρτωση του ερωτηματολογίου. Παρακαλώ δοκιμάστε ξανά.",
    "empty": "Δεν υπάρχουν προηγούμενα δεδομένα — ξεκινήστε απαντώντας στις ερωτήσεις παρακάτω.",
    "retry": "Επανάληψη",
    "savedDraft": "Οι απαντήσεις αποθηκεύτηκαν",
    "saveError": "Δεν ήταν δυνατή η αποθήκευση. Παρακαλώ δοκιμάστε ξανά.",
    "completed": "Το ερωτηματολόγιο ολοκληρώθηκε — σας ευχαριστούμε!",
    "sectionParentConcerns": "Ανησυχίες Γονέα",
    "sectionDevelopment": "Ανάπτυξη",
    "sectionTreatmentResponse": "Ανταπόκριση στη Θεραπεία",
    "devBanner": "Έλεγχος Αναπτυξιακής Προόδου — αυτές οι ερωτήσεις μας βοηθούν να παρακολουθούμε τα αναπτυξιακά ορόσημα του παιδιού σας.",
    "continue": "Συνέχεια →",
    "back": "← Πίσω",
    "complete": "✓ Ολοκλήρωση Ερωτηματολογίου & Συνέχεια",
    "noPain": "Χωρίς πόνο",
    "worstPain": "Χειρότερος πόνος",
    "q1": {
      "title": "Ε1: Πώς είναι το παιδί σας από την τελευταία επίσκεψη;",
      "options": {
        "Much better": "Πολύ καλύτερα",
        "Slightly better": "Λίγο καλύτερα",
        "No change": "Καμία αλλαγή",
        "Slightly worse": "Λίγο χειρότερα",
        "Much worse": "Πολύ χειρότερα"
      }
    },
    "q2": {
      "title": "Ε2: Ποιες είναι οι κύριες ανησυχίες σας σήμερα;",
      "options": {
        "Pain is still present": "Ο πόνος υπάρχει ακόμη",
        "Pain has moved to a different area": "Ο πόνος μετακινήθηκε σε άλλη περιοχή",
        "New symptoms have appeared": "Εμφανίστηκαν νέα συμπτώματα",
        "Child is not improving as expected": "Το παιδί δεν βελτιώνεται όπως αναμενόταν",
        "Child is avoiding activities": "Το παιδί αποφεύγει δραστηριότητες",
        "Sleep is still disturbed": "Ο ύπνος εξακολουθεί να είναι διαταραγμένος",
        "Concerned about posture": "Ανησυχία για τη στάση σώματος",
        "Concerned about development": "Ανησυχία για την ανάπτυξη",
        "Limping or favouring one side": "Κουτσαίνει ή προτιμά τη μία πλευρά",
        "School/sports participation affected": "Επηρεάζεται η συμμετοχή σε σχολείο/αθλήματα",
        "No concerns — here for routine check": "Καμία ανησυχία — για έλεγχο ρουτίνας"
      }
    },
    "q3": {
      "title": "Ε3: Έχει αλλάξει κάτι από την τελευταία επίσκεψη;",
      "options": {
        "Started a new sport or activity": "Ξεκίνησε νέο άθλημα ή δραστηριότητα",
        "Had a fall or injury": "Είχε πτώση ή τραυματισμό",
        "Been unwell (illness, fever)": "Ήταν άρρωστο (ασθένεια, πυρετός)",
        "Growth spurt noticed": "Παρατηρήθηκε αναπτυξιακή έξαρση",
        "Started or stopped medication": "Ξεκίνησε ή σταμάτησε φαρμακευτική αγωγή",
        "Changed shoes or school bag": "Αλλαγή παπουτσιών ή σχολικής τσάντας",
        "Nothing has changed": "Τίποτα δεν έχει αλλάξει"
      }
    },
    "q4": {
      "title": "Ε4: Πώς αντιμετωπίζει το παιδί σας συναισθηματικά;",
      "options": {
        "Happy and active as usual": "Χαρούμενο και δραστήριο όπως συνήθως",
        "A bit frustrated by the limitation": "Λίγο απογοητευμένο από τον περιορισμό",
        "Anxious about the condition": "Ανήσυχο για την κατάσταση",
        "Withdrawn or less active than usual": "Εσωστρεφές ή λιγότερο δραστήριο",
        "No noticeable change": "Καμία αξιοσημείωτη αλλαγή"
      }
    },
    "q5": {
      "title": "Ε5: Έχει κάνει το παιδί τις ασκήσεις/οδηγίες που συστήσαμε;",
      "options": {
        "Yes, consistently": "Ναι, με συνέπεια",
        "Yes, but not regularly": "Ναι, αλλά όχι τακτικά",
        "Sometimes": "Μερικές φορές",
        "Rarely": "Σπάνια",
        "Not at all": "Καθόλου",
        "Exercises were not prescribed": "Δεν είχαν συνταγογραφηθεί ασκήσεις"
      }
    },
    "q6": {
      "title": "Ε6: Σε κλίμακα 0-10, πώς θα αξιολογούσατε τον πόνο του παιδιού σας τώρα;"
    },
    "q7": {
      "title": "Ε7: Από την τελευταία επίσκεψη, παρατηρήσατε αλλαγές στην κίνηση του παιδιού;",
      "options": {
        "Moving more freely": "Κινείται πιο ελεύθερα",
        "Started crawling / walking / running (milestone achieved)": "Ξεκίνησε να μπουσουλάει / περπατάει / τρέχει (ορόσημο)",
        "Seems less coordinated than before": "Φαίνεται λιγότερο συντονισμένο",
        "Head control has improved": "Ο έλεγχος του κεφαλιού έχει βελτιωθεί",
        "Still favouring one side": "Προτιμά ακόμη τη μία πλευρά",
        "No change noticed": "Δεν παρατηρείται αλλαγή"
      }
    },
    "q8": {
      "title": "Ε8: Υπάρχουν ανησυχίες σχετικά με τη διατροφή;",
      "options": {
        "Feeding well from both sides": "Τρέφεται καλά και από τις δύο πλευρές",
        "Still prefers one side": "Εξακολουθεί να προτιμά τη μία πλευρά",
        "Difficulty latching or feeding": "Δυσκολία στο θηλασμό ή τη σίτιση",
        "No concerns": "Καμία ανησυχία"
      }
    },
    "q9": {
      "title": "Ε9: Πώς κοιμάται το παιδί σας;",
      "options": {
        "Sleeping well through the night": "Κοιμάται καλά όλη τη νύχτα",
        "Waking due to discomfort": "Ξυπνά λόγω δυσφορίας",
        "Sleeping in an unusual position": "Κοιμάται σε ασυνήθιστη θέση",
        "Sleep has improved since last visit": "Ο ύπνος βελτιώθηκε από την τελευταία επίσκεψη",
        "No change": "Καμία αλλαγή"
      }
    },
    "q10": {
      "title": "Ε10: Ποιες θεραπείες έχει λάβει το παιδί από την τελευταία επίσκεψη;",
      "options": {
        "Chiropractic adjustments": "Χειροπρακτικές θεραπείες",
        "Soft tissue therapy": "Θεραπεία μαλακών ιστών",
        "Exercise therapy": "Θεραπευτικές ασκήσεις",
        "Home exercises only": "Μόνο ασκήσεις στο σπίτι",
        "Other healthcare provider treatment": "Θεραπεία από άλλον επαγγελματία υγείας",
        "No treatment received": "Δεν έλαβε καμία θεραπεία"
      }
    },
    "q11": {
      "title": "Ε11: Πώς ανταποκρίθηκε το παιδί στη θεραπεία;",
      "options": {
        "Pain reduced after treatment": "Ο πόνος μειώθηκε μετά τη θεραπεία",
        "More mobile after treatment": "Πιο ευκίνητο μετά τη θεραπεία",
        "Temporary soreness after treatment (normal)": "Προσωρινός πόνος μετά τη θεραπεία (φυσιολογικό)",
        "No noticeable effect": "Κανένα αξιοσημείωτο αποτέλεσμα",
        "Symptoms worsened after treatment (important to note)": "Τα συμπτώματα επιδεινώθηκαν μετά τη θεραπεία (σημαντικό)"
      }
    }
  },
  "outcomeMeasures": {
    "title": "Μέτρα Αποτελέσματος",
    "recommended": "συνιστάται βάσει περιοχών ενοχλήματος",
    "vasAlreadyCaptured": "Η βαθμολόγηση πόνου VAS έχει ήδη καταγραφεί στην ενότητα ενοχλημάτων.",
    "skipMeasures": "Παράλειψη Μέτρων Αποτελέσματος",
    "measureOf": "Μέτρο {{current}} από {{total}}",
    "allComplete": "Όλα τα προτεινόμενα μέτρα ολοκληρώθηκαν",
    "saveAndContinue": "Αποθήκευση & Συνέχεια",
    "ndi": "Δείκτης Αναπηρίας Αυχένα",
    "odi": "Δείκτης Αναπηρίας Oswestry",
    "dash": "DASH (Αναπηρίες Χεριού, Ώμου, Βραχίονα)",
    "lefs": "Κλίμακα Λειτουργικότητας Κάτω Άκρων",
    "phq9": "Ερωτηματολόγιο Υγείας Ασθενούς-9",
    "gad7": "Γενικευμένη Αγχώδης Διαταραχή-7",
    "startBack": "Εργαλείο Ελέγχου STarT Back",
    "tsk11": "Κλίμακα Tampa για Κινησιοφοβία-11",
    "severity": {
      "noDisability": "Χωρίς αναπηρία",
      "mild": "Ήπια",
      "moderate": "Μέτρια",
      "severe": "Σοβαρή",
      "fairlySevere": "Αρκετά σοβαρή",
      "verySevere": "Πολύ σοβαρή",
      "complete": "Πλήρης αναπηρία"
    }
  },
  "ddx": {
    "workingHypotheses": "Εργαζόμενες Υποθέσεις",
    "confirmed": "Επιβεβαιωμένο",
    "confidenceLabel": "βεβαιότητα",
    "acknowledgeAndConfirm": "Αναγνώριση & Επιβεβαίωση",
    "supportingEvidence": "Υποστηρικτική Τεκμηρίωση",
    "addConditionManually": "Χειροκίνητη Προσθήκη Πάθησης",
    "searchAndAdd": "Αναζήτηση & Προσθήκη Πάθησης",
    "searchPlaceholder": "Αναζήτηση κατά όνομα πάθησης, κωδικό ICD ή περιοχή σώματος...",
    "noMatchingConditions": "Δεν βρέθηκαν αντίστοιχες παθήσεις",
    "typeToSearch": "Πληκτρολογήστε τουλάχιστον 2 χαρακτήρες για αναζήτηση",
    "confirmAtLeastOne": "Παρακαλώ επιβεβαιώστε τουλάχιστον μία εργαζόμενη υπόθεση πριν την οριστικοποίηση.",
    "crossComplaintAlerts": "Ειδοποιήσεις Διασταυρούμενων Ενοχλημάτων",
    "clinicalNote": "Κλινική Σημείωση",
    "referTo": "Παραπομπή Προς",
    "additionalTests": "Πρόσθετες Εξετάσεις",
    "matchedCriteria": "Κριτήρια που Ταιριάζουν",
    "title": "Ανασκόπηση Διαφορικής Διάγνωσης",
    "confidence": {
      "strong": "Ισχυρή",
      "probable": "Πιθανή",
      "possible": "Δυνατή",
      "lessLikely": "Λιγότερο Πιθανή",
      "unlikely": "Απίθανη"
    },
    "status": {
      "suggested": "Προτεινόμενη",
      "confirmed": "Επιβεβαιωμένη",
      "overridden": "Υπερκερασμένη",
      "rejected": "Απορριφθείσα",
      "clinicianAdded": "Προστέθηκε από Κλινικό",
      "notSelected": "Δεν επιλέχθηκε"
    },
    "confirmBtn": "Επιβεβαίωση",
    "rejectBtn": "Απόρριψη",
    "overrideBtn": "Υπερκέραση",
    "showEvidence": "Εμφάνιση Τεκμηρίωσης",
    "hideEvidence": "Απόκρυψη Τεκμηρίωσης",
    "redFlagStatus": "Κατάσταση Κόκκινων Σημαιών",
    "acknowledged": "Αναγνωρισμένο",
    "allRedFlagsRequired": "Όλες οι κόκκινες σημαίες πρέπει να αναγνωριστούν πριν την οριστικοποίηση",
    "aiSecondOpinion": "Προαιρετικό: AI Δεύτερη Γνώμη",
    "analyzing": "Ανάλυση...",
    "getAiOpinion": "Λήψη AI Δεύτερης Γνώμης",
    "refreshAiOpinion": "Ανανέωση AI Γνώμης",
    "noAiSuggestions": "Χωρίς πρόσθετες προτάσεις από AI",
    "ruleBasedComplete": "Η ανάλυση βάσει κανόνων ολοκληρώθηκε",
    "clusterAnalysis": "Ανάλυση Συστάδων",
    "conditions": "Παθήσεις",
    "commonFindings": "Κοινά Ευρήματα",
    "systemicAlerts": "Ειδοποιήσεις Συστηματικών Προτύπων",
    "finalizeAssessment": "Οριστικοποίηση Αξιολόγησης",
    "finalizing": "Οριστικοποίηση...",
    "selectTop3": "Επιλογή Κορυφαίων 3",
    "selectBtn": "Επιλογή",
    "confirmedCount": "{{confirmed}} / {{total}} επιβεβαιωμένα",
    "emergency": "ΕΚΤΑΚΤΗ ΑΝΑΓΚΗ",
    "medicalEmergency": "ΙΑΤΡΙΚΗ ΕΚΤΑΚΤΗ ΑΝΑΓΚΗ",
    "emergencyAction": "ΙΑΤΡΙΚΗ ΕΚΤΑΚΤΗ ΑΝΑΓΚΗ — Απαιτεί Άμεση Δράση",
    "emergencyFlags": "ΣΗΜΑΙΕΣ ΙΑΤΡΙΚΗΣ ΕΚΤΑΚΤΗΣ ΑΝΑΓΚΗΣ",
    "critical": "ΚΡΙΣΙΜΟ",
    "loadingReview": "Φόρτωση ανασκόπησης DDx...",
    "noData": "Δεν υπάρχουν διαθέσιμα δεδομένα.",
    "selectHint": "Κάντε κλικ στο <strong>Επιλογή</strong> για επιβεβαίωση υποθέσεων εργασίας. Μόνο οι επιβεβαιωμένες παθήσεις συμπεριλαμβάνονται στο σχέδιο διαχείρισης.",
    "hypothesisCount_one": "{{count}} υπόθεση",
    "hypothesisCount_other": "{{count}} υποθέσεις",
    "skipAiSuggestions": "Παράλειψη Προτάσεων AI",
    "acceptBtn": "✓ Αποδοχή",
    "accepted": "✓ Αποδεκτό",
    "aiSuggestion": "Πρόταση AI",
    "aiDismissed": "Οι προτάσεις AI απορρίφθηκαν. Συνέχεια μόνο με χειροκίνητη DDx.",
    "aiComprehensive": "Χωρίς πρόσθετες προτάσεις από AI. Η ανάλυση βάσει κανόνων φαίνεται ολοκληρωμένη.",
    "aiClinicalNotes": "Κλινικές Σημειώσεις AI",
    "aiDescription": "Η ανάλυση βάσει κανόνων ολοκληρώθηκε. Θέλετε δεύτερη γνώμη AI;",
    "reasoning": "Αιτιολόγηση:",
    "keyFindings": "Βασικά Ευρήματα:",
    "recommendedTests": "Συνιστώμενες Εξετάσεις για Επιβεβαίωση/Αποκλεισμό:",
    "hideDetails": "Απόκρυψη Λεπτομερειών",
    "showDetails": "Εμφάνιση Λεπτομερειών",
    "regions": {
      "lumbar": "Οσφυϊκή (Κάτω Πλάτη)",
      "cervical": "Αυχενική (Λαιμός)",
      "thoracic": "Θωρακική (Μέση Πλάτη)",
      "shoulder": "Ώμος",
      "shoulder_left": "Αριστερός Ώμος",
      "shoulder_right": "Δεξιός Ώμος",
      "knee": "Γόνατο",
      "knee_left": "Αριστερό Γόνατο",
      "knee_right": "Δεξί Γόνατο",
      "hip": "Ισχίο",
      "hip_left": "Αριστερό Ισχίο",
      "hip_right": "Δεξί Ισχίο",
      "elbow": "Αγκώνας",
      "elbow_left": "Αριστερός Αγκώνας",
      "elbow_right": "Δεξιός Αγκώνας",
      "wrist_hand": "Καρπός/Χέρι",
      "wrist_hand_left": "Αριστερός Καρπός/Χέρι",
      "wrist_hand_right": "Δεξιός Καρπός/Χέρι",
      "ankle_foot": "Αστράγαλος/Πόδι",
      "ankle_foot_left": "Αριστερός Αστράγαλος/Πόδι",
      "ankle_foot_right": "Δεξιός Αστράγαλος/Πόδι",
      "tmj": "ΚΓΔ / Σαγόνι"
    },
    "card": {
      "regions": "Περιοχές:"
    },
    "acknowledgeAndDismiss": "Αναγνώριση & Απόρριψη",
    "dismissed": "Απορρίφθηκε",
    "restoreDismissed": "Επαναφορά υπόθεσης",
    "dismissReasonLabel": "Αιτιολογία απόρριψης (υποχρεωτική, τουλ. 5 χαρακτήρες)",
    "dismissReasonPlaceholder": "π.χ. Χωρίς αναισθησία σέλας, φυσιολογική λειτουργία κύστης, πλήρες ανώδυνο εύρος κίνησης",
    "dismissConfirm": "Απόρριψη με αιτιολογία",
    "dismissCancel": "Άκυρο",
    "escalateForEmergency": "Κλιμάκωση για επείγουσα αξιολόγηση",
    "escalateExplainer": "Μόνο αυτός ο διακόπτης εισάγει διατύπωση επείγουσας παραπομπής σε επιστολές ιατρών/ασφαλιστικών.",
    "escalateAction": "Κλιμάκωση",
    "escalationActive": "Κλιμάκωση ΕΝΕΡΓΗ",
    "acknowledgeFlag": "Αναγνώριση & απόρριψη ένδειξης",
    "confirmDifferential": "Επιβεβαίωση διαφορικής",
    "confirming": "Επιβεβαίωση...",
    "confirmedToast": "Η διαφορική επιβεβαιώθηκε — ελέγξτε το πλάνο διαχείρισης. Η αναφορά εκδίδεται όταν πατήσετε Ολοκλήρωση."
  },
  "careJourney": {
    "painRelief": {
      "title": "Φροντίδα Ανακούφισης",
      "duration": "2–6 εβδομάδες",
      "description": "Η πρώτη προτεραιότητα είναι η μείωση του πόνου σας και η ηρέμηση των ιστών. Επικεντρωνόμαστε σε ήπια θεραπεία, σύντομες επισκέψεις και απλές στρατηγικές στο σπίτι, ώστε να μπορείτε να κοιμάστε, να κινείστε και να εργάζεστε με λιγότερη ενόχληση."
    },
    "rehabilitation": {
      "title": "Αποκατάσταση",
      "duration": "6 εβδομάδες – 6 μήνες",
      "description": "Μόλις ο πόνος ελεγχθεί, ξαναχτίζουμε τη δύναμη, την κινητικότητα και την ποιότητα της κίνησης. Οι θεραπείες γίνονται λιγότερο συχνές και αναλαμβάνετε πιο ενεργές ασκήσεις — αυτή είναι η φάση που διατηρεί τη βελτίωση."
    },
    "maintenance": {
      "title": "Φροντίδα Ευεξίας",
      "duration": "Συνεχής",
      "description": "Περιοδικοί έλεγχοι διατηρούν τις βελτιώσεις για τις οποίες εργαστήκατε. Ελέγχουμε τη στάση σας, την κίνηση και τυχόν έγκαιρες ενδείξεις προβλημάτων, προσαρμόζοντας όπως χρειάζεται ώστε μικρά ζητήματα να μη γίνουν μεγαλύτερα."
    }
  },
  "managementPlan": {
    "title": "Σχέδιο Διαχείρισης",
    "panel": {
      "phases": {
        "title": "Φάσεις Φροντίδας",
        "phaseLabel": "Φάση"
      },
      "frequency": {
        "title": "Συχνότητα Θεραπείας",
        "empty": "Δεν υπάρχουν μπλοκ συχνότητας ακόμη. Επιλέξτε ένα προκαθορισμένο παραπάνω ή κάντε κλικ στο \"Προσθήκη Μπλοκ\" για να ξεκινήσετε."
      }
    },
    "preset": {
      "rowLabel": "Προκαθορισμένο"
    },
    "block": {
      "add": "Προσθήκη Μπλοκ",
      "delete": "Διαγραφή",
      "labelAria": "Ετικέτα μπλοκ",
      "frequencyPlaceholder": "π.χ. 3x/εβδομάδα",
      "durationPlaceholder": "εβδομάδες",
      "visitsPlaceholder": "επισκέψεις",
      "deleteMaintenanceConfirm": "Να αφαιρεθεί το μπλοκ Συντήρησης; Ο ασθενής δεν θα έχει συνεχιζόμενο μπλοκ φροντίδας μετά τις ενεργές φάσεις."
    },
    "maintenance": {
      "label": "Συντήρηση"
    },
    "regenerate": "Αναδημιουργία Σχεδίου",
    "generate": "Δημιουργία Σχεδίου",
    "requiresHypothesis": "Ένα σχέδιο διαχείρισης απαιτεί τουλάχιστον μία επιβεβαιωμένη εργαζόμενη υπόθεση από το βήμα Ανασκόπησης DDx.",
    "goToDdx": "← Μετάβαση στην Ανασκόπηση DDx",
    "addressesConditions": "Το Θεραπευτικό Σχέδιο Καλύπτει {{count}} Πάθηση(-εις)",
    "acrossRegions": "Σε {{count}} Περιοχές",
    "treatmentGoals": "Θεραπευτικοί Στόχοι Ασθενούς",
    "goalsSelected": "{{count}} στόχος(-οι) επιλεγμένος(-οι) — το θεραπευτικό σχέδιο θα ευθυγραμμιστεί με αυτούς τους στόχους.",
    "noPlanYet": "Δεν έχει δημιουργηθεί σχέδιο διαχείρισης ακόμα. Πατήστε \"Δημιουργία Σχεδίου\" για να δημιουργήσετε ένα ολοκληρωμένο θεραπευτικό σχέδιο βάσει επιβεβαιωμένων παθήσεων.",
    "visitSchedule": "Πρόγραμμα Επισκέψεων",
    "phase1": "Ενότητα 1",
    "phase2": "Ενότητα 2",
    "phase3": "Ενότητα 3",
    "understanding": "Κατανόηση της Πάθησής(-εών) Σας",
    "treatmentJourney": "Η Θεραπευτική Σας Πορεία",
    "acutePhase": "Φροντίδα Ανακούφισης",
    "rehabPhase": "Αποκατάσταση",
    "maintenancePhase": "Επισκέψεις Ευεξίας",
    "visitFrequency": "Συνιστώμενη Συχνότητα Επισκέψεων",
    "homeExercises": "Τι Μπορείτε να Κάνετε στο Σπίτι",
    "paediatricGuidance": "Παιδιατρική Καθοδήγηση",
    "generatePlan": "Δημιουργία Σχεδίου",
    "regeneratePlan": "Αναδημιουργία Σχεδίου",
    "generating": "Δημιουργία...",
    "completeDdxFirst": "Παρακαλώ ολοκληρώστε πρώτα το βήμα Ανασκόπησης DDx",
    "needConfirmedHypothesis": "Ένα σχέδιο διαχείρισης απαιτεί τουλάχιστον μία επιβεβαιωμένη εργαζόμενη υπόθεση",
    "confirmedConditions": "Επιβεβαιωμένες Παθήσεις",
    "expectedDuration": "Αναμενόμενη Συνολική Διάρκεια",
    "treatmentPhases": "Φάσεις Θεραπείας",
    "precautions": "Προφυλάξεις & Προειδοποιήσεις",
    "referralCriteria": "Κριτήρια Παραπομπής",
    "supplements": "Συστάσεις Συμπληρωμάτων",
    "supplementsClinicianOnly": "Αναφορά για τον κλινικό, όχι για το υλικό του ασθενή",
    "evidenceBase": "Τεκμηριωτική Βάση",
    "phase": "Φάση {{num}}:",
    "duration": "Διάρκεια:",
    "frequency": "Συχνότητα:",
    "techniques": "Τεχνικές",
    "goals": "Στόχοι",
    "condition": "Πάθηση",
    "criteria": "Κριτήρια",
    "urgency": "Επείγον",
    "routine": "τακτικό",
    "urgent": "επείγον",
    "emergent": "έκτακτο",
    "every2weeks": "Κάθε 2 εβδομάδες",
    "every3weeks": "Κάθε 3 εβδομάδες",
    "every4weeks": "Κάθε 4 εβδομάδες (Μηνιαία)",
    "every6weeks": "Κάθε 6 εβδομάδες",
    "ongoingWellness": "Συνεχής φροντίδα ευεξίας",
    "selfLimiting": "Αυτοπεριοριζόμενη κατάσταση",
    "expectedTimeline": "Αναμενόμενο χρονοδιάγραμμα",
    "evidence": {
      "levelA": "Επίπεδο Α — Ισχυρό",
      "levelB": "Επίπεδο Β — Μέτριο",
      "levelC": "Επίπεδο Γ — Περιορισμένο"
    },
    "loadingSupplements": "Φόρτωση συμπληρωμάτων...",
    "exerciseProgrammePdf": "PDF Προγράμματος Ασκήσεων",
    "generated": "Δημιουργήθηκε",
    "infantGoals": "Θεραπευτικοί Στόχοι για το Μωρό σας",
    "treatmentsConcurrent": "οι θεραπείες εκτελούνται παράλληλα",
    "clinicianOverride": "Τροποποίηση Κλινικού",
    "scheduleDescription": "Τα θεραπευτικά πρωτόκολλα αξιολογήθηκαν με βάση τα πιο πρόσφατα κλινικά τεκμήρια. Προσαρμόστε το πρόγραμμα παρακάτω όπως χρειάζεται.",
    "visitsPerWeek": "επισκέψεις/εβδομάδα",
    "for": "για",
    "weeks": "Εβδομάδες",
    "visits": "επισκέψεις",
    "phase3Ongoing": "Συντήρηση",
    "reExamSchedule": "Πρόγραμμα Επανεξετάσεων",
    "reExamsAtWeek": "Επανεξετάσεις στην εβδομάδα",
    "addReExamWeek": "Προσθήκη εβδομάδας επανεξέτασης",
    "removeLastReExam": "Αφαίρεση τελευταίας επανεξέτασης",
    "scheduleSummary": "Ενότητες 1+2: ~{{totalVisits}} επισκέψεις σε ~{{totalWeeks}} εβδομάδες + Συντήρηση: κάθε {{maintenanceWeeks}} εβδομάδες (συνεχής)",
    "resetToDefaults": "Επαναφορά Προεπιλογών",
    "whatDoesThisMean": "Τι σημαίνει αυτό;",
    "whatIsThis": "Τι είναι αυτό;",
    "howDoesItHappen": "Πώς συμβαίνει;",
    "whatCanBeDone": "Τι μπορεί να γίνει;",
    "whatToExpect": "Τι να περιμένετε",
    "whenToWorry": "Πότε να ανησυχήσετε",
    "do": "ΚΑΝΕΤΕ",
    "avoid": "ΑΠΟΦΥΓΕΤΕ",
    "contraindications": "Αντενδείξεις",
    "recommendedApproach": "Συνιστώμενη Προσέγγιση",
    "clinicServices": "Υπηρεσίες Κλινικής",
    "noSupplementsYet": "Δεν έχουν δημιουργηθεί συστάσεις συμπληρωμάτων ακόμα. Δημιουργούνται αυτόματα κατά τη δημιουργία του θεραπευτικού σχεδίου.",
    "grade": "Βαθμός",
    "dosage": "Δοσολογία",
    "timing": "Χρονισμός",
    "highSeverityWarning": "Ανιχνεύθηκε αλληλεπίδραση υψηλής σοβαρότητας — σκεφτείτε να απενεργοποιήσετε αυτό το συμπλήρωμα",
    "disableSupplement": "Απενεργοποίηση συμπληρώματος",
    "enableSupplement": "Ενεργοποίηση συμπληρώματος",
    "active": "ενεργά",
    "total": "σύνολο",
    "citations": "αναφορές",
    "effect": "Αποτέλεσμα",
    "evidenceLevelsDescription": "Επίπεδα τεκμηρίωσης: A = Υψηλής ποιότητας RCTs/μετα-αναλύσεις, B = Μέτριας ποιότητας τεκμήρια, C = Γνώμη ειδικών/σειρές περιπτώσεων",
    "failedToGenerate": "Αποτυχία δημιουργίας σχεδίου",
    "exercisePdfError": "Σφάλμα PDF ασκήσεων",
    "downloadFailed": "Η λήψη απέτυχε",
    "goalLabels": {
      "pain_relief": "Ανακούφιση πόνου",
      "return_to_sport": "Επιστροφή σε άθλημα/δραστηριότητα",
      "improve_posture": "Βελτίωση στάσης σώματος",
      "prevent_recurrence": "Βοήθεια στη μείωση του κινδύνου υποτροπής",
      "improve_mobility": "Βελτίωση κινητικότητας/ευελιξίας",
      "manage_chronic": "Διαχείριση χρόνιας πάθησης",
      "pre_post_surgical": "Προ/μετεγχειρητική αποκατάσταση",
      "general_wellness": "Γενική ευεξία",
      "symptom_resolution": "Επίλυση συμπτωμάτων",
      "improve_movement": "Βελτίωση κίνησης & συμμετρίας",
      "support_development": "Υποστήριξη αναπτυξιακών ορόσημων",
      "feeding_comfort": "Βελτίωση άνεσης σίτισης",
      "sleep_improvement": "Βελτίωση ποιότητας ύπνου",
      "parent_confidence": "Ενίσχυση εμπιστοσύνης γονέα",
      "head_shape": "Βελτίωση σχήματος κεφαλής",
      "prevent_secondary": "Πρόληψη δευτερογενών προβλημάτων"
    },
    "regions": {
      "lumbar": "Οσφυϊκή (Κάτω Μέρος Πλάτης)",
      "cervical": "Αυχενική (Λαιμός)",
      "thoracic": "Θωρακική (Μέσο Πλάτης)",
      "shoulder": "Ώμος",
      "knee": "Γόνατο",
      "hip": "Ισχίο",
      "elbow": "Αγκώνας",
      "wrist": "Καρπός/Χέρι",
      "ankle": "Αστράγαλος/Πόδι",
      "general": "Γενικό"
    },
    "visitWarning": {
      "title": "Ο αριθμός επισκέψεων είναι κάτω από το τυπικό εύρος πορείας φροντίδας",
      "body": "Ο προγραμματισμένος αριθμός επισκέψεων είναι κάτω από το τυπικό εύρος πορείας φροντίδας για αυτό το επίπεδο βαρύτητας. Εξετάστε εάν ο χαμηλότερος αριθμός είναι σκόπιμη επιλογή (αναμενόμενη ταχεία ανταπόκριση, προτίμηση ασθενούς, ήπια κλινική εικόνα) ή εάν θα ήταν κατάλληλο ένα σύντομο πλάνο επαναξιολόγησης.",
      "severity": {
        "mild": "ήπια",
        "moderate": "μέτρια",
        "moderateSevere": "μέτρια-σοβαρή",
        "severe": "σοβαρή"
      }
    },
    "severityTier": {
      "mildModerate": "Ήπια-Μέτρια",
      "moderate": "Μέτρια",
      "moderateSevere": "Μέτρια-Σοβαρή",
      "moderateHigh": "Μέτρια-Υψηλή",
      "high": "Υψηλή"
    },
    "moderateExplanation": "Τα συμπτώματά σας δείχνουν μέτριο επίπεδο συνολικής επιβάρυνσης, καθώς επηρεάζεται περισσότερη από μία περιοχή και η υψηλότερη βαθμολογία πόνου που αναφέρατε είναι 6/10. Αυτό δεν σημαίνει ότι βρέθηκε κάτι επικίνδυνο, αλλά μας βοηθά να σχεδιάσουμε τη φροντίδα σας και να παρακολουθούμε την πρόοδό σας.",
    "reexamPoints": {
      "title": "Επανεξετάσεις",
      "add": "Προσθήκη επανεξέτασης",
      "empty": "Δεν έχουν προγραμματιστεί επανεξετάσεις. Προσθέστε μία για να συνδέσετε τον επίσημο επανέλεγχο προόδου με προγραμματισμένη συνεδρία.",
      "visitOption": "Συνεδρία {{n}} (εβδομάδα {{w}})",
      "missingVisit": "Συνεδρία {{n}} (δεν είναι πλέον προγραμματισμένη)",
      "invalidWarning": "Αυτή η συνεδρία δεν υπάρχει πλέον — εξαιρείται από την αναφορά μέχρι να διορθωθεί.",
      "remove": "Αφαίρεση"
    },
    "genericTemplate": "γενικό πρότυπο",
    "genericTemplateHint": "Δεν υπάρχει πρωτόκολλο ειδικό για την πάθηση· αυτό είναι το γενικό πρότυπο 3 φάσεων."
  },
  "report": {
    "title": "Κλινική Αναφορά",
    "generate": "Δημιουργία Αναφοράς",
    "regenerate": "Αναδημιουργία",
    "format": "Μορφή Αναφοράς",
    "compact": "Συνοπτική",
    "comprehensive": "Αναλυτική",
    "selectLanguage": "Γλώσσα Αναφοράς",
    "selectSections": "Ενότητες προς Συμπερίληψη",
    "printReport": "Εκτύπωση Αναφοράς",
    "downloadPdf": "Λήψη PDF",
    "generatedOn": "Δημιουργήθηκε στις",
    "disclaimer": "Αυτή η αναφορά περιέχει εργαζόμενες υποθέσεις μόνο για κλινική εξέταση. Δεν αποτελεί οριστική διάγνωση.",
    "includeLetterhead": "Συμπερίληψη επιστολόχαρτου κλινικής",
    "enhanceWithAi": "Βελτίωση με AI",
    "selectAtLeastOne": "Επιλέξτε τουλάχιστον μία ενότητα",
    "aiSummary": "AI Ενισχυμένη Σύνοψη (Προαιρετικό)",
    "dismiss": "Απόρριψη",
    "keyPoints": "Βασικά Σημεία",
    "nextSteps": "Συνιστώμενα Επόμενα Βήματα",
    "clinicalReport": "Αναφορά Κλινικής Αξιολόγησης",
    "compactReport": "συνοπτική αναφορά",
    "comprehensiveReport": "αναλυτική αναφορά",
    "bookAppointment": "Κλείστε το Επόμενο Ραντεβού σας",
    "callUs": "Καλέστε μας:",
    "emailUs": "Email:",
    "visitUs": "Επισκεφθείτε μας:",
    "openingHours": "Ώρες λειτουργίας:",
    "followInstagram": "Ακολουθήστε μας στο Instagram:",
    "scanToBook": "Σαρώστε για να κλείσετε το επόμενο ραντεβού σας",
    "confidential": "Εμπιστευτικό",
    "was": "Ήταν",
    "now": "Τώρα",
    "before": "Πριν",
    "better": "καλύτερα",
    "improvement": "βελτίωση",
    "outcomeMeasureDeltas": "Αλλαγές Μετρήσεων Αποτελεσμάτων",
    "outcomeMeasureChanges": "Αλλαγές Μετρήσεων Αποτελεσμάτων",
    "measure": "Μέτρηση",
    "change": "Αλλαγή",
    "significance": "Σημαντικότητα",
    "whyOngoingCare": "Γιατί η Συνεχής Φροντίδα Είναι Σημαντική",
    "painRelief": "Ανακούφιση Πόνου",
    "rehabilitation": "Αποκατάσταση",
    "maintenance": "Ευεξία & Πρόληψη",
    "peakPerformance": "Κορυφαία Απόδοση",
    "emailReport": "Αποστολή Αναφοράς στον Ασθενή μέσω Email",
    "emailInstructions": "Εισάγετε τη διεύθυνση email του ασθενούς για αποστολή αντιγράφου αυτής της αναφοράς",
    "patientEmailOverride": "Email Ασθενούς (προαιρετική αντικατάσταση)",
    "sendReport": "Αποστολή Αναφοράς",
    "sending": "Αποστολή...",
    "sections": {
      "patient_info": "Στοιχεία Ασθενούς",
      "chief_complaints": "Κύρια Παράπονα",
      "medical_history": "Ιατρικό Ιστορικό",
      "examination_findings": "Ευρήματα Εξέτασης",
      "imaging_results": "Αποτελέσματα Απεικόνισης",
      "diagnosis": "Διάγνωση (DDx)",
      "treatment_plan": "Πλάνο Θεραπείας",
      "wellness_score": "Βαθμολογία Σωματικής Απόδοσης",
      "red_flags": "Σημάδια Κινδύνου",
      "referrals": "Παραπομπές",
      "supplement_plan": "Συστάσεις Συμπληρωμάτων"
    },
    "yourCarePathway": "Η Πορεία Προόδου",
    "phase1PainRelief": "1. Φροντίδα Ανακούφισης",
    "phase1Desc": "Φάση ανάρρωσης — σας απαλλάσσει από τον πόνο",
    "phase2Rehab": "2. Αποκατάσταση",
    "phase2Desc": "Φάση βελτίωσης — χτίζει την ανθεκτικότητά σας",
    "phase3Wellness": "3. Φροντίδα Ευεξίας",
    "phase3Desc": "Φάση βελτιστοποίησης — σας κρατά στο μέγιστο",
    "didYouKnow": "Ξέρατε ότι;",
    "didYouKnowText": "Οι τακτικοί έλεγχοι μας βοηθούν να παρακολουθούμε την πρόοδό σας, να εντοπίσουμε έγκαιρα αλλαγές στην κίνηση ή τη λειτουργία, και να υποστηρίξουμε την αυτοδιαχείρισή σας. Για πολλούς ασθενείς, η συνεχής φροντίδα βοηθά στη διατήρηση της δραστηριότητας και τη μείωση της πιθανότητας εξάρσεων.",
    "knowSomeone": "Γνωρίζετε κάποιον που θα μπορούσε να ωφεληθεί;",
    "knowSomeoneText": "Θα θέλαμε να βοηθήσουμε και την οικογένεια και τους φίλους σας. Αν γνωρίζετε κάποιον που θα μπορούσε να ωφεληθεί, θα ήταν τιμή μας να τον υποδεχτούμε.",
    "outOf100": "από 100",
    "zone": "Ζώνη",
    "treatmentGoals": "Οι θεραπευτικοί σας στόχοι:",
    "whenToContact": "Πότε να επικοινωνήσετε μαζί μας",
    "dearGuardianOf": "Γονέας/Κηδεμόνας του/της",
    "dearPatient": "Αγαπητέ/ή",
    "thankYouBringing": "Σας ευχαριστούμε που φέρατε τον/την {name} στο {clinic}. Παρακάτω θα βρείτε μια σύνοψη των ευρημάτων μας.",
    "ongoingCareIntro": "Όπως επισκέπτεστε τον οδοντίατρο κάθε 6 μήνες για να διατηρείτε τα δόντια σας υγιή, η σπονδυλική σας στήλη και το μυοσκελετικό σας σύστημα ωφελούνται από τακτικούς ελέγχους. Αυτές οι επισκέψεις μας βοηθούν να εντοπίσουμε μικρά προβλήματα πριν γίνουν μεγάλα.",
    "evidenceCareParagraph": "Ο πόνος στην πλάτη και τον αυχένα μπορεί να βελτιωθεί, αλλά τα συμπτώματα μπορεί κάποιες φορές να επανέλθουν — ιδιαίτερα όταν δεν αντιμετωπίζονται παράγοντες όπως η στάση στην εργασία, το άγχος, η μυϊκή αδυναμία, η δυσκαμψία, ο προπονητικός φόρτος ή άλλοι παράγοντες του τρόπου ζωής. Η έρευνα υποστηρίζει τη θεραπεία με τα χέρια, συμπεριλαμβανομένων των σπονδυλικών χειρισμών, ως μία επιλογή για τον πόνο στη μέση, όταν συνδυάζεται με άσκηση, αποκατάσταση, εκπαίδευση και αυτοδιαχείριση. Για επιλεγμένους ασθενείς με υποτροπιάζοντα ή επίμονο πόνο στη μέση, οι οποίοι ανταποκρίνονται καλά στην αρχική χειροπρακτική φροντίδα, έχει φανεί ότι η φροντίδα συντήρησης μπορεί να μειώσει τον αριθμό των ημερών με ενοχλητικό πόνο στη μέση μέσα σε διάστημα 12 μηνών, σε σύγκριση με φροντίδα μόνο όταν τα συμπτώματα επανεμφανίζονται.",
    "evidenceCitation": "Βάσει: NICE Guideline NG59; Eklund et al. (2018) Nordic Maintenance Care RCT; Senna & Machaly (2011) Spine; Cochrane Review CD008112 (Rubinstein et al.).",
    "encourageWellness": "Ενθαρρύνουμε τακτικούς ελέγχους ακόμη και μετά την υποχώρηση των συμπτωμάτων σας. Η μυοσκελετική σας υγεία είναι μια συνεχής διαδρομή και είμαστε εδώ να σας υποστηρίξουμε σε κάθε βήμα.",
    "versionHistory": "Ιστορικό τροποποιήσεων",
    "supersededBanner": "Βλέπετε μια παλαιότερη έκδοση που έχει αντικατασταθεί. Είναι μόνο για ανάγνωση.",
    "versionLabel": "Έκδοση",
    "versionCurrent": "τρέχουσα",
    "versionSuperseded": "αντικαταστάθηκε",
    "notReadyTitle": "Αυτή η αναφορά δεν είναι ακόμη έτοιμη",
    "notReadyBody": "Η αξιολόγηση δεν έχει ακόμη αρκετά καταγεγραμμένα στοιχεία για να παραχθεί αναφορά ασθενούς. Ολοκληρώστε τα υπόλοιπα βήματα και ανοίξτε ξανά την αναφορά."
  },
  "soap": {
    "title": "Σημείωμα SOAP",
    "printView": "Σημείωμα SOAP — Προβολή Εκτύπωσης",
    "loading": "Φόρτωση σημειώματος SOAP...",
    "autoGenerate": "Αυτόματη Δημιουργία",
    "aiPolish": "AI Βελτίωση",
    "aiPolishing": "AI Βελτίωση...",
    "backToEditor": "Πίσω στον Επεξεργαστή",
    "saveNote": "Αποθήκευση Σημειώματος SOAP",
    "saving": "Αποθήκευση...",
    "savedSuccess": "Το σημείωμα SOAP αποθηκεύτηκε επιτυχώς.",
    "autoGenerated": "Το σημείωμα δημιουργήθηκε αυτόματα από τα δεδομένα αξιολόγησης.",
    "subjective": "Υποκειμενικό",
    "objective": "Αντικειμενικά (Ευρήματα & Υποθέσεις Εργασίας)",
    "assessment": "Ενέργεια / Θεραπεία",
    "plan": "Σχέδιο",
    "subjectivePlaceholder": "Συμπτώματα, ιστορικό και ενοχλήματα που αναφέρει ο ασθενής...",
    "objectivePlaceholder": "Ευρήματα εξέτασης, υποθέσεις εργασίας DDx, βαθμολογία BPS...",
    "assessmentPlaceholder": "π.χ., CMT C4-5 δεξιά στροφή, κινητοποίηση βαθμού IV L4-5, STT τραπέζιοι Α...",
    "planPlaceholder": "Θεραπευτικό σχέδιο, παρακολούθηση, παραπομπές, εκπαίδευση ασθενούς...",
    "formatting": "Μορφοποίηση:",
    "errors": {
      "generateFailed": "Αποτυχία δημιουργίας σημειώματος SOAP",
      "saveFailed": "Αποτυχία αποθήκευσης σημειώματος SOAP"
    }
  },
  "settings": {
    "title": "Ρυθμίσεις Κλινικής",
    "manageDesc": "Διαχειριστείτε την εμφάνιση και τις πληροφορίες της κλινικής σας",
    "viewDesc": "Προβολή πληροφοριών κλινικής",
    "clinicInfo": "Πληροφορίες Κλινικής",
    "clinicName": "Όνομα Κλινικής",
    "phone": "Τηλέφωνο",
    "email": "Email",
    "website": "Ιστοσελίδα",
    "address": "Διεύθυνση",
    "instagram": "Λογαριασμός Instagram",
    "openingHours": "Ώρες Λειτουργίας",
    "clinicLogo": "Λογότυπο Κλινικής",
    "logoDesc": "Ανεβάστε το λογότυπο της κλινικής σας. Θα εμφανίζεται στην κεφαλίδα της εφαρμογής, τη σελίδα σύνδεσης και τις αναφορές. Αποδεκτές μορφές: PNG, JPG, SVG. Μέγ. 2MB.",
    "uploading": "Ανέβασμα…",
    "uploadLogo": "Ανέβασμα Λογοτύπου",
    "removeLogo": "Αφαίρεση λογοτύπου",
    "branding": "Εταιρική Ταυτότητα",
    "primaryColor": "Κύριο Χρώμα",
    "usedInHeaders": "Χρησιμοποιείται στις κεφαλίδες αναφορών",
    "reportFooter": "Κείμενο Υποσέλιδου Αναφοράς",
    "qrCodeUrl": "URL Κωδικού QR (για αναφορές)",
    "qrCodeDesc": "Επικολλήστε σύνδεσμο κράτησης, σελίδα Instagram ή σύνδεσμο Google Maps. Ένας κωδικός QR θα εμφανίζεται στις αναφορές ασθενών.",
    "saveClinicInfo": "Αποθήκευση Πληροφοριών Κλινικής",
    "aiConfig": "Ρύθμιση AI",
    "aiConfigDesc": "Ρυθμίστε ένα εξωτερικό AI API για κλινικές λειτουργίες ανάλυσης όπως DDx δεύτερη γνώμη, δημιουργία σημειώματος SOAP και ανάλυση απεικόνισης.",
    "aiProvider": "Πάροχος AI",
    "model": "Μοντέλο",
    "enterModel": "Εισάγετε όνομα μοντέλου",
    "apiKey": "Κλειδί API",
    "currentKeyMasked": "Τρέχον κλειδί: [κρυμμένο] — αφήστε κενό για διατήρηση",
    "apiEndpoint": "Σημείο Πρόσβασης API",
    "monthlyBudget": "Μηνιαίο Όριο Προϋπολογισμού (προαιρετικό)",
    "noLimit": "Χωρίς όριο",
    "perMonth": "/ μήνα (ενημερωτικό)",
    "saveAiConfig": "Αποθήκευση Ρύθμισης AI",
    "testConnection": "Δοκιμή Σύνδεσης",
    "testing": "Δοκιμή…",
    "emailConfig": "Ρύθμιση Email (SMTP)",
    "emailConfigDesc": "Ρυθμίστε SMTP για αποστολή αναφορών ασθενών μέσω email απευθείας από την πλατφόρμα. Ο κωδικός SMTP αποθηκεύεται κρυπτογραφημένος.",
    "enableEmail": "Ενεργοποίηση αποστολής email",
    "smtpHost": "Διακομιστής SMTP",
    "smtpPort": "Θύρα SMTP",
    "smtpPortWarning465": "Η θύρα 465 ενδέχεται να αποκλείεται από ορισμένους παρόχους. Εάν αποτύχουν τα emails, αλλάξτε σε θύρα 587 (STARTTLS).",
    "smtpUser": "Όνομα Χρήστη SMTP",
    "smtpPassword": "Κωδικός SMTP",
    "smtpFrom": "Διεύθυνση Email Αποστολέα",
    "saveSmtpConfig": "Αποθήκευση Ρύθμισης SMTP",
    "tabClinicSettings": "Ρυθμίσεις Κλινικής",
    "tabTreatmentProtocols": "Πρωτόκολλα Θεραπείας",
    "navIdentity": "Ταυτότητα Κλινικής",
    "navTeam": "Η Ομάδα Σας",
    "navModalities": "Θεραπευτικές Μέθοδοι",
    "navTools": "Εργαλεία Αξιολόγησης",
    "navPathway": "Θεραπευτική Πορεία",
    "navReports": "Αναφορές",
    "navChecker": "Έλεγχος Συμπτωμάτων",
    "navIntegrations": "Ενσωματώσεις",
    "navType": "Τύπος Κλινικής",
    "navBilling": "Χρεώσεις",
    "whatsappNumber": "Αριθμός WhatsApp",
    "googleMapsLink": "Σύνδεσμος Google Maps",
    "facebook": "Facebook",
    "linkedin": "LinkedIn",
    "regionalSettings": "Περιφερειακές Ρυθμίσεις",
    "dateFormat": "Μορφή Ημερομηνίας",
    "dateFmtEU": "ΗΗ/ΜΜ/ΕΕΕΕ (ΕΕ/Κύπρος)",
    "dateFmtUS": "ΜΜ/ΗΗ/ΕΕΕΕ (ΗΠΑ)",
    "dateFmtISO": "ΕΕΕΕ-ΜΜ-ΗΗ (ISO)",
    "measurementSystem": "Σύστημα Μετρήσεων",
    "measureMetric": "Μετρικό (cm, kg)",
    "measureImperial": "Αγγλοσαξονικό (in, lb)",
    "customNextSteps": "Προσαρμοσμένα Επόμενα Βήματα",
    "customNextStepsDesc": "Προσαρμόστε την ενότητα \"Επόμενα Βήματα\" των αναφορών ασθενών με το δικό σας μήνυμα και εικόνα.",
    "customMessage": "Προσαρμοσμένο Μήνυμα",
    "generateWithAi": "Δημιουργία με AI",
    "nextStepsImage": "Εικόνα Επόμενων Βημάτων (προαιρετικό)",
    "nextStepsImageDesc": "Ανεβάστε μια εικόνα για εμφάνιση στην ενότητα Επόμενων Βημάτων των αναφορών. Μέγ. 1MB.",
    "removeImage": "Αφαίρεση Εικόνας",
    "reportContent": "Περιεχόμενο Αναφοράς",
    "reportContentDesc": "Προσαρμόστε το κείμενο που εμφανίζεται στις ενότητες της αναφοράς ασθενή.",
    "aboutOurTeam": "Σχετικά με την Ομάδα μας",
    "treatmentApproach": "Θεραπευτική Προσέγγιση",
    "maintenanceWellnessMsg": "Μήνυμα Συντήρησης / Ευεξίας",
    "yourTeam": "Η Ομάδα Σας",
    "addMember": "+ Προσθήκη Μέλους",
    "teamDesc": "Αυτά τα μέλη ομάδας εμφανίζονται στην Αναφορά Ασθενή κάτω από \"Η Ομάδα Φροντίδας Σας\". Ο Επικεφαλής Κλινικός υπογράφει αναφορές.",
    "fullName": "Πλήρες Όνομα *",
    "roleTitle": "Ρόλος / Τίτλος στην Κλινική *",
    "professionalCredential": "Επαγγελματικός Τίτλος",
    "selectCredential": "— Επιλέξτε τίτλο —",
    "displayOnReports": "Εμφάνιση σε αναφορές",
    "displayPrefNameCred": "Όνομα (Τίτλος) — προεπιλογή",
    "displayPrefNameOnly": "Μόνο όνομα",
    "displayPrefCustom": "Προσαρμοσμένο — ελεύθερο κείμενο",
    "customTitlePlaceholder": "Ακριβώς πώς θέλετε να εμφανίζεται το όνομά σας στις αναφορές",
    "preview": "Προεπισκόπηση:",
    "shortBio": "Σύντομο Βιογραφικό",
    "shortBioPlaceholder": "Σύντομο επαγγελματικό βιογραφικό στις αναφορές ασθενών (μέγ. 600 χαρ.)",
    "leadClinician": "Επικεφαλής / Ιδιοκτήτης Κλινικός",
    "leadClinicianNote": "(υπογράφει αναφορές, μόνο ένας ανά κλινική)",
    "lead": "Επικεφαλής",
    "noTeamMembers": "Δεν έχουν ρυθμιστεί μέλη ομάδας. Κάντε κλικ στο \"Προσθήκη Μέλους\" για να ξεκινήσετε.",
    "saveModalities": "Αποθήκευση Θεραπευτικών Μεθόδων",
    "saveAllChanges": "",
    "saveAssessmentTools": "Αποθήκευση Εργαλείων Αξιολόγησης",
    "saveCarePathway": "Αποθήκευση Θεραπευτικής Πορείας",
    "saveReportPreferences": "Αποθήκευση Προτιμήσεων Αναφοράς",
    "reportTemplates": "Πρότυπα Αναφορών",
    "reportTemplatesDesc": "Σχεδιάστε και προσαρμόστε τη διάταξη αναφορών ασθενών.",
    "aiCredits": "Μονάδες AI",
    "mskCredits": "Μονάδες MSK",
    "ownApiKey": "Δικό σας Κλειδί API",
    "aiCreditsDesc": "Επιλέξτε πώς λειτουργούν οι δυνατότητες AI.",
    "aiMode": "Λειτουργία AI",
    "useOwnApiKey": "Χρήση δικού σας κλειδιού API",
    "useMskCredits": "Χρήση Μονάδων AI MSK Insight",
    "creditBalance": "Υπόλοιπο Μονάδων",
    "creditRateFast": "Γρήγορη κλήση = 1 μονάδα",
    "creditRateSmart": "Έξυπνη κλήση = 5 μονάδες",
    "creditRateFormat": "Κλήση μορφοποίησης = 1 μονάδα",
    "lowCreditsWarning": "Χαμηλές μονάδες! Οι λειτουργίες AI ενδέχεται να σταματήσουν σύντομα. Αγοράστε περισσότερες μονάδες.",
    "creditPacks": "Πακέτα Μονάδων",
    "buyCredits": "Αγορά Μονάδων",
    "buyCreditsNote": "Επικοινωνήστε στο support@mskinsight.com για αγορά",
    "googleReviews": "Κριτικές Google",
    "connected": "Συνδεδεμένο",
    "notConnected": "Μη συνδεδεμένο",
    "googleReviewsDesc": "Συνδέστε τον σύνδεσμο κριτικών Google Business για αποστολή αιτημάτων κριτικής σε ασθενείς μέσω email ή WhatsApp.",
    "googleReviewUrlLabel": "URL Κριτικής Google",
    "googleReviewUrlHint": "Βρείτε τον σύνδεσμό σας στο Google Business Profile κάτω από \"Λάβετε περισσότερες κριτικές\"",
    "saveReviewUrl": "Αποθήκευση URL Κριτικής",
    "whatsappBusiness": "WhatsApp Business",
    "notConfigured": "Μη ρυθμισμένο",
    "whatsappBusinessDesc": "Ρυθμίστε τον αριθμό WhatsApp Business και το πρότυπο μηνύματος για επικοινωνία με ασθενείς.",
    "whatsappBusinessNumber": "Αριθμός WhatsApp Business",
    "whatsappNumberHint": "Συμπεριλάβετε κωδικό χώρας (π.χ. +357 για Κύπρο, +44 για Ηνωμένο Βασίλειο)",
    "defaultMsgTemplate": "Προεπιλεγμένο Πρότυπο Μηνύματος",
    "templateVariables": "Διαθέσιμες μεταβλητές: {patientName}, {clinicName}, {condition}, {reviewUrl}",
    "saveWhatsappSettings": "Αποθήκευση Ρυθμίσεων WhatsApp",
    "testWhatsapp": "Δοκιμή WhatsApp",
    "saveClinicType": "Αποθήκευση Τύπου Κλινικής",
    "demoMode": "Λειτουργία Επίδειξης",
    "demoModeDesc": "Φόρτωση δεδομένων επίδειξης. Δεν θα εμφανίζονται πραγματικά δεδομένα ασθενών.",
    "demoModeOn": "Η λειτουργία επίδειξης είναι ΕΝΕΡΓΗ — τα πραγματικά δεδομένα ασθενών είναι κρυμμένα",
    "modalities": {
      "_TRANSLATE_ME": "Night 10 stub. All strings below are empty — i18next falls back to EN until translated. See ~/Desktop/MODALITIES-DECISIONS-LOCKED.md.",
      "title": "",
      "helperText": "",
      "clinicNotesHint": "",
      "clinicNotesPlaceholder": "",
      "customGroupLabel": "",
      "removeCustom": "",
      "addCustomTitle": "",
      "addCustomPlaceholder": "",
      "addCustomButton": "",
      "filledSummary": "",
      "groups": {
        "manual": {
          "label": ""
        },
        "active": {
          "label": ""
        },
        "modality_based": {
          "label": ""
        },
        "education": {
          "label": ""
        }
      },
      "items": {
        "spinal_manipulation": {
          "label": "",
          "description": ""
        },
        "instrument_adjusting": {
          "label": "",
          "description": ""
        },
        "drop_piece": {
          "label": "",
          "description": ""
        },
        "soft_tissue": {
          "label": "",
          "description": ""
        },
        "iastm": {
          "label": "",
          "description": ""
        },
        "dry_needling": {
          "label": "",
          "description": ""
        },
        "cupping": {
          "label": "",
          "description": ""
        },
        "neural_mobilisation": {
          "label": "",
          "description": ""
        },
        "joint_mobilisation": {
          "label": "",
          "description": ""
        },
        "rehab_exercises": {
          "label": "",
          "description": ""
        },
        "functional_movement": {
          "label": "",
          "description": ""
        },
        "clinical_pilates": {
          "label": "",
          "description": ""
        },
        "gait_retraining": {
          "label": "",
          "description": ""
        },
        "neuromuscular_reeducation": {
          "label": "",
          "description": ""
        },
        "breathing_exercises": {
          "label": "",
          "description": ""
        },
        "spinal_decompression": {
          "label": "",
          "description": ""
        },
        "shockwave": {
          "label": "",
          "description": ""
        },
        "laser": {
          "label": "",
          "description": ""
        },
        "tens": {
          "label": "",
          "description": ""
        },
        "ultrasound": {
          "label": "",
          "description": ""
        },
        "kinesio_taping": {
          "label": "",
          "description": ""
        },
        "rigid_taping": {
          "label": "",
          "description": ""
        },
        "normatec": {
          "label": "",
          "description": ""
        },
        "heat_therapy": {
          "label": "",
          "description": ""
        },
        "hydrotherapy": {
          "label": "",
          "description": ""
        },
        "red_light_therapy": {
          "label": "",
          "description": ""
        },
        "posture_analysis": {
          "label": "",
          "description": ""
        },
        "patient_education": {
          "label": "",
          "description": ""
        },
        "ergonomic_assessment": {
          "label": "",
          "description": ""
        },
        "nutritional": {
          "label": "",
          "description": ""
        }
      },
      "primaryDiscipline": {
        "title": "",
        "helperText": "",
        "options": {
          "chiropractic": {
            "label": "",
            "description": ""
          },
          "physiotherapy": {
            "label": "",
            "description": ""
          },
          "osteopathy": {
            "label": "",
            "description": ""
          },
          "sports_medicine": {
            "label": "",
            "description": ""
          },
          "multidisciplinary": {
            "label": "",
            "description": ""
          }
        }
      }
    },
    "_TRANSLATE_ME_NIGHT_12B": "Night 12b stub. Values marked '[_TRANSLATE_ME]' fall back to EN at render time. See proof/night12b/USER-EVIDENCE.md.",
    "navDiagnosticEquipment": "Διαγνωστικός Εξοπλισμός",
    "navOutcomeMeasuresAndTests": "Δείκτες Αποτελέσματος & Δοκιμές",
    "diagnosticEquipment": {
      "title": "Διαγνωστικός Εξοπλισμός",
      "subtitle": "Επιλέξτε τα διαγνωστικά εργαλεία και τα εργαλεία αξιολόγησης που διαθέτει η κλινική σας."
    },
    "outcomeMeasuresAndTests": {
      "title": "Δείκτες Αποτελέσματος & Δοκιμές",
      "helperText": "Επιλέξτε ποιους δείκτες αποτελέσματος αναφερόμενους από τον ασθενή και ποια ορθοπεδικά πακέτα δοκιμών χρησιμοποιεί η κλινική σας. Οι προτάσεις AI και οι ροές αξιολόγησης θα ευθυγραμμιστούν με αυτές."
    },
    "outcomeMeasures": {
      "sectionTitle": "Δείκτες Αποτελέσματος",
      "sectionSubtitle": "12 επικυρωμένα εργαλεία αναφερόμενα από τον ασθενή. Οι απενεργοποιημένοι δείκτες δεν θα προταθούν στις ροές αξιολόγησης.",
      "filledSummary": "{{count}} από {{total}} δείκτες αποτελέσματος ενεργοποιημένοι",
      "groups": {
        "generic": {
          "label": "Γενικοί"
        },
        "region_specific": {
          "label": "Ανά περιοχή"
        },
        "psychosocial": {
          "label": "Ψυχοκοινωνική διαλογή"
        }
      },
      "items": {
        "PSFS": {
          "label": "Patient-Specific Functional Scale",
          "description": "Ο ασθενής εντοπίζει 3-5 δραστηριότητες που περιορίζονται από την κατάστασή του· βαθμολογεί την ικανότητα 0-10."
        },
        "NPRS": {
          "label": "Numeric Pain Rating Scale",
          "description": "Μονοσημείωτη βαθμολογία πόνου 0-10. Γρήγορη, παγκοσμίως κατανοητή."
        },
        "VAS": {
          "label": "Visual Analog Scale",
          "description": "Συνεχής γραμμή 0-100mm για πόνο ή άλλους υποκειμενικούς δείκτες."
        },
        "GROC": {
          "label": "Global Rating of Change",
          "description": "Μονή αναδρομική βαθμολόγηση της συνολικής αλλαγής από την αρχική κατάσταση -7 έως +7."
        },
        "NDI": {
          "label": "Neck Disability Index",
          "description": "Δείκτης αναπηρίας 10 στοιχείων για αυχενικές παθήσεις. Βαθμολογία 0-50."
        },
        "ODI": {
          "label": "Oswestry Disability Index",
          "description": "Δείκτης αναπηρίας 10 στοιχείων για χαμηλό πόνο πλάτης. Βαθμολογία 0-100· MCID ~10."
        },
        "DASH": {
          "label": "DASH — Αναπηρία Άνω Άκρου",
          "description": "Disabilities of the Arm, Shoulder and Hand. Κλίμακα 30 στοιχείων."
        },
        "LEFS": {
          "label": "Lower Extremity Functional Scale",
          "description": "20 στοιχεία λειτουργικής αξιολόγησης για μυοσκελετικές παθήσεις κάτω άκρων."
        },
        "PHQ9": {
          "label": "Patient Health Questionnaire-9",
          "description": "Διαλογή σοβαρότητας κατάθλιψης. Βαθμολογία 0-27."
        },
        "GAD7": {
          "label": "Generalised Anxiety Disorder-7",
          "description": "Διαλογή σοβαρότητας άγχους. Βαθμολογία 0-21."
        },
        "STarT_Back": {
          "label": "STarT Back Screening Tool",
          "description": "Διαστρωμάτωση κινδύνου πόνου πλάτης 9 στοιχείων (χαμηλός / μεσαίος / υψηλός κίνδυνος)."
        },
        "TSK11": {
          "label": "Tampa Scale Kinesiophobia-11",
          "description": "Κλίμακα φόβου κίνησης 11 στοιχείων. Βαθμολογία 11-44."
        }
      }
    },
    "orthopaedicTestPacks": {
      "sectionTitle": "Πακέτα Ορθοπεδικών Δοκιμών",
      "sectionSubtitle": "14 πακέτα δοκιμών ομαδοποιημένα ανά περιοχή. Κάθε πακέτο ενεργοποιεί μια επιλεγμένη ομάδα ορθοπεδικών δοκιμών στη ροή αξιολόγησης.",
      "testCount": "{{count}} δοκιμές",
      "filledSummary": "{{count}} από {{total}} πακέτα ενεργοποιημένα ({{tests}} δοκιμές διαθέσιμες)",
      "groups": {
        "axial": {
          "label": "Αξονική"
        },
        "upper_extremity": {
          "label": "Άνω άκρο"
        },
        "lower_extremity": {
          "label": "Κάτω άκρο"
        },
        "special": {
          "label": "Ειδικές"
        }
      },
      "items": {
        "CERVICAL": {
          "label": "Αυχενική",
          "description": "Spurling, distraction, ULTT, διαλογή σπονδυλικής αρτηρίας και 11 άλλες."
        },
        "THORACIC": {
          "label": "Θωρακική",
          "description": "Δοκιμή ελατηρίου (spring testing), Adam forward bend, δοκιμές πλευροσπονδυλικής άρθρωσης."
        },
        "LUMBAR": {
          "label": "Οσφυϊκή",
          "description": "SLR, slump, prone instability, Kemp και 16 άλλες."
        },
        "SI_JOINT": {
          "label": "Ιεροκόκκυγο-λαγόνια Άρθρωση",
          "description": "Σύμπλεγμα 5 δοκιμών πρόκλησης ΙΛΑ (distraction, compression, thigh thrust, Gaenslen, sacral thrust)."
        },
        "SACRAL": {
          "label": "Ιερά",
          "description": "Ψηλάφηση κίνησης ιερού, πρόκληση ιερο-κοκκυγικής άρθρωσης, κινητικότητα κόκκυγα."
        },
        "HEADACHE": {
          "label": "Κεφαλαλγία",
          "description": "Δοκιμές πρόκλησης κεφαλαλγίας αυχενικού τύπου και τάσης."
        },
        "SHOULDER": {
          "label": "Ώμος",
          "description": "Neer, Hawkins-Kennedy, Empty Can, O Brien, apprehension και 15 άλλες."
        },
        "ELBOW": {
          "label": "Αγκώνας",
          "description": "Cozen, Mill, δοκιμές καταπόνησης συνδέσμων, Tinel και άλλες."
        },
        "WRIST_HAND": {
          "label": "Καρπός / Χέρι",
          "description": "Phalen, Tinel στον καρπό, Finkelstein, δοκιμές σκαφοειδούς και άλλες."
        },
        "HIP": {
          "label": "Ισχίο",
          "description": "FABER, FADIR, Trendelenburg, δοκιμή Thomas και 8 άλλες."
        },
        "KNEE": {
          "label": "Γόνατο",
          "description": "Lachman, anterior drawer, McMurray, valgus/varus stress και 15 άλλες."
        },
        "ANKLE_FOOT": {
          "label": "Αστράγαλος / Πόδι",
          "description": "Anterior drawer, talar tilt, Thompson, δοκιμές συνδεσμώσεως και άλλες."
        },
        "DIZZINESS": {
          "label": "Ζάλη",
          "description": "Dix-Hallpike, αιθουσαία οφθαλμοκινητική διαλογή (VOMS), αυχενική διαλογή."
        },
        "PAEDIATRIC": {
          "label": "Παιδιατρική",
          "description": "26 ειδικές παιδιατρικές διαλογές που καλύπτουν βάδιση, στάση, υπερευλυγισία αρθρώσεων και αναπτυξιακά ορόσημα."
        }
      }
    },
    "carePathway": {
      "title": "Προεπιλογές Διαδρομής Φροντίδας",
      "description": "Διαμορφώστε τις φάσεις φροντίδας με εύρη συχνότητας και διάρκειας, προρυθμίσεις σοβαρότητας και κανόνες επανεξέτασης.",
      "phaseHeading": "Φάση",
      "phaseName": "Όνομα Φάσης",
      "subtitle": "Υπότιτλος",
      "frequency": "Συχνότητα",
      "frequencyTo": "έως",
      "visitsPer": "επισκέψεις ανά",
      "duration": "Διάρκεια",
      "weeks": "εβδομάδες",
      "ongoing": "Συνεχόμενη",
      "frequencyBlocks": "Μπλοκ Συχνότητας",
      "frequencyBlocksHint": "(προαιρετικό — χρησιμοποιείται για δημιουργία προγράμματος επισκέψεων)",
      "blockThen": "στη συνέχεια",
      "blockFor": "για",
      "addFrequencyBlock": "+ Προσθήκη μπλοκ συχνότητας",
      "goals": "Στόχοι",
      "goalPlaceholder": "Εισάγετε στόχο...",
      "addGoal": "+ Προσθήκη στόχου",
      "patientMessage": "Μήνυμα προς Ασθενή",
      "patientMessagePlaceholder": "Μήνυμα που εμφανίζεται στους ασθενείς στις αναφορές...",
      "remove": "Αφαίρεση",
      "addPhase": "+ Προσθήκη Φάσης",
      "severityPresets": "Προρυθμίσεις Σοβαρότητας",
      "severityMild": "Ήπιο",
      "severityModerate": "Μέτριο",
      "severitySevere": "Σοβαρό",
      "severityFor": "για",
      "severityWk": "εβδ",
      "reExamRules": "Κανόνες Επανεξέτασης",
      "firstReExamAfter": "Πρώτη επανεξέταση μετά από",
      "thenEvery": "Στη συνέχεια κάθε",
      "visits": "επισκέψεις",
      "customRule": "Προσαρμοσμένος Κανόνας (προαιρετικό)",
      "customRulePlaceholder": "π.χ., Πάντα επανεξέταση μετά τις σχολικές διακοπές",
      "terminology": "Προτίμηση Ορολογίας",
      "wellnessCare": "Φροντίδα Ευεξίας",
      "maintenanceCare": "Φροντίδα Διατήρησης",
      "livePreview": "Ζωντανή Προεπισκόπηση",
      "previewLabel": "Προεπισκόπηση",
      "reExam": "Επανεξέταση:",
      "reExamSentence": "Θα ελέγξουμε την πρόοδό σας μετά από {{firstMin}}-{{firstMax}} επισκέψεις, και στη συνέχεια κάθε {{recMin}}-{{recMax}} επισκέψεις.",
      "periodWeek": "εβδομάδα",
      "periodFortnight": "δεκαπενθήμερο",
      "periodMonth": "μήνα"
    },
    "checker": {
      "sectionTitle": "Έλεγχος Συμπτωμάτων",
      "sectionDescription": "Η δημόσια σελίδα ελέγχου συμπτωμάτων για ασθενείς και διαφημιστικές καμπάνιες.",
      "statusLive": "ΖΩΝΤΑΝΟ",
      "statusNotActivated": "Μη Ενεργοποιημένο",
      "preview": "Προεπισκόπηση",
      "copy": "Αντιγραφή",
      "copied": "Αντιγράφηκε!",
      "adCampaignTitle": "URL Διαφημιστικής Καμπάνιας",
      "adCampaignDescription": "Χρησιμοποιήστε αυτά τα URL στις διαφημίσεις σας στο Facebook, Google και Instagram για να κατευθύνετε τους ασθενείς στον ελεγκτή συμπτωμάτων με τη σωστή γλώσσα και περιοχή σώματος.",
      "enableAtLeastOne": "Ενεργοποιήστε τουλάχιστον μία γλώσσα στην Προσαρμογή Ελεγκτή παρακάτω.",
      "baseUrl": "URL Βάσης",
      "copyAll": "Αντιγραφή Όλων",
      "regionLumbar": "Πόνος στην Πλάτη",
      "regionCervical": "Πόνος στον Αυχένα",
      "regionShoulder": "Ώμος",
      "regionKnee": "Γόνατο",
      "customisationTitle": "Προσαρμογή Ελεγκτή",
      "customisationDescription": "Διαμορφώστε γλώσσες, επιλογές εμφάνισης και παρακολούθηση για τον ελεγκτή συμπτωμάτων.",
      "languages": "Γλώσσες",
      "defaultLanguage": "Προεπιλεγμένη Γλώσσα",
      "displayOptions": "Επιλογές Εμφάνισης",
      "showConfidence": "Εμφάνιση βαθμολογίας εμπιστοσύνης",
      "showClinicalTerms": "Εμφάνιση κλινικών όρων",
      "showShareButton": "Εμφάνιση κουμπιού κοινοποίησης",
      "showDisclaimer": "Εμφάνιση δήλωσης αποποίησης",
      "customDisclaimer": "Προσαρμοσμένη Δήλωση Αποποίησης",
      "customDisclaimerPlaceholder": "Αφήστε κενό για χρήση της προεπιλεγμένης δήλωσης αποποίησης",
      "whatsappTemplate": "Πρότυπο Μηνύματος WhatsApp",
      "whatsappTemplateHint": "Χρησιμοποιήστε {{conditionPh}} και {{regionPh}} ως κρατούμενες θέσεις.",
      "gaId": "ID Google Analytics",
      "fbPixelId": "ID Facebook Pixel",
      "bookingButtonsTitle": "Κουμπιά Κράτησης",
      "bookingButtonsDescription": "Επιλέξτε ποια κουμπιά επικοινωνίας θα εμφανίζονται στη σελίδα αποτελεσμάτων του ελεγκτή.",
      "showBookOnline": "Εμφάνιση κουμπιού \"Online Κράτηση\"",
      "showBookOnlineNoUrl": "Εμφάνιση κουμπιού \"Online Κράτηση\" (δεν έχει οριστεί URL κράτησης)",
      "showWhatsapp": "Εμφάνιση κουμπιού \"WhatsApp\"",
      "showWhatsappNoNumber": "Εμφάνιση κουμπιού \"WhatsApp\" (δεν έχει οριστεί αριθμός WhatsApp)",
      "showCall": "Εμφάνιση κουμπιού \"Κλήση\"",
      "showCallNoPhone": "Εμφάνιση κουμπιού \"Κλήση\" (δεν έχει οριστεί αριθμός τηλεφώνου)",
      "usageTitle": "Χρήση",
      "usageLoading": "Φόρτωση δεδομένων χρήσης...",
      "usageUnableToLoad": "Αδυναμία φόρτωσης δεδομένων χρήσης.",
      "usageChecksThisMonth": "έλεγχοι αυτόν τον μήνα",
      "usageUnlimited": "(Απεριόριστο)",
      "saveButton": "Αποθήκευση Ρυθμίσεων Ελεγκτή",
      "saving": "Αποθήκευση..."
    },
    "reportPreferences": {
      "title": "Προτιμήσεις Αναφορών & Επιστολών Γενικού Ιατρού",
      "description": "Διαμορφώστε το περιεχόμενο αναφορών, τις γλώσσες και τη μορφοποίηση επιστολών Γενικού Ιατρού.",
      "reportLanguages": "Γλώσσες Αναφορών",
      "defaultReportLanguage": "Προεπιλεγμένη Γλώσσα Αναφοράς",
      "reportContentHeading": "Περιεχόμενο Αναφοράς Ασθενούς",
      "includeTeam": "Συμπερίληψη ενότητας ομάδας",
      "includeStatistics": "Συμπερίληψη ενότητας στατιστικών/έρευνας",
      "includeSupplements": "Συμπερίληψη ενότητας συμπληρωμάτων",
      "includeExercises": "Συμπερίληψη προγράμματος ασκήσεων",
      "commonReferralSpecialists": "Συχνοί Ειδικοί Παραπομπής (ένας ανά γραμμή)",
      "commonReferralSpecialistsPlaceholder": "Ορθοπεδικός Χειρουργός\nΝευρολόγος\nΡευματολόγος"
    },
    "navAuditLog": "Αρχείο Ελέγχου",
    "navPrivacy": "Δεδομένα & Απόρρητο",
    "navSecurity": "Ασφάλεια",
    "frontDeskModule": "Υποδοχή",
    "frontDeskModuleDesc": "Συμφωνία κρατήσεων, ουρές επαναπρογραμματισμού και μη προσελεύσεων, επιβεβαιώσεις και παράδοση βάρδιας. Ο συγχρονισμός ραντεβού συνεχίζεται είτε είναι ενεργό είτε όχι.",
    "practiceHub": "PracticeHub",
    "practiceHubDesc": "Συγχρονισμός ασθενών και διαχείριση εγγράφων. Τα ραντεβού και οι καρτέλες ασθενών αντλούνται από τον λογαριασμό σας στο PracticeHub.",
    "enablePracticeHub": "Ενεργοποίηση συγχρονισμού PracticeHub",
    "phBaseUrl": "Βασική διεύθυνση URL PracticeHub",
    "phApiKey": "Κλειδί API",
    "phApiKeyPlaceholder": "Εισαγάγετε κλειδί API",
    "phApiKeyFingerprint": "Αποτύπωμα κλειδιού: {{fp}} — αφήστε το κενό για να διατηρηθεί",
    "phApiKeyIsV3": "Αυτό είναι κλειδί του νέου API (phk_). Το MSK Insight δεν χρησιμοποιεί ακόμη τέτοια κλειδιά· κρατήστε το για την επερχόμενη σύνδεση v3.",
    "phSavedKeyAccepted": "Αποθηκεύτηκε — το PracticeHub δέχτηκε το κλειδί ({{patients}} καρτέλες ασθενών ορατές).",
    "phSavedKeyRefused": "Αποθηκεύτηκε, αλλά το PracticeHub το απέρριψε. Βεβαιωθείτε ότι αντιγράψατε ολόκληρο το κλειδί από το PracticeHub.",
    "phSavedKeyRateLimited": "Αποθηκεύτηκε, αλλά το PracticeHub περιορίζει τα αιτήματα αυτή τη στιγμή. Πατήστε Δοκιμή σύνδεσης σε λίγα λεπτά.",
    "phSavedKeyUntested": "Αποθηκεύτηκε, αλλά δεν ήταν δυνατή η σύνδεση με το PracticeHub για έλεγχο. Πατήστε Δοκιμή σύνδεσης.",
    "phAppDetails": "Στοιχεία εφαρμογής",
    "phAppDetailsHint": "Το όνομα εφαρμογής που εμφανίζει το PracticeHub για αυτή τη σύνδεση.",
    "savePracticeHubConfig": "Αποθήκευση ρυθμίσεων PracticeHub",
    "phTestOk": "Συνδέθηκε — ορατές {{patients}} καρτέλες ασθενών.",
    "phTestOkNoCount": "Συνδέθηκε.",
    "phTestFailed": "Η δοκιμή σύνδεσης απέτυχε",
    "phSaved": "Οι ρυθμίσεις PracticeHub αποθηκεύτηκαν.",
    "phSaveFailed": "Η αποθήκευση των ρυθμίσεων PracticeHub απέτυχε."
  },
  "audit": {
    "title": "Αρχείο Ελέγχου",
    "dateFrom": "Ημερομηνία Από",
    "dateTo": "Ημερομηνία Έως",
    "user": "Χρήστης",
    "searchByName": "Αναζήτηση με όνομα...",
    "action": "Ενέργεια",
    "entity": "Οντότητα",
    "applyFilters": "Εφαρμογή Φίλτρων",
    "recordsFound": "{{count}} εγγραφή(-ες) βρέθηκε(-αν)",
    "noEntries": "Δεν βρέθηκαν εγγραφές αρχείου ελέγχου που να ταιριάζουν με τα τρέχοντα φίλτρα.",
    "table": {
      "timestamp": "Χρονοσφραγίδα",
      "user": "Χρήστης",
      "action": "Ενέργεια",
      "entity": "Οντότητα",
      "details": "Λεπτομέρειες"
    },
    "page": "Σελίδα {{current}} από {{total}}",
    "actions": {
      "all": "Όλες οι Ενέργειες",
      "create": "Δημιουργία",
      "read": "Ανάγνωση",
      "update": "Ενημέρωση",
      "delete": "Διαγραφή",
      "login": "Σύνδεση",
      "logout": "Αποσύνδεση",
      "export": "Εξαγωγή",
      "consent": "Συγκατάθεση"
    },
    "entities": {
      "all": "Όλες οι Οντότητες",
      "patient": "Ασθενής",
      "assessment": "Αξιολόγηση",
      "user": "Χρήστης",
      "consent": "Συγκατάθεση",
      "report": "Αναφορά",
      "referral": "Παραπομπή"
    }
  },
  "gdpr": {
    "title": "GDPR & Απόρρητο Δεδομένων",
    "description": "Διαχειριστείτε τα δικαιώματα δεδομένων ασθενών συμπεριλαμβανομένης της εξαγωγής, διαγραφής και ανωνυμοποίησης σύμφωνα με τον GDPR.",
    "findPatient": "Εύρεση Ασθενούς",
    "searchPlaceholder": "Αναζήτηση με όνομα, email ή αναγνωριστικό ασθενούς...",
    "searching": "Αναζήτηση...",
    "selectedPatient": "Επιλεγμένος Ασθενής",
    "dataExport": "Εξαγωγή Δεδομένων",
    "exportDesc": "Εξαγωγή όλων των δεδομένων ασθενούς ως αρχείο JSON. Αυτό περιλαμβάνει προσωπικές πληροφορίες, αξιολογήσεις, συγκαταθέσεις και κλινικά αρχεία.",
    "exporting": "Εξαγωγή...",
    "exportButton": "Εξαγωγή Δεδομένων Ασθενούς (JSON)",
    "rightToForget": "Δικαίωμα στη Λήθη",
    "rightToForgetDesc": "Οριστική διαγραφή όλων των δεδομένων ασθενούς. Αυτή η ενέργεια είναι μη αναστρέψιμη και θα προγραμματιστεί με περίοδο χάριτος.",
    "requestDeletion": "Αίτηση Διαγραφής Δεδομένων",
    "typeDeleteConfirm": "Πληκτρολογήστε DELETE για επιβεβαίωση οριστικής διαγραφής:",
    "processing": "Επεξεργασία...",
    "confirmDelete": "Επιβεβαίωση Διαγραφής",
    "anonymization": "Ανωνυμοποίηση",
    "anonymizationDesc": "Αφαίρεση προσωπικών αναγνωριστικών διατηρώντας κλινικά δεδομένα για ερευνητικούς και αναλυτικούς σκοπούς.",
    "anonymizeButton": "Ανωνυμοποίηση Δεδομένων Ασθενούς",
    "anonymizeWarning": "Αυτό θα αφαιρέσει όλα τα προσωπικά αναγνωριστικά. Τα κλινικά δεδομένα θα διατηρηθούν ανώνυμα.",
    "confirmAnonymize": "Επιβεβαίωση Ανωνυμοποίησης",
    "consentOverview": "Επισκόπηση Συγκατάθεσης Επεξεργασίας Δεδομένων",
    "noConsent": "Δεν βρέθηκαν εγγραφές συγκατάθεσης για αυτόν τον ασθενή.",
    "consentTable": {
      "type": "Τύπος Συγκατάθεσης",
      "status": "Κατάσταση",
      "lastUpdated": "Τελευταία Ενημέρωση"
    }
  },
  "wizard": {
    "stepNames": {
      "1": "Κύρια Ενοχλήματα",
      "2": "Ιατρικό Ιστορικό",
      "3": "Φυσική Εξέταση",
      "4": "Ανάλυση Στάσης",
      "5": "Εξετάσεις",
      "6": "Μέτρα Αποτελέσματος",
      "7": "Ανασκόπηση DDx",
      "8": "Σχέδιο Διαχείρισης",
      "9": "Δημιουργία Αναφοράς"
    },
    "fullAssessment": "Πλήρης Αξιολόγηση",
    "quickScore": "Γρήγορη Βαθμολόγηση",
    "reExamination": "Επανεξέταση",
    "stepOf": "Βήμα {{current}} από {{total}}",
    "paediatric": "Παιδιατρικό",
    "finalized": "Οριστικοποιημένο",
    "savedAt": "Αποθηκεύτηκε {{time}}",
    "saveAndExit": "Αποθήκευση & Έξοδος",
    "aiAnalysingImages": "AI αναλύει {{count}} εικόνα",
    "saveAndContinueTo": "Αποθήκευση & Συνέχεια σε {{stepName}} →",
    "saveAndContinue": "Αποθήκευση & Συνέχεια →",
    "previousSection": "← Προηγούμενη Ενότητα",
    "completeAssessment": "Ολοκλήρωση Αξιολόγησης",
    "optional": "Προαιρετικό",
    "loadingAssessment": "Φόρτωση αξιολόγησης…",
    "goBack": "Επιστροφή",
    "noPatientSelected": "Δεν επιλέχθηκε ασθενής. Ξεκινήστε αξιολόγηση από το προφίλ του ασθενούς.",
    "viewPatients": "Προβολή Ασθενών",
    "saveAsDraft": "Αποθήκευση ως Πρόχειρο — Η Υποδοχή θα Ολοκληρώσει",
    "continueToReport": "Συνέχεια στη Δημιουργία Αναφοράς →",
    "finalizeReport": "Οριστικοποίηση Αναφοράς",
    "finalizeReady": "Όταν όλες οι ενότητες είναι έτοιμες, οριστικοποιήστε την αναφορά για να την σημειώσετε ως ολοκληρωμένη.",
    "reportFinalized": "Η αναφορά οριστικοποιήθηκε και είναι έτοιμη για τον ασθενή.",
    "step": "Βήμα",
    "of": "από",
    "stepComingSoon": "Βήμα {{step}} — το περιεχόμενο έρχεται σύντομα.",
    "saveDraft": "Αποθήκευση Πρόχειρου",
    "validation": {
      "complaintsRequired": "Παρακαλώ προσθέστε τουλάχιστον ένα ενόχλημα πριν συνεχίσετε."
    },
    "finalizeErrorTitle": "Η οριστικοποίηση δεν ολοκληρώθηκε.",
    "finalizeAlreadyIssued": "Αυτή η αναφορά έχει ήδη εκδοθεί. Ανοίξτε την ξανά για τροποποίηση ώστε να δημοσιευτεί νέα έκδοση.",
    "finalizeNotAuthor": "Μόνο ο κλινικός που εξέδωσε αυτή την αναφορά μπορεί να την τροποποιήσει.",
    "finalizeFailed": "Δεν αποθηκεύτηκε τίποτα. Παρακαλώ δοκιμάστε ξανά.",
    "noFrequency": {
      "title": "Δεν έχει οριστεί συχνότητα θεραπείας",
      "body": "Αυτό το πλάνο δεν έχει μπλοκ συχνότητας θεραπείας, οπότε η αναφορά δεν θα έχει πρόγραμμα επισκέψεων.",
      "applyDefault": "Εφαρμογή {{preset}} και ολοκλήρωση",
      "completeAnyway": "Ολοκλήρωση χωρίς πλάνο συχνότητας",
      "presetMissing": "Το προεπιλεγμένο πρότυπο δεν φορτώθηκε — ορίστε τη συχνότητα στο βήμα Πλάνο Διαχείρισης.",
      "lowVisitsTitle": "Ενεργές επισκέψεις στο πλάνο: {{count}}. Να εκδοθεί ούτως ή άλλως;",
      "lowVisitsBody": "Ένα τόσο σύντομο πλάνο δεν αποτελεί κύκλο θεραπείας, επομένως η αναφορά δεν θα δίνει εκτιμώμενο χρόνο ολοκλήρωσης. Μπορείτε πρώτα να εφαρμόσετε ένα πρότυπο ή να εκδώσετε την αναφορά ως έχει.",
      "noPresetTitle": "Δεν εφαρμόστηκε πρότυπο σε αυτό το πλάνο. Να εκδοθεί ούτως ή άλλως;",
      "noPresetBody": "Χωρίς πρότυπο, η αναφορά δεν θα δίνει εκτιμώμενο χρόνο ολοκλήρωσης. Μπορείτε πρώτα να εφαρμόσετε το προεπιλεγμένο πρότυπο της κλινικής ή να εκδώσετε την αναφορά ως έχει.",
      "issueAnyway": "Έκδοση ούτως ή άλλως"
    }
  },
  "patientReport": {
    "dear": "Αγαπητέ/ή",
    "introP1": "Σας ευχαριστούμε που επιλέξατε το {{clinicName}} για τη φροντίδα σας. Μετά την ολοκληρωμένη αξιολόγησή σας, είμαστε στην ευχάριστη θέση να μοιραστούμε μαζί σας αυτή την εξατομικευμένη αναφορά. Εξηγεί τι βρήκαμε, πώς σκοπεύουμε να σας βοηθήσουμε και τι μπορείτε να κάνετε στο σπίτι για να υποστηρίξετε την ανάρρωσή σας. Θέλουμε να αισθάνεστε σίγουροι και ενημερωμένοι σε κάθε βήμα.",
    "introP2": "Στόχος μας δεν είναι απλώς να σας βοηθήσουμε να αισθανθείτε καλύτερα, αλλά να παραμείνετε καλύτερα. Είμαστε εδώ για να σας υποστηρίξουμε σε κάθε στάδιο της θεραπευτικής σας πορείας.",
    "whatWeFound": "Τι Βρήκαμε",
    "aiSummaryTitle": "Η Περίληψη της Επίσκεψής σας",
    "whatWeFoundIntro": "Με βάση το ιστορικό και την εξέτασή σας, τα ευρήματα είναι περισσότερο συμβατά με τις ακόλουθες υποθέσεις εργασίας. Αυτές περιγράφουν μοτίβα που μπορεί να συμβάλλουν στα συμπτώματά σας· δεν επιβεβαιώνουν μία συγκεκριμένη δομή ως την ακριβή πηγή του πόνου και μπορεί να αναθεωρηθούν καθώς παρακολουθούμε την πρόοδό σας ή λαμβάνουμε νέες πληροφορίες. Το πλάνο φροντίδας σας καθοδηγείται από τα συμπτώματα, τη λειτουργικότητα, τα ευρήματα της εξέτασης, τους στόχους και την ανταπόκρισή σας στη φροντίδα, και όχι μόνο από την ονομασία. Όπου ενδείκνυται, θα συστήσουμε επίσης ιατρική αξιολόγηση ή περαιτέρω διερεύνηση.",
    "whatIsIt": "Τι είναι;",
    "howDoesItHappen": "Πώς προκαλείται;",
    "whatCanBeDone": "Τι μπορεί να γίνει;",
    "whatToExpect": "Τι να περιμένετε;",
    "whatDoesThisMean": "Τι σημαίνει αυτό;",
    "reExamDisclaimer": "Η έρευνα υποδεικνύει τυπικά χρονικά πλαίσια αποκατάστασης και συχνότητες θεραπείας για αυτές τις παθήσεις. Προτιμούμε να προχωρήσουμε με το προτεινόμενο πλάνο και να επανεξετάσουμε την πρόοδό σας κατά τη διάρκεια. Αυτές οι επανεξετάσεις μας βοηθούν να συγκρίνουμε πώς ήσασταν, πώς είστε, και να αποφασίσουμε πώς θα συνεχίσουμε μαζί.",
    "yourProgress": "Η Πρόοδός Σας",
    "yourTreatmentPlan": "Το Θεραπευτικό Σας Πλάνο",
    "treatmentPlanIntro": "Η θεραπεία σας είναι δομημένη σε φάσεις, καθεμία σχεδιασμένη να χτίζει πάνω στην πρόοδο της προηγούμενης. Σκεφτείτε το ως ένα ταξίδι από την ανακούφιση του πόνου, μέσω της αποκατάστασης, προς τη μακροχρόνια ευεξία.",
    "expectedDuration": "Αναμενόμενη Διάρκεια",
    "treatmentsConcurrent": "(οι θεραπείες για όλες τις παθήσεις εκτελούνται παράλληλα)",
    "phase": "Φάση",
    "duration": "Διάρκεια",
    "weeks": "εβδομάδες",
    "frequency": "Συχνότητα",
    "phaseTableStage": "Στάδιο φροντίδας",
    "phaseTableCondition": "Πάθηση",
    "phaseTableFocus": "Εστίαση",
    "phaseTableCadenceNote": "Η συχνότητα των επισκέψεων εμφανίζεται στο πρόγραμμα συχνότητας θεραπείας παρακάτω.",
    "techniques": "Τεχνικές",
    "goals": "Στόχοι",
    "goldenRulesTitle": "Οι Χρυσοί Σας Κανόνες",
    "goldenRulesIntro": "Αυτά είναι τα βασικά πράγματα που πρέπει να θυμάστε μεταξύ των ραντεβού. Η τήρηση αυτών των οδηγιών θα σας βοηθήσει να πετύχετε τα καλύτερα δυνατά αποτελέσματα από τη θεραπεία σας.",
    "doNow": "Κάντε Τώρα",
    "thingsToAvoid": "Πράγματα προς Αποφυγή",
    "lifestyleChanges": "Αλλαγές Τρόπου Ζωής",
    "homeCareTitle": "Συμβουλές Φροντίδας στο Σπίτι",
    "supplementsTitle": "Προτεινόμενα Συμπληρώματα",
    "supplementsIntro": "Αυτά τα συμπληρώματα προτείνονται βάσει της αξιολόγησής σας για την υποστήριξη της ανάρρωσής σας. Συμβουλευτείτε τον γενικό σας γιατρό ή τον φαρμακοποιό σας πριν ξεκινήσετε νέα συμπληρώματα, ιδίως εάν λαμβάνετε φαρμακευτική αγωγή.",
    "supplement": "Συμπλήρωμα",
    "yourWellnessScore": "Η Βαθμολογία Σωματικής Απόδοσής Σας",
    "wellnessScoreIntro": "Η Βαθμολογία Σωματικής Απόδοσής σας αντικατοπτρίζει πολλαπλές πτυχές της μυοσκελετικής σας υγείας. Το παρακάτω διάγραμμα δείχνει πώς βαθμολογείται κάθε τομέας — θα παρακολουθούμε την πρόοδό σας σε κάθε επανεξέταση.",
    "overallScore": "Συνολική Βαθμολογία",
    "scoreExcellent": "Εξαιρετικά — συνεχίστε την καλή δουλειά!",
    "scoreGood": "Καλά — με στοχευμένη φροντίδα μπορείτε να φτάσετε στο καλύτερό σας.",
    "scoreFair": "Μέτρια — υπάρχουν περιθώρια βελτίωσης και το πλάνο μας είναι σχεδιασμένο να βοηθήσει.",
    "scoreNeedsAttention": "Χρειάζεται προσοχή — το θεραπευτικό μας πλάνο στοχεύει τους τομείς που χρειάζονται τη μεγαλύτερη βοήθεια.",
    "exercisesTitle": "Προτεινόμενες Ασκήσεις",
    "exerciseSets": "σετ",
    "exerciseReps": "επαναλήψεις",
    "exerciseHold": "κράτημα",
    "exerciseSec": "δευτ.",
    "whyOngoingCare": "Γιατί η Συνεχής Φροντίδα Είναι Σημαντική",
    "ongoingCareP1": "Η έρευνα δείχνει σταθερά ότι οι ασθενείς που ολοκληρώνουν πλήρως τη θεραπεία τους — συμπεριλαμβανομένης της φάσης ευεξίας — παρουσιάζουν σημαντικά καλύτερα μακροπρόθεσμα αποτελέσματα. Η διακοπή της θεραπείας όταν ο πόνος υποχωρήσει μοιάζει με τη διακοπή αντιβιοτικών στη μέση: τα συμπτώματα μπορεί να έχουν φύγει, αλλά το υποκείμενο πρόβλημα δεν έχει αποκατασταθεί πλήρως.",
    "ongoingCareP2": "Η θεραπευτική σας πορεία:",
    "carePhase1": "Φροντίδα Ανακούφισης — Μείωση πόνου και φλεγμονής",
    "carePhase2": "Αποκατάσταση — Επαναφορά δύναμης και λειτουργικότητας",
    "carePhase3": "Φροντίδα Ευεξίας — Υποστήριξη μακροπρόθεσμης κίνησης, λειτουργικότητας και αυτοδιαχείρισης",
    "ongoingCareP3": "Οι ασθενείς που ολοκληρώνουν και τη φάση ευεξίας μπορεί να εμφανίσουν λιγότερες υποτροπές. Συνιστούμε θερμά την ολοκλήρωση όλων των φάσεων της θεραπείας σας.",
    "yourCareTeam": "Η Θεραπευτική Σας Ομάδα",
    "careTeamIntro": "Είστε σε εξαιρετικά χέρια. Η ομάδα μας από έμπειρους επαγγελματίες είναι αφοσιωμένη στο να σας βοηθήσει να πετύχετε το καλύτερο δυνατό αποτέλεσμα.",
    "nextSteps": "Επόμενα Βήματα",
    "nextStepsIntro": "Είστε έτοιμοι να ξεκινήσετε το ταξίδι σας προς καλύτερη υγεία; Κλείστε το επόμενο ραντεβού σας σήμερα.",
    "phone": "Τηλέφωνο",
    "email": "Email",
    "website": "Ιστοσελίδα",
    "instagram": "Instagram",
    "footer": "Αυτή η αναφορά παρέχεται για ενημερωτικούς σκοπούς στο πλαίσιο του θεραπευτικού σας πλάνου. Οι αναφερόμενες παθήσεις αποτελούν εργαζόμενες υποθέσεις μόνο για κλινική εξέταση και δεν πρέπει να εκληφθούν ως οριστικές διαγνώσεις. Παρακαλούμε συζητήστε οποιαδήποτε ανησυχία με τον θεράποντα κλινικό σας.",
    "footerOneLine": "Ενημερωτική σύνοψη — οι αναφερόμενες παθήσεις είναι εργαζόμενες υποθέσεις για κλινική εξέταση, όχι οριστικές διαγνώσεις. Συζητήστε τυχόν ανησυχίες με τον θεράποντά σας.",
    "cta": {
      "whatsappLabel": "WhatsApp",
      "whatsappPrefix": "Στείλτε μας μήνυμα στο WhatsApp:",
      "referTitle": "Συστήστε μας",
      "referHeading": "Γνωρίζετε κάποιον που θα μπορούσε να επωφεληθεί από τη φροντίδα μας;",
      "referLine1": "Θα χαρούμε να βοηθήσουμε και την οικογένεια και τους φίλους σας.",
      "referLine2": "Αν γνωρίζετε κάποιον που θα μπορούσε να επωφεληθεί, θα είναι τιμή μας να τον υποδεχτούμε.",
      "referShare": "Μοιραστείτε",
      "googleReviewCtaTitle": "Βοηθήστε άλλους να μας βρουν",
      "googleReviewCtaBody": "Εάν σας βοηθήσαμε, σκεφτείτε να αφήσετε μια κριτική 5 αστέρων στο Google. Διαρκεί 30 δευτερόλεπτα και βοηθά άλλους να βρουν ποιοτική φροντίδα.",
      "googleReviewCtaButton": "Αφήστε κριτική στο Google"
    }
  },
  "preview": {
    "tabs": {
      "clinician": "Κλινικός",
      "patient": "Ασθενής"
    }
  },
  "redFlags": {
    "title": "Έλεγχος Κόκκινων Σημαιών",
    "instructions": "Απαντήστε ΝΑΙ ή ΟΧΙ σε κάθε ερώτηση ελέγχου. Ερωτούνται μία φορά για ολόκληρη την αξιολόγηση.",
    "emergencyDetected": "ΑΝΙΧΝΕΥΘΗΚΕ ΙΑΤΡΙΚΗ ΕΚΤΑΚΤΗ ΑΝΑΓΚΗ",
    "emergencyMessage": "Εντοπίστηκαν μία ή περισσότερες ιατρικές εκτάκτες ανάγκες. Ελέγξτε αμέσως και λάβετε τα κατάλληλα μέτρα.",
    "flagsDetected": "Ανιχνεύθηκαν Κόκκινες Σημαίες",
    "emergencyAndFlags": "Ανιχνεύθηκαν Εκτάκτες Ανάγκες & Κόκκινες Σημαίες",
    "emergencyInstruction": "ΣΤΑΜΑΤΗΣΤΕ: Οι σημαίες εκτάκτου ανάγκης πρέπει να αντιμετωπιστούν πριν από οποιαδήποτε κλινική διαδικασία. Όλες οι σημαίες απαιτούν δράση κλινικού πριν τη συνέχεια.",
    "flagsInstruction": "Οι ακόλουθες κόκκινες σημαίες απαιτούν ενέργεια κλινικού πριν τη συνέχεια.",
    "screeningComplete": "Ο έλεγχος κόκκινων σημαιών ολοκληρώθηκε. Δεν υπάρχουν ανησυχίες που απαιτούν άμεση δράση.",
    "backToReview": "← Πίσω στην Ανασκόπηση Ενοχλημάτων",
    "reviewed": "Κόκκινες σημαίες ελέγχθηκαν — χρησιμοποιήστε την πλοήγηση στο κάτω μέρος για να συνεχίσετε",
    "submitting": "Υποβολή...",
    "submitAndContinue": "Υποβολή Ελέγχου & Συνέχεια →"
  },
  "statusBadges": {
    "draft": "Πρόχειρο",
    "in_progress": "Σε Εξέλιξη",
    "clinician_draft": "Αναμένει Υποδοχή",
    "front_desk_review": "Η Υποδοχή Εργάζεται",
    "completed": "Ολοκληρώθηκε",
    "finalized": "Οριστικοποιημένο"
  },
  "carePhases": {
    "initial": "Αρχική",
    "active": "Ενεργή Θεραπεία",
    "maintenance": "Συντήρηση",
    "wellness": "Ευεξία"
  },
  "bodyRegions": {
    "headache": "Κεφαλαλγία",
    "dizziness": "Ζάλη",
    "cervical": "Αυχενική",
    "thoracic": "Θωρακική",
    "lumbar": "Οσφυϊκή",
    "sacral": "Ιερά",
    "shoulder_left": "Αρ. Ώμος",
    "shoulder_right": "Δε. Ώμος",
    "elbow_left": "Αρ. Αγκώνας",
    "elbow_right": "Δε. Αγκώνας",
    "wrist_hand_left": "Αρ. Καρπός",
    "wrist_hand_right": "Δε. Καρπός",
    "hip_left": "Αρ. Ισχίο",
    "hip_right": "Δε. Ισχίο",
    "knee_left": "Αρ. Γόνατο",
    "knee_right": "Δε. Γόνατο",
    "ankle_foot_left": "Αρ. Πόδι",
    "ankle_foot_right": "Δε. Πόδι",
    "tmj": "Κροταφογναθική",
    "growing_pains": "Πόνοι Ανάπτυξης",
    "torticollis": "Ραιβόκρανο"
  },
  "infant": {
    "reportTitle": "Η Αναφορά Υγείας του Μωρού σας",
    "progressUpdate": "Ενημέρωση Προόδου",
    "initialAssessment": "Αρχική Αξιολόγηση",
    "patientLabel": "Ασθενής",
    "ageLabel": "Ηλικία",
    "dateOfBirthLabel": "Ημερομηνία Γέννησης",
    "infantAssessment": "Αξιολόγηση Βρέφους",
    "loadingAssessment": "Φόρτωση αξιολόγησης βρέφους...",
    "assessmentTitle": "Αξιολόγηση Βρέφους (0-12 μηνών)",
    "assessmentDescription": "Ολοκληρωμένος έλεγχος για βρέφη — παρακαλώ συμπληρώστε όλες τις ενότητες για την καλύτερη δυνατή φροντίδα.",
    "completeAndContinue": "Ολοκλήρωση Αξιολόγησης Βρέφους & Συνέχεια",
    "sectionsComplete": "{{completed}} από {{total}} ενότητες ολοκληρώθηκαν",
    "monthsOld": "{{count}} μηνών",
    "oneMonthOld": "1 μηνός",
    "infantLabel": "βρέφος",
    "na": "Δ/Υ",
    "pronouns": {
      "heMale": "αυτός",
      "hisMale": "του",
      "himMale": "τον",
      "HeMale": "Αυτός",
      "HisMale": "Του",
      "heFemale": "αυτή",
      "hisFemale": "της",
      "himFemale": "την",
      "HeFemale": "Αυτή",
      "HisFemale": "Της",
      "heNeutral": "το μωρό",
      "hisNeutral": "του μωρού",
      "himNeutral": "το μωρό",
      "HeNeutral": "Το μωρό",
      "HisNeutral": "Του μωρού"
    },
    "greeting": {
      "dearGuardianWithRel": "Αγαπητέ/ή {{name}} ({{relationship}} του/της {{child}}),",
      "dearGuardian": "Αγαπητέ/ή {{name}},",
      "dearParents": "Αγαπητοί Γονείς,",
      "intro": "Σας ευχαριστούμε που φέρατε τον/την {{child}} για {{visitType}}. Γνωρίζουμε ότι η φροντίδα ενός μωρού φέρνει πολλά ερωτήματα και ανησυχίες, και θέλουμε να ξέρετε ότι είμαστε εδώ για να σας υποστηρίξουμε. Παρακάτω θα βρείτε μια σύνοψη των ευρημάτων μας και τις συστάσεις μας για τη φροντίδα του/της {{child}}.",
      "followUp": "επανεξέταση",
      "assessment": "αξιολόγηση"
    },
    "findings": {
      "title": "Τι Βρήκαμε Σήμερα",
      "howDoesItHappen": "Πώς συμβαίνει αυτό;",
      "whatCanBeDone": "Τι μπορεί να γίνει;",
      "noConcerns": "Δεν εντοπίσαμε κάποια συγκεκριμένη ανησυχία κατά τη σημερινή αξιολόγηση. Ο/Η {{child}} φαίνεται να αναπτύσσεται καλά. Σας παρέχουμε παρακάτω ορισμένες γενικές οδηγίες για την υποστήριξη της ανάπτυξης {{possessive}}.",
      "yourConcerns": "Οι Ανησυχίες Σας",
      "concernsIntro": "Αναφέρατε τις εξής ανησυχίες: {{concerns}}. Τις λάβαμε υπόψη στην αξιολόγηση και τις συστάσεις μας παρακάτω."
    },
    "tummyTime": {
      "title": "Πρόγραμμα Μπρούμυτα",
      "forChild": "Για τον/την {{child}} ({{age}}): {{minutes}}, {{frequency}}",
      "importance": "Ο χρόνος μπρούμυτα είναι η πιο σημαντική δραστηριότητα για τη σωματική ανάπτυξη του μωρού σας. Ενδυναμώνει τον αυχένα, τους ώμους και τους μύες του κορμού που χρειάζονται για κύλισμα, κάθισμα και μπουσούλημα.",
      "minutes1": "3–5 λεπτά",
      "frequency1": "2–3 φορές την ημέρα",
      "tip1_1": "Ξεκινήστε με μπρούμυτα στο στήθος σας ενώ είστε ξαπλωμένοι",
      "tip1_2": "Τοποθετήστε το μωρό σε σταθερή επιφάνεια με μια μικρή πετσέτα κάτω από το στήθος του",
      "tip1_3": "Μείνετε κοντά και μιλήστε ή τραγουδήστε για να κρατήσετε το μωρό ενεργό",
      "tip1_4": "Σταματήστε αν το μωρό δυσανασχετεί και δοκιμάστε ξανά αργότερα",
      "minutes2": "10–15 λεπτά",
      "frequency2": "3–4 φορές την ημέρα",
      "tip2_1": "Χρησιμοποιήστε ένα χαλάκι παιχνιδιού με πολύχρωμα παιχνίδια στο ύψος των ματιών",
      "tip2_2": "Τοποθετήστε έναν μικρό καθρέφτη μπροστά από το μωρό για να ενθαρρύνετε το σήκωμα του κεφαλιού",
      "tip2_3": "Δοκιμάστε μπρούμυτα στα πόδια σας για εναλλαγή",
      "tip2_4": "Στηρίξτε το μωρό πάνω σε τυλιγμένη πετσέτα ή μαξιλάρι θηλασμού κάτω από το στήθος του",
      "minutes3": "20–30 λεπτά",
      "frequency3": "4–5 φορές την ημέρα",
      "tip3_1": "Τοποθετήστε παιχνίδια σε ημικύκλιο για να ενθαρρύνετε τεντώματα και στροφές",
      "tip3_2": "Αφήστε το μωρό να παίζει μπρούμυτα κατά τη διάρκεια ελεύθερου παιχνιδιού στο πάτωμα",
      "tip3_3": "Δοκιμάστε στήριξη στα αντιβράχια για ενδυνάμωση του άνω σώματος",
      "tip3_4": "Ενθαρρύνετε το κύλισμα τοποθετώντας παιχνίδια λίγο πιο μακριά σε μία πλευρά",
      "minutes4": "30+ λεπτά",
      "frequency4": "Καθ' όλη τη διάρκεια της ημέρας κατά το παιχνίδι",
      "tip4_1": "Αφήστε το μωρό να εξερευνά ελεύθερα στο πάτωμα σε ασφαλή χώρο",
      "tip4_2": "Ενθαρρύνετε το μπουσούλημα τοποθετώντας παιχνίδια σε απόσταση",
      "tip4_3": "Υποστηρίξτε τη στάση και τη βάδιση κατά μήκος επίπλων",
      "tip4_4": "Συνεχίστε το παιχνίδι στο πάτωμα ως κύρια δραστηριότητα"
    },
    "headShape": {
      "title": "Συμβουλές για το Σχήμα του Κεφαλιού",
      "alternateCot": "Εναλλάσσετε την κατεύθυνση που κοιτάζει ο/η {{child}} στο κρεβάτι κάθε βράδυ",
      "encourageLook": "Ενθαρρύνετε τον/την {{child}} να κοιτάζει προς τη μη επίπεδη πλευρά κατά τη διάρκεια του παιχνιδιού",
      "minimiseFlat": "Ελαχιστοποιήστε τον χρόνο σε επίπεδες επιφάνειες — χρησιμοποιήστε μάρσιπο ή κρατήστε τον/την {{child}} όρθιο/α",
      "continueTummy": "Συνεχίστε τον χρόνο μπρούμυτα υπό επίβλεψη ως την καλύτερη αγωγή για τα επίπεδα σημεία",
      "noSleepChange": "ΜΗΝ αλλάζετε τη θέση ύπνου — τοποθετείτε πάντα τον/την {{child}} ανάσκελα για ύπνο",
      "reassurance": "Οι περισσότερες αλλαγές στο σχήμα του κεφαλιού βελτιώνονται σημαντικά καθώς το μωρό σας αποκτά έλεγχο κεφαλιού και περνά λιγότερο χρόνο ξαπλωμένο."
    },
    "feeding": {
      "title": "Οδηγίες Σίτισης",
      "sidePreference": "Ο/Η {{child}} προτιμά τη σίτιση από τη μία πλευρά. Δοκιμάστε να εναλλάσσετε πλευρές σε κάθε γεύμα για να ενθαρρύνετε ομοιόμορφη κίνηση αυχένα. Αν {{pronoun}} αντιστέκεται, δοκιμάστε διαφορετική θέση σίτισης (π.χ. κράτημα μπάλας) στη λιγότερο προτιμώμενη πλευρά.",
      "difficultyLatching": "Σημειώθηκε δυσκολία στο πιάσιμο — εξετάστε τη συμβουλή ειδικού γαλουχίας αν αυτό επιμένει.",
      "fussesDuringFeeds": "Ο/Η {{child}} ανησυχεί κατά τη σίτιση — αυτό μπορεί να σχετίζεται με παλινδρόμηση ή δυσφορία. Δοκιμάστε μικρότερα, πιο συχνά γεύματα.",
      "archesBack": "Το τόξωμα της πλάτης κατά τη σίτιση μπορεί να υποδηλώνει παλινδρόμηση. Κρατήστε τον/την {{child}} πιο όρθια κατά τη διάρκεια και μετά τη σίτιση.",
      "fallsAsleep": "Αν ο/η {{child}} αποκοιμιέται γρήγορα κατά τη σίτιση, δοκιμάστε ήπια διέγερση (γαργαλήστε τα πόδια, δροσερό πανί) για να ενθαρρύνετε μεγαλύτερης διάρκειας σίτιση.",
      "spitsUp": "Το συχνό φτύσιμο είναι φυσιολογικό στα μωρά. Κρατήστε τον/την {{child}} όρθια για 20–30 λεπτά μετά τη σίτιση.",
      "refluxTitle": "Συμβουλές Διαχείρισης Παλινδρόμησης:",
      "reflux1": "Κρατήστε όρθια για 20–30 λεπτά μετά κάθε γεύμα",
      "reflux2": "Προσφέρετε μικρότερα, πιο συχνά γεύματα",
      "reflux3": "Κάντε απαλά ρεψίματα κατά τη διάρκεια και μετά τη σίτιση",
      "reflux4": "Ανυψώστε ελαφρά το κεφάλι του κρεβατιού"
    },
    "carrying": {
      "title": "Συμβουλές Μεταφοράς & Κρατήματος",
      "hipHealthy": "Υγιές Κράτημα για τα Ισχία",
      "hipHealthyDesc": "Μεταφέρετε τον/την {{child}} με τα πόδια {{possessive}} ανοιχτά γύρω από τον γοφό σας σε θέση βατράχου. Χρησιμοποιήστε μάρσιπο με πλατιά βάση που στηρίζει τους μηρούς από γόνατο σε γόνατο.",
      "varyPositions": "Εναλλαγή Θέσεων",
      "varyPositionsDesc": "Εναλλάσσετε το χέρι με το οποίο κρατάτε τον/την {{child}}. Δοκιμάστε στροφή προς τα έξω για να ενθαρρύνετε τον/την {{child}} να κοιτάζει γύρω και να δυναμώνει τους μύες του αυχένα.",
      "forTorticollis": "Για Ραιβόκρανο",
      "torticollisDesc": "Μεταφέρετε τον/την {{child}} έτσι ώστε {{pronoun}} να πρέπει να γυρίσει το κεφάλι {{possessive}} προς τη σφιγμένη πλευρά για να σας δει. Όταν ο/η {{child}} είναι στην αγκαλιά σας, τοποθετήστε {{objective}} ώστε τα ενδιαφέροντα πράγματα να είναι στη λιγότερο προτιμώμενη πλευρά {{possessive}}.",
      "forHipDysplasia": "Για Δυσπλασία Ισχίου",
      "hipDysplasiaDesc": "Πάντα μεταφέρετε τον/την {{child}} με τα πόδια ανοιχτά γύρω σας (θέση ιππασίας). Αποφύγετε στενούς μάρσιπους που πιέζουν τα πόδια μαζί. Κατά τη φασκίωση, αφήστε τα πόδια {{possessive}} σε φυσική θέση βατράχου."
    },
    "milestones": {
      "title": "Αναπτυξιακά Ορόσημα",
      "disclaimer": "Κάθε μωρό αναπτύσσεται με τον δικό του ρυθμό. Τα παραπάνω ορόσημα αποτελούν γενικές κατευθυντήριες γραμμές. Αν έχετε ανησυχίες σχετικά με την ανάπτυξη του/της {{child}}, παρακαλούμε συζητήστε τις μαζί μας ή με τον παιδίατρό σας.",
      "notCompleted": "Η παρακολούθηση ορόσημων δεν ολοκληρώθηκε κατά τη σημερινή αξιολόγηση. Παρακαλούμε συζητήστε τυχόν αναπτυξιακές ανησυχίες με τον παιδίατρό σας."
    },
    "carePlan": {
      "title": "Σχέδιο Φροντίδας του/της {{child}}",
      "phase": "Φάση",
      "frequencyLabel": "Συχνότητα:",
      "durationLabel": "Διάρκεια:",
      "goals": "Στόχοι",
      "techniques": "Τεχνικές",
      "visitFrequency": "Συχνότητα Επισκέψεων:"
    },
    "homeAdvice": {
      "title": "Συμβουλές στο Σπίτι",
      "do": "Κάντε",
      "avoid": "Αποφύγετε"
    },
    "redFlags": {
      "title": "Πότε να Επικοινωνήσετε Μαζί Μας ή να Δείτε τον Παιδίατρό σας",
      "urgentTitle": "Αναζητήστε επείγουσα ιατρική φροντίδα αν ο/η {{child}}:",
      "temperature": "Έχει πυρετό πάνω από 38°C (κάτω των 3 μηνών) ή 39°C (πάνω από 3 μηνών)",
      "floppy": "Είναι ασυνήθιστα χαλαρός/ή, νυσταγμένος/η ή μη ανταποκρινόμενος/η",
      "vomiting": "Έχει εκτοξευτικό εμετό ή εμετό με πράσινη χολή",
      "refusesFeeds": "Αρνείται όλα τα γεύματα για περισσότερες από 4–6 ώρες",
      "fontanelle": "Έχει εξογκωμένη πηγή (μαλακό σημείο)",
      "seizure": "Έχει σπασμούς ή ασυνήθιστες κινήσεις",
      "soonerTitle": "Κλείστε νωρίτερα ραντεβού αν:",
      "notImproving": "Η κατάσταση του/της {{child}} δεν φαίνεται να βελτιώνεται",
      "newSymptoms": "Εμφανίζονται νέα συμπτώματα που σας ανησυχούν",
      "changeMovement": "Παρατηρείτε αλλαγή στην κίνηση ή τη συμπεριφορά {{possessive}}",
      "questionsWorries": "Έχετε οποιαδήποτε ερώτηση ή ανησυχία μεταξύ των επισκέψεων"
    },
    "parentNote": {
      "title": "Ένα Σημείωμα για τους Γονείς",
      "bodyWithConditions": "Κατανοούμε ότι η αξιολόγηση ενός μωρού μπορεί να είναι μια αγχωτική εμπειρία. Θέλουμε να γνωρίζετε ότι η κατάσταση του/της {{child}} είναι πολύ συνηθισμένη και ανταποκρίνεται καλά στη φροντίδα και τις συμβουλές που έχουμε περιγράψει. Τα μωρά είναι εκπληκτικά προσαρμοστικά και με την αγάπη σας και τη σωστή καθοδήγηση, τα περισσότερα μυοσκελετικά ζητήματα στη βρεφική ηλικία επιλύονται θαυμάσια. Κάνετε εξαιρετική δουλειά ως γονείς.",
      "bodyNoConditions": "Κατανοούμε ότι η αξιολόγηση ενός μωρού μπορεί να είναι μια αγχωτική εμπειρία. Θέλουμε να γνωρίζετε ότι η ανάπτυξη του/της {{child}} φαίνεται υγιής και είμαστε εδώ για να σας υποστηρίξουμε με οποιαδήποτε ερώτηση. Τα μωρά είναι εκπληκτικά προσαρμοστικά και με την αγάπη σας και τη σωστή καθοδήγηση, τα περισσότερα μυοσκελετικά ζητήματα στη βρεφική ηλικία επιλύονται θαυμάσια. Κάνετε εξαιρετική δουλειά ως γονείς.",
      "contactUs": "Αν ποτέ έχετε ερωτήσεις μεταξύ ραντεβού, μη διστάσετε να επικοινωνήσετε μαζί μας. Καμία ερώτηση δεν είναι πολύ μικρή ή ασήμαντη — πάντα θα προτιμούσαμε να ρωτήσετε παρά να ανησυχείτε."
    },
    "nextSteps": {
      "title": "Επόμενα Βήματα",
      "withFrequency": "Προτείνουμε να δούμε τον/την {{child}} ξανά {{frequency}}.",
      "withoutFrequency": "Θα προγραμματίσουμε την επόμενη επίσκεψη του/της {{child}} με βάση την πρόοδο {{possessive}}.",
      "bookingIntro": "Για να κλείσετε το επόμενο ραντεβού σας ή αν έχετε ερωτήσεις, παρακαλούμε επικοινωνήστε μαζί μας:",
      "scanToBook": "Σαρώστε για κράτηση"
    }
  },
  "exerciseProgram": {
    "title": "Πρόγραμμα Ασκήσεων",
    "homeTitle": "Πρόγραμμα Ασκήσεων για το Σπίτι",
    "generated": "Δημιουργήθηκε",
    "noProgram": "Δεν έχει δημιουργηθεί πρόγραμμα ασκήσεων. Κάντε κλικ στο \"Δημιουργία Προγράμματος\" για εξατομικευμένο πρόγραμμα.",
    "generatePlan": "Δημιουργία Προγράμματος",
    "regenerate": "Αναδημιουργία",
    "generating": "Δημιουργία...",
    "downloading": "Λήψη...",
    "downloadPdf": "Λήψη PDF",
    "generateFailed": "Αποτυχία δημιουργίας προγράμματος ασκήσεων",
    "pdfFailed": "Αποτυχία δημιουργίας PDF ασκήσεων",
    "pdfDownloadFailed": "Αποτυχία λήψης PDF",
    "contraindicationWarnings": "Προειδοποιήσεις Αντενδείξεων",
    "sets": "Σετ",
    "reps": "Επαναλήψεις",
    "hold": "Κράτηση",
    "instructions": "Οδηγίες",
    "guidedExercise": "Καθοδηγούμενη Άσκηση",
    "completed": "Ολοκληρώθηκε",
    "guidedResults": "Αποτελέσματα Καθοδηγούμενων Ασκήσεων",
    "totalExercises": "Σύνολο ασκήσεων",
    "regions": "Περιοχές"
  },
  "consent": {
    "title": "Διαχείριση Συγκατάθεσης",
    "loadingConsents": "Φόρτωση συγκαταθέσεων...",
    "noData": "Δεν υπάρχουν δεδομένα συγκατάθεσης.",
    "viewHistory": "Προβολή Ιστορικού",
    "hideHistory": "Απόκρυψη Ιστορικού",
    "viewText": "Προβολή Κειμένου",
    "hideText": "Απόκρυψη Κειμένου",
    "signConsent": "Υπογραφή Συγκατάθεσης",
    "signing": "Υπογραφή...",
    "revoke": "Ανάκληση",
    "revoking": "Ανάκληση...",
    "signed": "Υπογράφηκε",
    "revoked": "Ανακλήθηκε",
    "consentText": "Κείμενο Συγκατάθεσης",
    "history": "Ιστορικό Συγκατάθεσης",
    "noHistory": "Δεν υπάρχουν καταχωρήσεις ιστορικού.",
    "actionSigned": "υπογράφηκε",
    "actionRevoked": "ανακλήθηκε",
    "by": "από",
    "status": {
      "active": "Ενεργή",
      "not_signed": "Μη Υπογεγραμμένη",
      "revoked": "Ανακληθείσα"
    }
  },
  "imaging": {
    "title": "Μεταφόρτωση Απεικονιστικών",
    "dismiss": "Απόρριψη",
    "dragDrop": "Σύρετε και αποθέστε αρχεία εδώ, ή",
    "browseFiles": "αναζητήστε αρχεία",
    "acceptedFormats": "JPEG, PNG, PDF έως 10MB το καθένα",
    "uploading": "Μεταφόρτωση...",
    "uploadedFiles": "Μεταφορτωμένα Αρχεία",
    "uploaded": "Μεταφορτώθηκε",
    "analyzeWithAI": "Ανάλυση με AI",
    "analyzing": "Το AI αναλύει...",
    "aiAnalysisResults": "Αποτελέσματα Ανάλυσης AI",
    "aiAssistedObservation": "Παρατήρηση με υποστήριξη AI — απαιτείται επαλήθευση κλινικού",
    "analyzed": "Αναλύθηκε",
    "findingsNotConfirmed": "Τα ευρήματα δεν είναι επιβεβαιωμένα μέχρι να τα επαληθεύσετε",
    "findings": "Ευρήματα Απεικόνισης",
    "measurements": "Μετρήσεις",
    "impressions": "Εντυπώσεις",
    "normal": "Φυσιολογικό",
    "reject": "Απόρριψη",
    "review": "Ανασκόπηση Απεικόνισης",
    "comparison": "Σύγκριση Απεικόνισης",
    "overallChange": "Συνολική αλλαγή",
    "improved": "Βελτιωμένο",
    "stable": "Σταθερό",
    "progressed": "Εξελίχθηκε",
    "aiAssisted": "Ανάλυση με τεχνητή νοημοσύνη — ελέγχθηκε και εγκρίθηκε από τον κλινικό",
    "analyzeButton": "Ανάλυση με AI",
    "uploadImage": "Μεταφόρτωση εικόνας",
    "compareButton": "Σύγκριση εικόνων",
    "dateTaken": "Ημερομηνία λήψης",
    "viewSequence": "Προβολή / Σειρά"
  },
  "labResults": {
    "title": "Εργαστηριακά Αποτελέσματα",
    "valuePlaceholder": "Τιμή",
    "normal": "Φυσιολογικό",
    "autoInterpretation": "Αυτόματη Ερμηνεία",
    "savedSuccessfully": "Αποθηκεύτηκε επιτυχώς",
    "saveResults": "Αποθήκευση Αποτελεσμάτων"
  },
  "copilot": {
    "aggravating": "Επιδεινωτικοί",
    "analyze": "Ανάλυση με AI",
    "analyzing": "Ανάλυση αφήγησης...",
    "carePhase": "Συνιστώμενη Φάση Φροντίδας",
    "clarification": "Η AI χρειάζεται διευκρίνιση",
    "close": "Κλείσιμο",
    "complaints": "Ενοχλήματα",
    "confidence": "εμπιστοσύνη",
    "diagnoses": "Διαγνώσεις",
    "expected": "Αναμενόμενο",
    "followUp": "Παρακολούθηση",
    "functionalChanges": "Λειτουργικές Αλλαγές",
    "initial": "Αρχική",
    "initialExam": "Αρχική Εξέταση",
    "language": "Γλώσσα",
    "listening": "Ακούει...",
    "loadingTests": "Λήψη συστάσεων εξετάσεων...",
    "newComplaints": "Νέα Ενοχλήματα",
    "painComparison": "Σύγκριση Πόνου",
    "parsedFindings": "Ευρήματα AI",
    "planUpdates": "Ενημερώσεις Σχεδίου",
    "previousNarrative": "Προηγούμενη αφήγηση:",
    "proceedToTests": "Μετάβαση σε Φυσική Εξέταση →",
    "progressSummary": "Σύνοψη Προόδου",
    "reExamComplete": "Επανεξέταση Ολοκληρώθηκε",
    "reExamSaved": "Όλα τα δεδομένα αποθηκεύτηκαν.",
    "redFlags": "Αναγνωρισμένα Red Flags",
    "relieving": "Ανακουφιστικοί",
    "resolved": "Επιλύθηκε",
    "saveComplete": "Αποθήκευση & Ολοκλήρωση",
    "saving": "Αποθήκευση...",
    "startReExam": "Έναρξη AI Επανεξέτασης",
    "startVoice": "Έναρξη φωνητικής εισόδου",
    "starting": "Εκκίνηση...",
    "stop": "Στοπ",
    "stopVoice": "Στοπ",
    "submitClarification": "Υποβολή & Ανάλυση",
    "submitResults": "Υποβολή & Ενημέρωση DDx",
    "subtitle": "Επανεξέταση",
    "testRationale": "Γιατί αυτές οι εξετάσεις;",
    "testResults": "Αποτελέσματα Εξετάσεων",
    "tests": "εξετάσεις",
    "title": "AI Κλινικός Συνεπίκουρος",
    "typeAnswer": "Πληκτρολογήστε την απάντησή σας...",
    "updatedDiagnoses": "Ενημερωμένες Διαγνώσεις",
    "updatingDdx": "Ενημέρωση διάγνωσης...",
    "voiceNotSupported": "Η φωνητική είσοδος δεν είναι διαθέσιμη. Πληκτρολογήστε τις σημειώσεις σας.",
    "wellnessScores": "Βαθμολογίες Ευεξίας"
  },
  "email": {
    "attachPdf": "Επισύναψη PDF αναφοράς",
    "cancel": "Ακύρωση",
    "language": "Γλώσσα Αναφοράς",
    "patientEmail": "Email Ασθενή",
    "send": "Αποστολή",
    "sendReport": "Αποστολή Αναφοράς",
    "sending": "Αποστολή...",
    "templatePreview": "Προεπισκόπηση Προτύπου"
  },
  "exercises": {
    "title": "Πρόγραμμα Ασκήσεων",
    "current": "Τρέχουσες Ασκήσεις",
    "history": "Ιστορικό Ασκήσεων",
    "addExercise": "Προσθήκη Άσκησης",
    "recommended": "Προτεινόμενες",
    "progress": "Αναβάθμιση",
    "pause": "Παύση",
    "resume": "Συνέχεια",
    "remove": "Αφαίρεση",
    "logSession": "Καταγραφή",
    "logAll": "Καταγραφή Όλων",
    "printSheet": "Εκτύπωση",
    "adherence": "Συμμόρφωση",
    "excellent": "Εξαιρετικό",
    "good": "Καλό",
    "needsImprovement": "Χρειάζεται Βελτίωση",
    "atRisk": "Σε Κίνδυνο",
    "setsCompleted": "Σετ",
    "repsCompleted": "Επαναλήψεις",
    "painDuring": "Πόνος Κατά",
    "painAfter": "Πόνος Μετά",
    "difficulty": "Δυσκολία",
    "tooEasy": "Πολύ Εύκολο",
    "justRight": "Σωστό",
    "tooHard": "Πολύ Δύσκολο",
    "level1": "Αρχάριος",
    "level2": "Μέτριος",
    "level3": "Προχωρημένος",
    "level4": "Αθλητικός",
    "level5": "Ελίτ",
    "activeCare": "Ενεργή Φροντίδα",
    "correctiveCare": "Διορθωτική",
    "maintenance": "Συντήρηση",
    "myObligations": "Το Σώμα Μου οι Υποχρεώσεις Μου",
    "allDoneToday": "Όλα έγιναν σήμερα!",
    "keepGoing": "Συνεχίστε!",
    "greatConsistency": "Εξαιρετική συνέπεια!",
    "sets": "Σετ",
    "reps": "Επαναλήψεις",
    "hold": "Κράτημα",
    "rest": "Ξεκούραση",
    "frequency": "Συχνότητα",
    "perWeek": "ανά εβδομάδα",
    "equipment": "Εξοπλισμός",
    "formCheckpoints": "Σημεία Ελέγχου",
    "contraindications": "Αντενδείξεις",
    "progressionCriteria": "Κριτήρια Προόδου",
    "prescribedDate": "Συνταγογραφήθηκε",
    "expiresDate": "Λήγει",
    "supersededBy": "Αντικαταστάθηκε από",
    "noExercises": "Δεν έχουν συνταγογραφηθεί ασκήσεις",
    "addFromLibrary": "Προσθήκη από Βιβλιοθήκη",
    "confirmRemove": "Αφαίρεση αυτής της άσκησης;",
    "progressTo": "Προχωρήστε στο επόμενο επίπεδο",
    "exerciseLibrary": "Βιβλιοθήκη Ασκήσεων",
    "filterByRegion": "Φιλτράρισμα ανά περιοχή",
    "filterByLevel": "Φιλτράρισμα ανά επίπεδο",
    "filterByCategory": "Φιλτράρισμα ανά κατηγορία",
    "addToPlan": "Προσθήκη στο Πρόγραμμα",
    "phase": "Φάση",
    "notes": "Σημειώσεις",
    "allLevels": "Όλα τα Επίπεδα",
    "allCategories": "Όλες οι Κατηγορίες",
    "allRegions": "Όλες οι Περιοχές",
    "xTimesPerWeek": "{{count}}x ανά εβδομάδα",
    "painScale": "Πόνος (0-10)",
    "streakDays": "μέρες σερί",
    "loggedToday": "Καταγράφηκε σήμερα",
    "noData": "Δεν υπάρχουν δεδομένα",
    "thisWeek": "αυτήν την εβδομάδα",
    "none": "Δεν έχουν συνταγογραφηθεί ασκήσεις ακόμα.",
    "doWithCamera": "Με Κάμερα",
    "markDone": "Ολοκληρώθηκε",
    "start": "Έναρξη",
    "cancel": "Ακύρωση",
    "finish": "Τέλος",
    "setDone": "Σετ Ολοκληρώθηκε",
    "nextSet": "Επόμενο σετ σε",
    "formScore": "Ποιότητα Εκτέλεσης",
    "allDone": "Ολοκληρώθηκαν Όλες!",
    "voice": {
      "begin": "Ξεκινήστε την άσκησή σας τώρα"
    },
    "feedback": {
      "great": "Εξαιρετική εκτέλεση!",
      "good": "Καλά, προσπαθήστε λίγο βαθύτερα",
      "watch": "Προσέξτε την εκτέλεση — εστιάστε στο πλήρες εύρος",
      "excellent": "Άριστα!"
    }
  },
  "funcMovement": {
    "accept": "Αποδοχή",
    "aiSummary": "Κλινική Σύνοψη AI",
    "analyzing": "Ανάλυση κίνησης...",
    "back": "Πίσω",
    "categoryBreakdown": "Ανάλυση Κατηγοριών",
    "generateReport": "Δημιουργία Αναφοράς",
    "overallScore": "Συνολική Βαθμολογία",
    "patientReady": "Ασθενής Έτοιμος",
    "quickScreen": "Γρήγορος Έλεγχος (~3 λεπ)",
    "readToPatient": "Διαβάστε στον ασθενή:",
    "recommendations": "Συστάσεις",
    "redo": "Ξανά",
    "result": "Αποτέλεσμα",
    "setupInstructions": "Τοποθετήστε τη συσκευή σε σταθερή επιφάνεια, 2 μέτρα από τον ασθενή",
    "skip": "Παράλειψη",
    "startTest": "Έναρξη Εξέτασης",
    "stopCapture": "Στοπ",
    "title": "Λειτουργική Αξιολόγηση Κίνησης"
  },
  "gamification": {
    "achievements": "Επιτεύγματα",
    "balance": "Ισορροπία",
    "best": "Καλύτερο",
    "bodyPerformance": "Βαθμολογία Σωματικής Απόδοσης",
    "change": "Αλλαγή",
    "completedExercises": "Ολοκληρωμένες ασκήσεις",
    "converted": "Εγγράφηκε",
    "copied": "Αντιγράφηκε! Μοιραστείτε με φίλους",
    "current": "Τρέχουσα",
    "dailyCheckIn": "Ημερήσιο Check-In",
    "dayStreak": "ημέρες σερί",
    "days": "ημέρες",
    "energyLevel": "Επίπεδο ενέργειας",
    "howDidYouMove": "Πώς κινηθήκατε σήμερα;",
    "initial": "Αρχική",
    "lifestyle": "Τρόπος Ζωής",
    "movement": "Κίνηση",
    "nextTier": "Επόμενο",
    "noAchievementsInCategory": "Χωρίς επιτεύγματα σε αυτή την κατηγορία",
    "noStreaks": "Ξεκινήστε το πρώτο σας σερί σήμερα!",
    "nowScore": "Τώρα",
    "pending": "Εκκρεμεί",
    "personalBest": "Νέο Ρεκόρ!",
    "progressSnapshot": "Η Πρόοδός Σας",
    "recovery": "Ανάρρωση",
    "referralMessage": "Σας συστήνω",
    "referralProgram": "Πρόγραμμα Παραπομπής",
    "referralUseCode": "Χρησιμοποιήστε τον κωδικό μου",
    "retry": "Ξαναπροσπαθήστε",
    "shareCode": "Αντιγραφή & Κοινοποίηση",
    "sleepQuality": "Ποιότητα ύπνου",
    "sortCategory": "Ταξινόμηση κατηγορίας",
    "sortRecent": "Ταξινόμηση πρόσφατα",
    "startScore": "Αρχή",
    "streaks": "Τα Σερί Σας",
    "strength": "Δύναμη",
    "stressLevel": "Επίπεδο στρες (1=χαμηλό, 5=υψηλό)",
    "submitCheckIn": "Υποβολή Check-In",
    "submitting": "Υποβολή...",
    "total": "Σύνολο",
    "visits": "επισκέψεις",
    "yourCode": "Ο κωδικός παραπομπής σας"
  },
  "lifestyle": {
    "activity": "Σωματική Δραστηριότητα",
    "alcohol": "Κατανάλωση αλκοόλ;",
    "answered": "απαντήθηκαν",
    "breaks": "Τακτικά διαλείμματα;",
    "diet": "Περιγράψτε τη διατροφή σας;",
    "ergonomics": "Εργασία & Εργονομία",
    "exerciseFreq": "Πόσο συχνά γυμνάζεστε;",
    "exerciseTypes": "Τι τύπο;",
    "habits": "Συνήθειες",
    "howActive": "Πόσο δραστήριος είστε;",
    "nutrition": "Διατροφή & Ενυδάτωση",
    "occupation": "Επίπεδο καθημερινής δραστηριότητας;",
    "quickMode": "← Γρήγορη λειτουργία",
    "quickTitle": "Γρήγορος Έλεγχος Τρόπου Ζωής",
    "saving": "Αποθήκευση...",
    "sitting": "Ώρες καθιστός/ή ημερησίως;",
    "sittingQ": "Ώρες καθιστός/ή;",
    "sleep": "Ύπνος",
    "sleepHours": "Ώρες ανά νύχτα;",
    "sleepQ": "Ποιότητα ύπνου;",
    "sleepQuality": "Ποιότητα ύπνου;",
    "smoking": "Καπνίζετε;",
    "stress": "Στρες",
    "stressLevel": "Επίπεδο στρες;",
    "stressQ": "Επίπεδο στρες;",
    "stressSources": "Κύριες πηγές;",
    "title": "Βαθμολογία Τρόπου Ζωής",
    "wantMore": "Θέλετε περισσότερες λεπτομέρειες; Αναπτύξτε πλήρη αξιολόγηση →",
    "water": "Ποτήρια νερού ημερησίως;"
  },
  "notifications": {
    "empty": "Χωρίς ειδοποιήσεις",
    "markAllRead": "Σήμανση όλων ως αναγνωσμένα",
    "title": "Ειδοποιήσεις"
  },
  "painMap": {
    "back": "Πίσω",
    "clearView": "Καθαρισμός",
    "front": "Μπροστά",
    "instruction": "Πατήστε στο σώμα για να σημειώσετε τοποθεσίες πόνου",
    "markers": "σημεία",
    "title": "Σημείωση Τοποθεσίας Πόνου",
    "undo": "Αναίρεση"
  },
  "planner": {
    "headers": {
      "phase": "Φάση",
      "frequency": "Συχνότητα",
      "duration": "Διάρκεια (εβδ.)",
      "action": "Ενέργεια"
    },
    "totalVisits": "Συνολικές επισκέψεις πριν τη συντήρηση: {{count}}"
  },
  "portal": {
    "achievements": "Τα Επιτεύγματά Σας",
    "balance": "Ισορροπία",
    "bodyPerformance": "Σωματική Απόδοσή Σας",
    "breakdown": "Ανάλυση Βαθμολογίας",
    "calmToStressed": "Ήρεμος → Στρεσαρισμένος",
    "checkedIn": "Check-in σήμερα!",
    "codeHint": "Ελέγξτε την αναφορά σας ή ρωτήστε τη ρεσεψιόν",
    "copied": "Αντιγράφηκε!",
    "copyShare": "Αντιγραφή & Κοινοποίηση",
    "dailyQuote": "Κάθε βήμα μπροστά σας κάνει πιο δυνατό.",
    "dayStreak": "ημέρες σερί",
    "didExercises": "Κάνατε τις ασκήσεις σας;",
    "doneToday": "σήμερα",
    "download": "Λήψη",
    "earned": "κερδίσατε",
    "energyLevel": "Επίπεδο ενέργειας;",
    "enterCode": "Εισάγετε τον κωδικό πρόσβασης",
    "estimatedNext": "Εκτιμώμενη επόμενη επίσκεψη",
    "exercises": "Ασκήσεις",
    "faq": "Συχνές Ερωτήσεις",
    "faqAfterPain": "Τι γίνεται αφού φύγει ο πόνος;",
    "faqAfterPainA": "Θα περάσετε στη Φροντίδα Ευεξίας — τακτικοί έλεγχοι που σας κρατούν στα καλύτερά σας.",
    "faqFreqActive": "Κατά τη Φροντίδα Ανακούφισης, συνιστούμε 2 επισκέψεις ανά εβδομάδα.",
    "faqFreqMaint": "Στην τρέχουσα φάση, μηνιαίοι έλεγχοι αρκούν.",
    "faqFrequency": "Πόσο συχνά πρέπει να έρχομαι;",
    "faqScoring": "Πώς λειτουργεί η βαθμολόγηση;",
    "faqScoringA": "Η Βαθμολογία Σωματικής Απόδοσης μετρά 5 τομείς: Κίνηση, Δύναμη, Ισορροπία, Ανάρρωση και Τρόπο Ζωής.",
    "faqWhenBetter": "Πότε θα νιώσω καλύτερα;",
    "faqWhenBetterA": "Οι περισσότεροι ασθενείς βελτιώνονται σε 2-4 εβδομάδες.",
    "firstVisit": "Πρώτη Επίσκεψη",
    "friendsJoined": "Φίλοι εγγράφηκαν",
    "health": "Υγεία",
    "howFeeling": "Πώς αισθάνεστε σήμερα;",
    "howMove": "Πώς κινηθήκατε σήμερα;",
    "invalidCode": "Μη έγκυρος κωδικός.",
    "journeyTimeline": "Η Πορεία Σας",
    "lifestyle": "Τρόπος Ζωής",
    "movement": "Κίνηση",
    "myExercises": "Οι Ασκήσεις Μου",
    "myReports": "Οι Αναφορές Μου",
    "needHelp": "Χρειάζεστε βοήθεια; Επικοινωνήστε με την κλινική",
    "networkError": "Σφάλμα σύνδεσης.",
    "next": "Επόμενο",
    "nextVisit": "Επόμενη επίσκεψη",
    "no": "Όχι",
    "noAchievementsYet": "Ολοκληρώστε check-ins για badges!",
    "noExercises": "Δεν υπάρχουν ασκήσεις ακόμα.",
    "noProgress": "Χρειάζεται να ολοκληρώσετε τουλάχιστον 2 αξιολογήσεις για να δείτε την πρόοδό σας.",
    "noReferral": "Ζητήστε κωδικό παραπομπής.",
    "noReports": "Δεν υπάρχουν αναφορές ακόμα.",
    "now": "Τώρα",
    "personalBest": "Νέο Ρεκόρ!",
    "personalizedTips": "Το Σχέδιο Βελτίωσής Σας",
    "pointsImproved": "βαθμοί βελτίωσης",
    "recovery": "Ανάρρωση",
    "refer": "Παραπομπή",
    "referralMsg": "Σας συστήνω",
    "reports": "Αναφορές",
    "seeFullProgress": "Δείτε πλήρη πρόοδο →",
    "shareWellness": "Μοιραστείτε το Ταξίδι Ευεξίας!",
    "sinceLast": "από τελευταία επίσκεψη",
    "sleepQuality": "Πώς κοιμηθήκατε;",
    "startStreak": "Ξεκινήστε σήμερα!",
    "strength": "Δύναμη",
    "stressLevel": "Επίπεδο στρες;",
    "totalShares": "Σύνολο κοινοποιήσεων",
    "treatmentGoals": "Οι Στόχοι Σας",
    "useCode": "Χρήση κωδικού",
    "verifying": "Επαλήθευση...",
    "viewAll": "Προβολή όλων →",
    "viewCarePlan": "Δείτε το σχέδιο φροντίδας →",
    "viewDashboard": "Πίνακας Ελέγχου",
    "welcome": "Καλωσήρθατε",
    "yes": "Ναι",
    "yourCarePlan": "Το Σχέδιο Φροντίδας Σας",
    "yourJourney": "Το Ταξίδι Υγείας Σας",
    "yourProgress": "Η Πρόοδός Σας",
    "yourReferralCode": "Ο κωδικός παραπομπής σας",
    "hiName": "Γεια σου {{name}}!",
    "stageRelief": "Φροντίδα Ανακούφισης",
    "stageRehab": "Αποκατάσταση",
    "stageWellness": "Φροντίδα Ευεξίας"
  },
  "portalAdmin": {
    "accessCode": "Κωδικός Πρόσβασης",
    "generate": "Δημιουργία Κωδικού",
    "generating": "Δημιουργία...",
    "noAccess": "Δεν υπάρχει πρόσβαση ακόμα",
    "patientPortal": "Πρόσβαση Πύλης Ασθενή"
  },
  "save": {
    "ago": "πριν",
    "justNow": "Μόλις τώρα",
    "saveDraft": "Αποθήκευση Πρόχειρου",
    "saveExit": "Αποθήκευση & Έξοδος",
    "saved": "Αποθηκεύτηκε",
    "saving": "Αποθήκευση...",
    "unsaved": "Μη αποθηκευμένες αλλαγές",
    "upToDate": "Ενημερωμένο"
  },
  "screening": {
    "alerts": "Κλινικές Ειδοποιήσεις Ελέγχου",
    "bpHeadache": "Συνιστάται μέτρηση πίεσης για κεφαλαλγία.",
    "bpRecommended": "Συνιστάται Μέτρηση Πίεσης",
    "cnHeadache": "Ασθενής με κεφαλαλγία. Συνιστάται αξιολόγηση κρανιακών νεύρων.",
    "cnNeuro": "Συνιστάται Νευρολογικός Έλεγχος",
    "cnNeuroReason": "Αυχενικό ενόχλημα με νευρολογικά συμπτώματα.",
    "cnRecommended": "Συνιστάται Εξέταση Κρανιακών Νεύρων",
    "save": "Αποθήκευση",
    "saveResults": "Αποθήκευση Αποτελεσμάτων",
    "vbiReason": "Αυχενικό ενόχλημα με ζάλη. Απαιτείται VBI πριν τον χειρισμό.",
    "vbiRequired": "Απαιτείται Έλεγχος Σπονδυλικής Αρτηρίας"
  },
  "softTissue": {
    "confirmWith": "Επιβεβαίωση με",
    "more": "περισσότεροι διαθέσιμοι",
    "noStructures": "Δεν φορτώθηκαν δομές για τις επιλεγμένες περιοχές.",
    "palpation": "Οδηγός Ψηλάφησης",
    "showLess": "← Εμφάνιση μόνο 3",
    "significance": "Κλινική Σημασία",
    "title": "Αξιολόγηση Μαλακών Ιστών",
    "top3": "Κορυφαίοι 3"
  },
  "uploads": {
    "addToFile": "הוסף לתיק הבריאות",
    "description": "Περιγραφή (προαιρετικό)",
    "logToday": "Καταγραφή Σήμερα",
    "myUploads": "Τα Αρχεία Μου",
    "trackBody": "Παρακολούθηση Σώματος",
    "upload": "Μεταφόρτωση",
    "uploading": "Μεταφόρτωση..."
  },
  "intake": {
    "loading": "Φόρτωση...",
    "oops": "Ωχ",
    "noToken": "Δεν δόθηκε κωδικός πρόσβασης.",
    "linkExpired": "Αυτός ο σύνδεσμος έχει λήξει. Επικοινωνήστε με την κλινική.",
    "invalidLink": "Μη έγκυρος σύνδεσμος. Επικοινωνήστε με την κλινική.",
    "somethingWrong": "Κάτι πήγε στραβά.",
    "unableToConnect": "Δεν είναι δυνατή η σύνδεση. Ελέγξτε τη σύνδεσή σας."
  },
  "onboarding": {
    "stepOf": "Βήμα {{current}} από {{total}}",
    "finishLater": "Θα τελειώσω αργότερα",
    "back": "Πίσω",
    "next": "Επόμενο",
    "completeSetup": "Ολοκλήρωση Ρύθμισης",
    "welcome": {
      "title": "Καλώς ήρθατε στο MSK Insight",
      "subtitle": "Ας ρυθμίσουμε την κλινική σας σε περίπου 5 λεπτά. Μπορείτε να αλλάξετε τα πάντα αργότερα στις Ρυθμίσεις.",
      "clinicTypePrompt": "Τι τύπος κλινικής είστε;",
      "getStarted": "Ξεκινήστε"
    },
    "clinicIdentity": {
      "title": "Ταυτότητα Κλινικής",
      "subtitle": "Βασικές πληροφορίες για την κλινική σας.",
      "clinicName": "Όνομα Κλινικής",
      "phone": "Τηλέφωνο",
      "email": "Email",
      "address": "Διεύθυνση",
      "whatsapp": "WhatsApp",
      "website": "Ιστοσελίδα",
      "placeholderName": "π.χ. Το Χειροπρακτικό Κέντρο",
      "placeholderPhone": "+357 25 344747",
      "placeholderEmail": "info@yourclinic.com",
      "placeholderAddress": "Λεωφόρος Μακαρίου 25, 3040 Λεμεσός, Κύπρος",
      "placeholderWhatsapp": "+357 99 123456",
      "placeholderWebsite": "https://yourclinic.com",
      "errorClinicName": "Το όνομα κλινικής είναι υποχρεωτικό",
      "errorPhone": "Ο αριθμός τηλεφώνου είναι υποχρεωτικός",
      "errorEmail": "Το email είναι υποχρεωτικό"
    },
    "team": {
      "title": "Η Ομάδα Σας",
      "subtitle": "Ποιοι εργάζονται στην κλινική σας; Μπορείτε να προσθέσετε μέλη αργότερα.",
      "lead": "Επικεφαλής",
      "fullName": "Πλήρες Όνομα",
      "roleTitle": "Ρόλος / Τίτλος",
      "credential": "Επαγγελματικό Πιστοποιητικό",
      "bio": "Σύντομο Βιογραφικό",
      "bioPlaceholder": "Σύντομο επαγγελματικό βιογραφικό (προαιρετικό)",
      "leadOwner": "Επικεφαλής / Ιδιοκτήτης Κλινικός",
      "add": "Προσθήκη",
      "save": "Αποθήκευση",
      "cancel": "Ακύρωση",
      "addTeamMember": "+ Προσθήκη Μέλους",
      "select": "-- Επιλέξτε --",
      "placeholderName": "π.χ. Μαρία Γεωργίου",
      "placeholderTitle": "π.χ. Επικεφαλής Χειροπράκτης"
    },
    "modalities": {
      "title": "Κλινικές Μέθοδοι",
      "subtitle": "Ποιες θεραπείες προσφέρει η κλινική σας; Οι προτάσεις AI θα περιοριστούν σε αυτές."
    },
    "assessmentTools": {
      "title": "Εργαλεία Αξιολόγησης",
      "subtitle": "Ποια διαγνωστικά εργαλεία χρησιμοποιείτε; Μπορείτε να παραλείψετε αυτό το βήμα."
    },
    "carePathway": {
      "title": "Πορεία Φροντίδας",
      "subtitle": "Πώς δομείτε τη φροντίδα των ασθενών; Συμπληρώνονται αυτόματα με βάση τον τύπο κλινικής."
    },
    "reportPreferences": {
      "title": "Προτιμήσεις Αναφορών",
      "subtitle": "Πώς θα πρέπει να εμφανίζονται οι αναφορές ασθενών και οι επιστολές GP;"
    },
    "integrations": {
      "title": "Ενσωματώσεις",
      "subtitle": "Συνδέστε τα υπάρχοντα εργαλεία σας. Μπορείτε να τα ρυθμίσετε αργότερα.",
      "practiceHub": "PracticeHub",
      "practiceHubDesc": "Συγχρονισμός ραντεβού και δεδομένων ασθενών",
      "emailSmtp": "Email (SMTP)",
      "emailSmtpDesc": "Αποστολή αναφορών και υπενθυμίσεων ασθενών",
      "aiAssistant": "AI Βοηθός",
      "aiAssistantDesc": "Αφηγήσεις αναφορών και κλινικές πληροφορίες με AI",
      "configureAfter": "Ρυθμίστε στις Ρυθμίσεις → Ενσωματώσεις μετά την εγκατάσταση.",
      "allOptional": "Όλες οι ενσωματώσεις είναι προαιρετικές και μπορούν να ρυθμιστούν οποιαδήποτε στιγμή."
    },
    "review": {
      "title": "Ελέγξτε τη Ρύθμιση",
      "subtitle": "Όλα φαίνονται καλά; Μπορείτε να αλλάξετε οτιδήποτε αργότερα στις Ρυθμίσεις.",
      "clinicIdentity": "Ταυτότητα Κλινικής",
      "yourTeam": "Η Ομάδα Σας",
      "clinicalModalities": "Κλινικές Μέθοδοι",
      "assessmentTools": "Εργαλεία Αξιολόγησης",
      "carePathway": "Πορεία Φροντίδας",
      "reportPreferences": "Προτιμήσεις Αναφορών",
      "clinicType": "Τύπος Κλινικής",
      "edit": "Επεξεργασία",
      "notConfigured": "Δεν έχει ρυθμιστεί ακόμα",
      "name": "Όνομα",
      "phone": "Τηλέφωνο",
      "email": "Email",
      "address": "Διεύθυνση",
      "languages": "Γλώσσες",
      "notSet": "Μη ορισμένο"
    },
    "completion": {
      "title": "Η κλινική σας είναι έτοιμη!",
      "subtitle": "Όλα ρυθμίστηκαν. Μπορείτε να αρχίσετε να δέχεστε ασθενείς αμέσως ή να προσαρμόσετε στις Ρυθμίσεις.",
      "addFirstPatient": "Προσθέστε τον Πρώτο Ασθενή",
      "exploreDashboard": "Εξερεύνηση Πίνακα",
      "customiseSettings": "Προσαρμογή Ρυθμίσεων",
      "redirecting": "Ανακατεύθυνση στον πίνακα σε {{seconds}} δευτερόλεπτα..."
    }
  },
  "session": {
    "warning": {
      "message": "Η σύνδεσή σας θα λήξει σε 5 λεπτά. Κάντε κλικ για να παραμείνετε συνδεδεμένοι.",
      "button": "Παραμείνετε συνδεδεμένοι"
    },
    "expired": {
      "toast": "Η σύνδεσή σας έληξε. Συνδεθείτε ξανά."
    }
  },
  "reportV2": {
    "rv2CoverTitle": "Το Προσωπικό Σας Πλάνο Ανάρρωσης & Απόδοσης",
    "rv2PreparedFor": "Εκπονήθηκε για **{patient_full_name}** · {report_date}",
    "rv2ToldLabel": "Τι μας είπατε",
    "rv2GoalsLabel": "Τι θέλετε να ανακτήσετε",
    "rv2WhatItMeansLabel": "Τι σημαίνει:",
    "rv2ContributingLabel": "Περιοχές που συμβάλλουν:",
    "rv2HowWeCanHelpLabel": "Πώς μπορούμε να βοηθήσουμε",
    "rv2AlsoCovered": "Καλύπτεται επίσης από το πλάνο σας",
    "rv2RecoveryDialTitle": "Η Βαθμολογία Ανάρρωσής Σας",
    "rv2ProgressHeading": "Η Πρόοδός Σας από την Τελευταία Επίσκεψη",
    "rv2ScheduleHeading": "Το πρόγραμμα θεραπείας σας",
    "rv2ScheduleFootnote": "Τα πρωτόκολλα θεραπείας ελέγχονται βάσει των πιο πρόσφατων κλινικών δεδομένων.",
    "rv2BookingDatesNote": "Οι πραγματικές ημερομηνίες των ραντεβού σας μπορεί να διαφέρουν ελαφρώς, ανάλογα με τη διαθεσιμότητα του προγράμματος.",
    "rv2Ongoing": "Συνεχιζόμενο",
    "rv2CarePlanHeading": "Το Εξατομικευμένο Σας Πλάνο Φροντίδας",
    "rv2HomeAdviceHeading": "Το Πλάνο Φροντίδας στο Σπίτι",
    "rv2ColDoNow": "Κάντε Τώρα",
    "rv2ColAvoid": "Τι να Αποφεύγετε",
    "rv2ColLifestyle": "Αλλαγές στον Τρόπο Ζωής",
    "rv2ColSupplement": "Συμπλήρωμα",
    "rv2ColDosage": "Δοσολογία",
    "rv2ColWhen": "Πότε να το Παίρνετε",
    "rv2ColWhatItDoes": "Τι Κάνει",
    "rv2AsDirected": "Σύμφωνα με τις οδηγίες",
    "rv2SupportsRecovery": "Υποστηρίζει την ανάρρωση και την ευεξία",
    "rv2Daily": "Καθημερινά",
    "rv2QrCaption": "Σαρώστε για online κράτηση",
    "rv2ContentsStory": "Η ιστορία σας",
    "rv2ContentsFound": "Τι βρήκαμε",
    "rv2ContentsCarePlan": "Το πλάνο φροντίδας σας",
    "rv2ContentsNext": "Επόμενα βήματα",
    "rv2Call": "Τηλέφωνο",
    "rv2Online": "Online",
    "rv2Page": "Σελίδα",
    "rv2PainRatingLabel": "η βαθμολογία πόνου σας",
    "rv2NotRecorded": "Δεν καταγράφηκε σε αυτή την επίσκεψη",
    "rv2OpeningHours": "Ώρες Λειτουργίας:",
    "rv2GoalsTarget": "Αυτός είναι ο κοινός μας στόχος και το πλάνο που ακολουθεί έχει σχεδιαστεί για να σας οδηγήσει εκεί.",
    "rv2HowWeCanHelpText": "φροντίδα που στοχεύει να ηρεμήσει τον ερεθισμένο ιστό, να αποκαταστήσει την κίνηση και τη δύναμη που τον προστατεύουν και να σας βοηθήσει να παραμείνετε καλά μακροπρόθεσμα.",
    "rv2GoldenIntro": "Αυτά είναι τα βασικά που καλό είναι να θυμάστε ανάμεσα στα ραντεβού σας. Ακολουθώντας αυτές τις οδηγίες θα έχετε τα καλύτερα δυνατά αποτελέσματα από τη θεραπεία σας.",
    "rv2ExerciseNote": "Όσες ασκήσεις εμφανίζονται ή συζητούνται είναι μόνο ενδεικτικές. Ο ειδικός αποκατάστασης θα σας ορίσει τις ασκήσεις που ταιριάζουν σε εσάς, στο κατάλληλο στάδιο της φροντίδας σας.",
    "rv2TroublingFor": "σας ταλαιπωρεί εδώ και",
    "rv2ByYourChiropractor": "Ο χειροπράκτης σας {name} ({credential})",
    "rv2WhyLabel": "Γιατί το κάνουμε αυτό",
    "rv2WhyText": "Στο The Chiropractic Center έχουμε χτίσει μια ομάδα με τεχνολογική υποστήριξη, με τους ανθρώπους στο επίκεντρο και με πολλές ειδικότητες, με μία δουλειά: να σας βοηθήσουμε και να σας ενδυναμώσουμε ώστε να πετύχετε τους στόχους σας. Ψάχνουμε την πραγματική αιτία, ξαναχτίζουμε αυτό που χρειάζεται το σώμα σας και σας επιστρέφουμε την ευθύνη για την υγεία σας. Και όταν είστε έτοιμοι για κάτι περισσότερο από την ανάρρωση, η φροντίδα και η ευεξία για μια ζωή σας περιμένουν. Πάντα δική σας επιλογή, πάντα με τον δικό σας ρυθμό.",
    "rv2JourneyCaption": "ηρεμία · ανοικοδόμηση · διατήρηση για μια ζωή",
    "rv2JourneyChoice": "Το τρίτο στάδιο είναι μια πρόσκληση. Πάντα δική σας επιλογή.",
    "rv2WhatItMeansFallback": "Οι δομές σε αυτή την περιοχή είναι ερεθισμένες και δεν έχουν επαρκή υποστήριξη, κάτι που μπορεί να αντιμετωπιστεί με ένα στοχευμένο, σταδιακό πλάνο",
    "rv2PageOf": "από"
  },
  "versionNudge": {
    "message": "Διατίθεται νέα έκδοση",
    "reload": "Επαναφόρτωση",
    "later": "Αργότερα"
  },
  "autosave": {
    "finalizedNothingToSave": "Η αξιολόγηση έχει οριστικοποιηθεί. Δεν υπάρχει κάτι άλλο προς αποθήκευση.",
    "finalizedShort": "Οριστικοποιήθηκε"
  },
  "reportGenerator": {
    "emailNotEnabled": "Η αποστολή email δεν έχει ενεργοποιηθεί ακόμη για αυτή την κλινική. Ζητήστε από τον διαχειριστή να τη ρυθμίσει.",
    "emailNeedsFinalize": "Οριστικοποιήστε την αξιολόγηση πριν στείλετε την αναφορά στον ασθενή με email."
  },
  "amend": {
    "inProgressTitle": "Τροποποίηση σε εξέλιξη",
    "inProgressBody": "Η έκδοση {{version}} παραμένει ενεργή και αμετάβλητη μέχρι να πατήσετε Ολοκλήρωση, που δημοσιεύει την έκδοση {{next}}.",
    "button": "Τροποποίηση αναφοράς",
    "reopening": "Άνοιγμα ξανά...",
    "buttonHint": "Ανοίξτε ξανά αυτή την εκδοθείσα αναφορά για να δημοσιεύσετε διορθωμένη έκδοση",
    "currentVersion": "Τρέχουσα έκδοση: {{version}}",
    "failed": "Δεν ήταν δυνατό το άνοιγμα της αναφοράς για τροποποίηση."
  },
  "pushStatus": {
    "delivered": "Στάλθηκε στο PracticeHub v{{version}}",
    "retrying": "PracticeHub: νέα προσπάθεια στις {{time}}",
    "failed": "PracticeHub: δεν στάλθηκε μετά από {{attempts}} προσπάθειες",
    "pushNow": "Αποστολή τώρα",
    "pushing": "Αποστολή…"
  },
  "lifecycle": {
    "draft": "Πρόχειρο",
    "confirmedNotIssued": "Επιβεβαιωμένο — μη εκδοθέν",
    "amending": "Τροποποίηση σε εξέλιξη",
    "issued": "Εκδόθηκε v{{version}}"
  },
  "sprint6": {
    "journeyWeekByWeek": "Ανά εβδομάδα",
    "journeyWeekLabel": "Εβδομάδα {{n}}",
    "journeyAnd": "και",
    "journeyOr": "ή",
    "journeyWith": "με",
    "journeyGapWeek": "καμία επίσκεψη αυτή την εβδομάδα",
    "journeyChoiceNote": "Όταν εμφανίζονται δύο ονόματα, θα επιβεβαιώσουμε ποιο από τα δύο άτομα θα δείτε όταν κλειστεί η επίσκεψη.",
    "journeyThenMaintenance": "έπειτα Wellness Care κάθε 6 εβδομάδες",
    "journeyPractitionerColumn": "Ειδικός"
  },
  "letterMachine": {
    "title": "Δημιουργία επιστολής",
    "letterType": "Τύπος επιστολής",
    "typeReferral": "Παραπομπή",
    "typeProgress": "Πορεία",
    "typeInsurance": "Προς ασφαλιστική",
    "recipient": "Παραλήπτης",
    "recipientHintReferral": "π.χ. «Δρ Jane Smith»",
    "recipientHintProgress": "π.χ. «Δρ Jane Smith» (ή αφήστε κενό για το αρχείο του ασθενούς)",
    "recipientHintInsurance": "π.χ. επωνυμία ασφαλιστικής ή αφήστε κενό για «Προς κάθε ενδιαφερόμενο»",
    "policyRef": "Αρ. συμβολαίου / απαίτησης (προαιρετικά)",
    "generate": "Δημιουργία",
    "regenerate": "Εκ νέου δημιουργία",
    "generating": "Δημιουργία…",
    "editableDraft": "Επεξεργάσιμο προσχέδιο",
    "editsNote": "Οι αλλαγές εδώ εφαρμόζονται κατά την αντιγραφή, λήψη, αποστολή στο PracticeHub και αποστολή με email.",
    "copy": "Αντιγραφή",
    "copied": "Η επιστολή αντιγράφηκε στο πρόχειρο",
    "copyFailed": "Η αντιγραφή απέτυχε — επιλέξτε και αντιγράψτε χειροκίνητα",
    "downloadPdf": "Λήψη PDF",
    "rendering": "Προετοιμασία…",
    "pushToPracticeHub": "Αποστολή στο PracticeHub",
    "pushing": "Αποστολή…",
    "emailToPatient": "Αποστολή email στον ασθενή",
    "sending": "Αποστολή…",
    "englishOnly": "Οι επιστολές συντάσσονται στα Αγγλικά.",
    "requests": "Αιτήματα",
    "requestsIntro": "Επιλέξτε τι ζητάτε. Οι προτεινόμενες γραμμές προκύπτουν από σημεία συναγερμού και την υπόθεση εργασίας· αποεπιλέξτε ό,τι δεν επιθυμείτε.",
    "addRequest": "Προσθήκη αιτήματος",
    "noRequests": "Δεν επιλέχθηκε τίποτα: η επιστολή θα περιλαμβάνει μόνο κλινική ενημέρωση.",
    "loadingSuggestions": "Φόρτωση προτάσεων…",
    "kind": "Είδος",
    "kindImaging": "Απεικόνιση",
    "kindOpinion": "Γνώμη ειδικού",
    "kindEmergency": "Επείγουσα διαδικασία",
    "kindUpdateOnly": "Μόνο κλινική ενημέρωση",
    "modality": "Απεικονιστική μέθοδος",
    "specialty": "Ειδικότητα",
    "region": "Περιοχή",
    "purpose": "Σκοπός",
    "purposeCustom": "Άλλος σκοπός (πληκτρολογήστε)",
    "urgency": "Βαθμός επείγοντος",
    "urgencyRoutine": "Τακτικό",
    "urgencySoon": "Σύντομα",
    "urgencyUrgent": "Επείγον",
    "urgencyEmergency": "Άμεσο",
    "suggested": "Προτεινόμενο",
    "fromRedFlag": "από σημείο συναγερμού",
    "fromHypothesis": "από την υπόθεση εργασίας",
    "remove": "Αφαίρεση",
    "moveUp": "Μετακίνηση πάνω",
    "moveDown": "Μετακίνηση κάτω",
    "regionNone": "Καμία περιοχή"
  },
  "phV3": {
    "title": "PracticeHub v3 (νέο API)",
    "intro": "Για τη μετάβαση στο νέο API του PracticeHub. Δεν χρησιμοποιείται ακόμη: κάθε πόρος παρακάτω μένει στην παλιά σύνδεση μέχρι τον έλεγχο του Οκτωβρίου.",
    "keyLabel": "Κλειδί API v3 (ξεκινά με phk_)",
    "keyPlaceholder": "phk_…",
    "fingerprint": "Αποτύπωμα κλειδιού: {{fp}} — αφήστε το κενό για να διατηρηθεί",
    "save": "Αποθήκευση κλειδιού v3",
    "saving": "Αποθήκευση…",
    "saved": "Το κλειδί PracticeHub v3 αποθηκεύτηκε.",
    "accepted": "Αποθηκεύτηκε — το PracticeHub v3 δέχτηκε το κλειδί.",
    "readOnlyWarn": "Αυτό το κλειδί μπορεί να γράφει. Δημιουργήστε κλειδί μόνο ανάγνωσης για το MSK Insight και αποθηκεύστε εκείνο.",
    "tzWarn": "Η ζώνη ώρας του λογαριασμού είναι {{tz}}. Το MSK Insight διαβάζει τις ώρες της κλινικής ως Europe/Nicosia, οπότε οι αναγνώσεις ραντεβού μέσω v3 θα απορρίπτονται μέχρι να διευθετηθεί.",
    "refused": "Αποθηκεύτηκε, αλλά το PracticeHub το απέρριψε. Βεβαιωθείτε ότι αντιγράψατε ολόκληρο το κλειδί.",
    "rateLimited": "Αποθηκεύτηκε, αλλά το PracticeHub περιορίζει τα αιτήματα αυτή τη στιγμή. Θα ελεγχθεί ξανά στην επόμενη αποθήκευση.",
    "untested": "Αποθηκεύτηκε, αλλά δεν ήταν δυνατή η σύνδεση με το PracticeHub για έλεγχο.",
    "isLegacy": "Αυτό είναι παλιό κλειδί API του PracticeHub. Ανήκει στο πεδίο του παλιού κλειδιού παραπάνω· αυτό το πεδίο δέχεται μόνο κλειδιά του νέου API που ξεκινούν με phk_. Δεν αποθηκεύτηκε τίποτα.",
    "invalidShape": "Αυτό δεν είναι κλειδί API v3 του PracticeHub. Αντιγράψτε το ξανά από PracticeHub → Developers → API Keys. Δεν αποθηκεύτηκε τίποτα.",
    "notConfigured": "Αποθηκεύστε ένα κλειδί PracticeHub v3 πριν μεταφέρετε έναν πόρο στο v3.",
    "writeKeyLabel": "Κλειδί εγγραφής v3 (ξεκινά με phk_)",
    "writeKeyHint": "Δεύτερο κλειδί, με δικαίωμα εγγραφής, που χρησιμοποιείται ΜΟΝΟ για την αποστολή αναφορών. Οι αναγνώσεις και οι συγχρονισμοί δεν το χρησιμοποιούν ποτέ. Δημιουργήστε το στο PracticeHub → Developers → API Keys με Access level: Read and write.",
    "writeSave": "Αποθήκευση κλειδιού εγγραφής v3",
    "writeSaved": "Το κλειδί εγγραφής PracticeHub v3 αποθηκεύτηκε.",
    "writeAccepted": "Αποθηκεύτηκε — το PracticeHub v3 δέχτηκε το κλειδί και μπορεί να γράφει.",
    "writeNoScope": "Αποθηκεύτηκε, αλλά αυτό το κλειδί δεν μπορεί να γράφει. Δημιουργήστε κλειδί με Access level: Read and write για την αποστολή αναφορών.",
    "writeUntested": "Αποθηκεύτηκε, αλλά δεν ήταν δυνατή η σύνδεση με το PracticeHub για έλεγχο.",
    "patientsNeedsMrn": "Ο διακόπτης ασθενών παραμένει κλειστός μέχρι το PracticeHub να επιβεβαιώσει ποιο πεδίο του v3 περιέχει τον αριθμό ασθενή (MRN). Μέχρι τότε οι ασθενείς συγχρονίζονται μέσω της παλιάς σύνδεσης και κάθε υπάρχον MRN διατηρείται.",
    "patientsCheckFirst": "Η ενεργοποίηση των ασθενών ελέγχει πρώτα 20 ασθενείς ζωντανά: ο καθένας πρέπει να έχει τον αριθμό ασθενή (MRN) στο v3, ίδιο με τον αριθμό της παλιάς σύνδεσης.",
    "waitingForMigration": "Αναμονή για τη μετάπτωση του PracticeHub: {{populated}} από {{checked}} ασθενείς που ελέγχθηκαν έχουν αριθμό ασθενή στο v3 και {{equal}} ταιριάζουν με τον αριθμό της παλιάς σύνδεσης. Ο διακόπτης ασθενών παραμένει κλειστός και κάθε υπάρχον MRN διατηρείται.",
    "mrnCheckFailed": "Ο έλεγχος αριθμών ασθενών δεν μπόρεσε να επικοινωνήσει με το PracticeHub, οπότε ο διακόπτης ασθενών παραμένει κλειστός. Δοκιμάστε ξανά σε λίγα λεπτά.",
    "saveFailed": "Δεν ήταν δυνατή η αποθήκευση των ρυθμίσεων PracticeHub v3.",
    "switchesTitle": "Ανάγνωση από το v3, ανά πόρο",
    "switchesHint": "Όλα ανενεργά μέχρι τον ζωντανό έλεγχο του Οκτωβρίου. Ένας ανενεργός πόρος διαβάζεται από το παλιό API, όπως σήμερα.",
    "resource": {
      "patients": "Ασθενείς",
      "appointments": "Ραντεβού",
      "practitioners": "Θεραπευτές",
      "files": "Αρχεία",
      "clinical_notes": "Κλινικές σημειώσεις"
    },
    "saveSwitches": "Αποθήκευση διακοπτών",
    "switchesSaved": "Οι διακόπτες αποθηκεύτηκαν.",
    "pushesLabel": "Αποστολή αναφορών στο PracticeHub μέσω v3",
    "pushesHint": "Ανενεργό: οι αναφορές πηγαίνουν μέσω της παλαιάς σύνδεσης, όπως σήμερα. Ενεργό: η σημείωση και τα PDF πηγαίνουν μέσω v3 με το κλειδί εγγραφής, το καθένα με τη δική μας αναφορά, ώστε μια χαμένη απάντηση να εντοπίζεται ξανά αντί να σταλεί δύο φορές.",
    "pushesOn": "Οι αναφορές πηγαίνουν πλέον στο PracticeHub μέσω v3.",
    "pushesOff": "Οι αναφορές πηγαίνουν πλέον στο PracticeHub μέσω της παλαιάς σύνδεσης.",
    "pushesNeedWriteKey": "Αποθηκεύστε πρώτα ένα κλειδί εγγραφής v3."
  },
  "quickReportDetour": {
    "question": "Θέλετε να προσθέσετε σάρωση στάσης σώματος ή απεικόνιση πριν συνεχίσετε;",
    "hint": "Μπορείτε να προσθέσετε τώρα μια αναφορά PostureScreen ή απεικόνιση· μετά θα επιστρέψετε στη διάγνωση.",
    "addPosture": "Προσθήκη σάρωσης στάσης",
    "addImaging": "Προσθήκη απεικόνισης",
    "no": "Όχι, συνέχεια",
    "bannerText": "Όταν προσθέσετε ό,τι χρειάζεστε, συνεχίστε στη διάγνωση.",
    "returnButton": "Συνέχεια στη διάγνωση"
  },
  "phFiles": {
    "title_one": "{{count}} αρχείο στο PracticeHub",
    "title_other": "{{count}} αρχεία στο PracticeHub",
    "none": "Δεν υπάρχουν αρχεία για αυτόν τον ασθενή στο PracticeHub.",
    "unnamed": "(χωρίς όνομα αρχείου)",
    "listOnly": "Λίστα από το PracticeHub· ανοίξτε τα στο PracticeHub.",
    "rateLimited": "Τα αρχεία του PracticeHub δεν είναι διαθέσιμα προσωρινά. Θα εμφανιστούν ξανά σύντομα."
  },
  "imagingStudy": {
    "title": "Απεικονιστική μελέτη",
    "imagesCount_one": "{{count}} εικόνα",
    "imagesCount_other": "{{count}} εικόνες",
    "status_uploaded": "Δεν έχει αναλυθεί",
    "status_analysed": "Η σύνοψη περιμένει έλεγχο",
    "status_accepted": "Η σύνοψη έγινε αποδεκτή",
    "analyse": "Ανάλυση και των {{count}} εικόνων μαζί",
    "analysing": "Ανάλυση της μελέτης…",
    "accept": "Αποδοχή σύνοψης",
    "reviewLines": "Έλεγχος γραμμών",
    "hideLines": "Απόκρυψη ελέγχου γραμμών",
    "edit": "Επεξεργασία",
    "save": "Αποθήκευση",
    "cancel": "Ακύρωση",
    "reject": "Απόρριψη",
    "rejected": "απορρίφθηκε",
    "edited": "επεξεργάστηκε",
    "series": "Σειρές",
    "findings": "Ευρήματα",
    "measurements": "Μετρήσεις",
    "impressions": "Συμπεράσματα",
    "pendingNote": "Παρατήρηση με τη βοήθεια ΤΝ. Τίποτα από εδώ δεν περνά στη διάγνωση ή στην αναφορά μέχρι να αποδεχτείτε τη σύνοψη.",
    "acceptedNote": "Παρατήρηση με τη βοήθεια ΤΝ, η σύνοψη έγινε αποδεκτή από τον κλινικό. Οι αποδεκτές και οι διορθωμένες γραμμές τροφοδοτούν τη διάγνωση και την ενότητα εξετάσεων της αναφοράς.",
    "excluded_one": "{{count}} αρχείο δεν μπόρεσε να διαβαστεί από την ΤΝ (αναλύονται μόνο εικόνες JPEG, PNG ή WebP).",
    "excluded_other": "{{count}} αρχεία δεν μπόρεσαν να διαβαστούν από την ΤΝ (αναλύονται μόνο εικόνες JPEG, PNG ή WebP).",
    "groupUnassigned": "Ανάλυση των {{count}} προηγούμενων εικόνων μαζί ως μία μελέτη",
    "regionMatch": "Η περιοχή της απεικόνισης συμφωνεί με την περιοχή του ενοχλήματος.",
    "regionMismatch": "Οι εικόνες δείχνουν {{imaging}}, αλλά η περιοχή του ενοχλήματος είναι {{complaint}}. Ελέγξτε ότι οι εικόνες αφορούν αυτό το ενόχλημα πριν την αποδοχή.",
    "regionUnknown": "Η περιοχή της απεικόνισης δεν μπόρεσε να διαβαστεί από τις εικόνες· ελέγξτε την εσείς σε σχέση με την περιοχή του ενοχλήματος.",
    "regionNoComplaint": "Αυτή η αξιολόγηση δεν έχει περιοχή ενοχλήματος για σύγκριση με την απεικόνιση.",
    "failed": "Δεν ολοκληρώθηκε: {{message}}",
    "region": {
      "cervical": "αυχενική μοίρα",
      "thoracic": "θωρακική μοίρα",
      "lumbar": "οσφυϊκή μοίρα",
      "sacral": "ιερό οστό/λεκάνη",
      "shoulder": "ώμος",
      "elbow": "αγκώνας",
      "wrist_hand": "καρπός/χέρι",
      "hip": "ισχίο",
      "knee": "γόνατο",
      "ankle_foot": "ποδοκνημική/πόδι",
      "tmj": "γνάθος (ΚΓΔ)"
    },
    "reportAttached": "+ έκθεση ακτινολόγου",
    "radiologistReport": "Έκθεση ακτινολόγου (αυτούσια)",
    "radFindings": "Ευρήματα ακτινολόγου",
    "radImpression": "Γνωμάτευση ακτινολόγου",
    "aiObservations": "Παρατηρήσεις ΤΝ στις εικόνες",
    "disagreeBanner": "Οι παρατηρήσεις της ΤΝ διαφωνούν με την έκθεση του ακτινολόγου:",
    "radSays": "ακτινολόγος",
    "aiSays": "ΤΝ",
    "agreeNote": "Οι παρατηρήσεις της ΤΝ συμφωνούν με την έκθεση του ακτινολόγου.",
    "compareUnavailable": "Δεν ήταν δυνατή η σύγκριση της έκθεσης του ακτινολόγου με τις παρατηρήσεις της ΤΝ: {{note}}",
    "aiUnavailable": "Οι παρατηρήσεις ΤΝ στις εικόνες δεν είναι διαθέσιμες ({{note}}). Προηγείται μόνη της η έκθεση του ακτινολόγου.",
    "reportUnrecognised": "Ανέβηκε PDF μαζί με τις εικόνες, αλλά δεν βρέθηκε ενότητα Ευρημάτων ή Γνωμάτευσης. Διαβάστε την ίδια την έκθεση."
  },
  "postureCapture": {
    "title": "Καταγραφή στάσης σώματος",
    "steps": "Βήματα καταγραφής στάσης",
    "step": {
      "setup": "Συνεδρία",
      "photos": "Φωτογραφίες",
      "wall": "Μετρήσεις τοίχου",
      "mark": "Σημειώστε τις κουκκίδες",
      "summary": "Σύνοψη"
    },
    "script": "Σταθείτε όπως στέκεστε συνήθως. Μην στέκεστε ίσια για την κάμερα. Κοιτάξτε ευθεία μπροστά.",
    "kind": {
      "label": "Είδος συνεδρίας",
      "normal": "Κανονική",
      "stand_tall": "Όρθια στάση",
      "repeat_test": "Επανάληψη ελέγχου"
    },
    "week": {
      "label": "Εβδομάδα",
      "none": "Χωρίς εβδομάδα",
      "w0": "Εβδομάδα 0",
      "w6": "Εβδομάδα 6",
      "w12": "Εβδομάδα 12"
    },
    "settings": {
      "cameraDistanceCm": "Απόσταση κάμερας (cm)",
      "lensHeightCm": "Ύψος φακού (cm)",
      "floorMark": "Χρήση σημαδιού δαπέδου",
      "defaultsHint": "Οι προεπιλογές είναι η τυπική ρύθμιση της κλινικής. Αλλάξτε τις μόνο αν η κάμερα τοποθετήθηκε διαφορετικά σήμερα."
    },
    "createSession": "Δημιουργία συνεδρίας",
    "creating": "Δημιουργία συνεδρίας...",
    "sessionCreated": "Η συνεδρία δημιουργήθηκε",
    "view": {
      "front": "Μπροστά",
      "back": "Πίσω",
      "left": "Αριστερή πλευρά",
      "right": "Δεξιά πλευρά"
    },
    "photos": {
      "hint": "Έως {{max}} φωτογραφίες ανά όψη, JPEG ή PNG. Κάθε φωτογραφία ανεβαίνει μόλις επιλεγεί.",
      "takePhoto": "Λήψη φωτογραφίας",
      "chooseFile": "Επιλογή αρχείου",
      "limit": "Η όψη αυτή έχει ήδη {{max}} φωτογραφίες.",
      "uploading": "Ανέβασμα...",
      "uploaded": "Ανέβηκε",
      "failed": "Το ανέβασμα απορρίφθηκε",
      "refusedType": "Γίνονται δεκτές μόνο φωτογραφίες JPEG ή PNG.",
      "refusedSize": "Η φωτογραφία είναι μεγαλύτερη από 15 MB.",
      "empty": "Καμία φωτογραφία ακόμη",
      "thumbAlt": "Φωτογραφία {{view}} {{index}}"
    },
    "wall": {
      "title": "Μετρήσεις κεφαλής-τοίχου",
      "hint": "Τρεις μετρήσεις σε εκατοστά, με το άτομο να στέκεται με την πλάτη στον τοίχο.",
      "reading": "Μέτρηση {{n}} (cm)",
      "save": "Αποθήκευση μετρήσεων",
      "saved": "Οι μετρήσεις αποθηκεύτηκαν",
      "invalid": "Εισαγάγετε τρεις αριθμούς από μηδέν εκατοστά και πάνω."
    },
    "mark": {
      "next": "Σημειώστε",
      "complete": "Όλες οι κουκκίδες τοποθετήθηκαν",
      "undo": "Αναίρεση τελευταίας κουκκίδας",
      "redo": "Επανάληψη αυτής της όψης",
      "save": "Αποθήκευση κουκκίδων",
      "saved": "Οι κουκκίδες αποθηκεύτηκαν",
      "earlierHidden": "Οι αριθμοί προηγούμενων συνεδριών δεν εμφανίζονται κατά τη σήμανση.",
      "noCaptures": "Δεν υπάρχουν φωτογραφίες ακόμη. Προσθέστε πρώτα φωτογραφίες.",
      "loadingImage": "Φόρτωση της φωτογραφίας...",
      "imageAlt": "Φωτογραφία {{view}} {{index}}, πατήστε για να τοποθετήσετε κουκκίδα"
    },
    "landmark": {
      "tragus": "Σημείο αυτιού (τράγος)",
      "c7": "Βάση του αυχένα (Α7)",
      "leftEar": "Αριστερό αυτί",
      "rightEar": "Δεξί αυτί",
      "leftShoulder": "Αριστερός ώμος",
      "rightShoulder": "Δεξιός ώμος"
    },
    "summary": {
      "title": "Σύνοψη καταγραφής",
      "noVerdict": "Μόνο γωνίες και έλεγχος λήψης. Χωρίς βαθμολογία, αποτέλεσμα ή αναφορά σε αυτή την οθόνη.",
      "noneMarked": "Δεν αποθηκεύτηκαν κουκκίδες για αυτή την όψη.",
      "neckAngle": "Γωνία αυχένα",
      "shoulderLine": "Κλίση γραμμής ώμων",
      "headLine": "Κλίση γραμμής κεφαλής",
      "mean": "Μέσος όρος",
      "spread": "εύρος",
      "needsRemark": "Χρειάζεται νέα σήμανση: οι φωτογραφίες διαφωνούν",
      "agree": "Οι φωτογραφίες συμφωνούν",
      "settings": "Έλεγχος ρύθμισης λήψης",
      "settingsOk": "Η ρύθμιση είναι εντός των τυπικών ανοχών.",
      "nominal": "τυπικό",
      "remark": "Νέα σήμανση των κουκκίδων"
    },
    "next": "Επόμενο",
    "error": {
      "generic": "Ο διακομιστής απέρριψε το αίτημα."
    }
  }
}
